import countries from 'i18n-iso-countries';
import momentTZ from 'moment-timezone';

// have to do this to get country names in english
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

export const announcementMessageTypes = [
  'ALERT',
  'PROMOTION',
];

export const autoTranslationLanguages = [
  { label: 'Arabic', value: 'ar' },
  { label: 'Catalan', value: 'ca' },
  { label: 'Chinese (Simplified)', value: 'zh-Hans' },
  { label: 'Chinese (Traditional)', value: 'zh-Hant' },
  { label: 'Croatian', value: 'hr' },
  { label: 'Czech', value: 'cs' },
  { label: 'Danish', value: 'da' },
  { label: 'Dutch', value: 'nl' },
  { label: 'English (GB)', value: 'en-GB' },
  { label: 'Finnish', value: 'fi' },
  { label: 'French', value: 'fr' },
  { label: 'French (Canada)', value: 'fr-CA' },
  { label: 'German', value: 'de' },
  { label: 'Greek', value: 'el' },
  { label: 'Hebrew', value: 'he' },
  { label: 'Hindi', value: 'hi' },
  { label: 'Hungarian', value: 'hu' },
  { label: 'Indonesian', value: 'id' },
  { label: 'Italian', value: 'it' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Korean', value: 'ko' },
  { label: 'Malay', value: 'ms-MY' },
  { label: 'Norwegian Bokmal', value: 'nb' },
  { label: 'Polish', value: 'pl' },
  { label: 'Portuguese (Brazil)', value: 'pt-BR' },
  { label: 'Portuguese (Portugal)', value: 'pt-PT' },
  { label: 'Pseudo', value: 'en-XA' },
  { label: 'Pseudo (BiDi)', value: 'ar-XB' },
  { label: 'Russian', value: 'ru' },
  { label: 'Slovak', value: 'sk' },
  { label: 'Slovenian', value: 'sl' },
  { label: 'Spanish (Argentina)', value: 'es-AR' },
  { label: 'Spanish (Latin America)', value: 'es-419' },
  { label: 'Spanish (Spain)', value: 'es-ES' },
  { label: 'Spanish (Mexico)', value: 'es-MX' },
  { label: 'Swedish', value: 'sv' },
  { label: 'Thai', value: 'th' },
  { label: 'Turkish', value: 'tr' },
  { label: 'Vietnamese', value: 'vi' },
];

export const brandValues = ['NIKE', 'CONVERSE', 'FOOTLOCKER'];

export const businessConceptValues = [
  'BEACON', 'BRAND_POP_UP',
  'CLEARANCE', 'COMMUNITY',
  'EMPLOYEE_STORE',
  'FACTORY',
  'KICKS_LOUNGE',
];

export const conceptCodeValues = [
  'Beacon', 'Brand Pop Up',
  'Clearance', 'Community',
  'Employee Store',
  'Factory',
  'INLINE',
  'Kicks Lounge',
  'NikeLab', 'NikeTown',
  'POP UP',
  'Running',
  'Traditional',
  'Womens',
];

export const concepts = [
  { label: 'AIRPORT', value: 'AIRPORT' },
  { label: 'BEACON_STORE', value: 'BEACON' },
  { label: 'CLEARANCE_STORES', value: 'CLEARANCE' },
  { label: 'COMMUNITY_STORE', value: 'COMMUNITY' },
  { label: 'DISTRIBUTION_CENTER', value: 'DC' },
  { label: 'EMPLOYEE_STORE', value: 'EMPLOYEE' },
  { label: 'GOLF_ONLY_STORE', value: 'GOLF' },
  { label: 'NIKE_RUNNING', value: 'RUNNING' },
  { label: 'NIKE_TOWN', value: 'NIKETOWN' },
  { label: 'NIKELAB', value: 'NIKELAB' },
  { label: 'ONLINE_STORE', value: 'COM' },
  { label: 'POP_UP_STORE', value: 'POP_UP' },
  { label: 'SATELLITE_DISTRIBUTION_CENTER', value: 'SDC' },
  { label: 'TRADITIONAL_STORE', value: 'TRADITIONAL' },
  { label: 'WOMENS_ONLY', value: 'WOMENS' },
];

export const countryValues = countries.getAlpha3Codes();

export const countryOptions = Object.keys(countryValues).map((code) => ({
  // TODO: remove Türkiye hardcoding when dependent module releases a version with the new name
  label: code === 'TUR' ? 'Türkiye' : countries.getName(code, 'en'),
  value: code,
}));

export const cmpCountries = ['USA', 'PRI'];

export const currencyCodeValues = [
  'AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN',
  'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BRL', 'BSD', 'BTN', 'BWP', 'BYR', 'BZD',
  'CAD', 'CDF', 'CHF', 'CLP', 'CNY', 'COP', 'CRC', 'CSD', 'CUP', 'CVE', 'CZK',
  'DJK', 'DKK', 'DOP', 'DZD',
  'EGP', 'ERN', 'ETB', 'EUR',
  'FJD', 'FKP', 'FOK',
  'GBP', 'GEL', 'GHC', 'GIP', 'GMD', 'GNF', 'GTQ', 'GWP', 'GYD',
  'HKD', 'HNL', 'HRK', 'HTG', 'HUF',
  'IDR', 'IEP', 'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'ITL',
  'JMD', 'JOD', 'JPY',
  'KES', 'KGS', 'KHR', 'KMF', 'KPW', 'KRW', 'KWD', 'KYD', 'KZT',
  'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LYD',
  'MAD', 'MDL', 'MGF', 'MKD', 'MMK', 'MNT', 'MOP', 'MRO', 'MTL', 'MUR', 'MVR', 'MWK', 'MXN', 'MYR', 'MZM',
  'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD',
  'OMR',
  'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN', 'PYG',
  'QAR',
  'ROL', 'RON', 'RSD', 'RUB', 'RUR', 'RWF',
  'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SHP', 'SKK', 'SLL', 'SOS', 'SRG', 'SSP', 'STD', 'SVC', 'SYP', 'SZL',
  'THB', 'TJS', 'TMM', 'TMT', 'TND', 'TOP', 'TRY', 'TTD', 'TWD', 'TZS',
  'UAH', 'UGX', 'USD', 'USN', 'USS', 'UYU', 'UZS',
  'VEF', 'VND', 'VUV',
  'WST',
  'XAF', 'XCD', 'XOF', 'XPF',
  'YER',
  'ZAR', 'ZMW', 'ZWD',
];

export const defaultNFSImageUrl = 'https://static.nike.com/a/images/f_auto/d2f5c06a-629d-4f20-a092-9e56315a80b3/image.jpeg';

export const defaultNSPImageUrl = 'https://static.nike.com/a/images/f_auto/2e8d9338-b43d-4ef5-96e1-7fdcfd838f8e/image.jpg';

export const defaultOfferingImageUrl = 'https://static.nike.com/a/images/f_auto/7cb8e7f1-ec92-4827-a7ac-a0d91fffae08/image.png';

export const dimensionCodeValues = ['DIGITAL', 'EUR', 'GA', 'NFS', 'NSO', 'TMALL'];

export const dimensions = [
  { label: 'CLEARANCE_STORES', value: 'CLEARANCE' },
  { label: 'GENERAL_AVAILABILITY', value: 'GA' },
  { label: 'NIKE_COM', value: 'DIGITAL' },
  { label: 'NIKE_FACTORY_STORES', value: 'NFS' },
  { label: 'NIKE_STORES_OWNED', value: 'NSO' },
  { label: 'NIKE_STORES_PARTNERED', value: 'NSP' },
];

export const facilityTypeValues = [
  'NIKE_OWNED_STORE',
  'FRANCHISEE_PARTNER_STORE',
  'MONO_BRAND_NON_FRANCHISEE_PARTNER_STORE',
  'MULTI_BRAND_NON_FRANCHISEE_PARTNER_STORE',
  'POPUP_STORE',
  'NIKE_STORE_EXTENSION',
];

export const serviceStatusValues = [
  'ENABLED',
  'DISABLED',
];

export const IPTempClosureReasonValues = [
  '',
  'NATURAL_DISASTER',
  'OVERCAPACITY',
  'PERM_CLOSURE_PREPARATION',
  'REMODEL',
  'UNFORSEEN_EVENTS',
];

export const IPPlatformValues = [
  'BEACON',
  'CITY_DOOR', 'CLEARANCE_DOOR',
  'DROP_SHIP',
  'EMPLOYEE_STORE',
  'GLOBAL_EXPANSION',
  'HOOPS',
  'IP_BY_ACCOUNT',
  'NIKE_COM', 'NIKEID',
  'OUTLET_DOOR',
  'REVERSE_DROP_SHIP', 'RUNNING_DOOR',
  'SOCIAL_COMMERCE',
  'WOMENS_DOOR',
];

export const IPChannelValues = [
  'DIGITAL',
  'NFS',
  'NSO',
  'NSP',
];

export const IPTerritory = ['', 'CENTRAL', 'EAST', 'NORTH', 'SOUTH', 'WEST'];

export const IPSubTerritory = [
  '',
  'AGS_CENTRAL_CH', 'AGS_NORTH', 'AGS_SOUTH_AU',
  'BERLIN',
  'CENTRAL_EUROPE',
  'FRANCE_NORTH', 'FRANCE_SOUTH',
  'GERMAN_MID_SWITZERLAND', 'GERMAN_NORTH', 'GERMAN_SOUTH_AUSTRIA', 'GREECE',
  'ISRAEL', 'ITALY', 'ITALY_MILAN',
  'LONDON',
  'NE_CENTRAL', 'NE_NORTH', 'NE_SOUTH', 'NTL',
  'PARIS_NORTH', 'PARIS_SOUTH', 'POLAND',
  'RUSSIA_MOSCOW', 'RUSSIA_ST_PETERSBURG',
  'SOUTH_AFRICA', 'SPAIN', 'SPAIN_BARCELONA', 'SPAIN_PORTUGAL',
  'TURKEY', 'TURKEY_ISTANBUL',
  'UK_EAST', 'UK_IRELAND_WEST', 'UK_NORTH', 'UK_SOUTH',
];

export const IPTimezones = [
  '',
  'BST',
  'CEST', 'CET',
  'EEST', 'EET',
  'FET',
  'GMT',
  'IST',
  'KUYT',
  'MSD', 'MSK',
  'RST',
  'SAMT',
  'TRT',
  'WEST', 'WET',
];

export const jeCountries = [
  'ANDORRA', 'ARGENTINA', 'AUSTRIA',
  'BELGIUM',
  'CHILE', 'MAINLAND_CHINA', 'CROATIA', 'CZECH_REPUBLIC',
  'DENMARK',
  'FINLAND', 'FRANCE',
  'GERMANY', 'GREECE',
  'HONG_KONG', 'HUNGARY',
  'IRELAND', 'ISRAEL', 'ITALY',
  'JAPAN',
  'MACAO', 'MEXICO',
  'NETHERLANDS', 'NORWAY',
  'POLAND', 'PORTUGAL', 'PUERTO_RICO',
  'RUSSIA',
  'SLOVAKIA', 'SPAIN', 'SWEDEN', 'SWITZERLAND',
  'TAIWAN', 'TURKEY',
  'URUGUAY', 'UNITED_KINGDOM', 'UNITED_STATES',
];

export const jeDistricts = [
  { label: 'CE_CHINA_EAST', value: 'CE' },
  { label: 'CN_CHINA_EAST', value: 'CN' },
  { label: 'CN_CHINA_NORTH', value: 'CS' },
  { label: 'CS_CHINA_SOUTH', value: 'CS_CHINA_SOUTH' },
  { label: 'CW_CHINA_WEST', value: 'CW_CHINA_WEST' },
  { label: 'DEFAULT', value: 'DEFAULT' },
  { label: 'DISTRICT_1', value: 'DISTRICT_1' },
  { label: 'DISTRICT_2', value: 'DISTRICT_2' },
  { label: 'DISTRICT_3', value: 'DISTRICT_3' },
  { label: 'DISTRICT_4', value: 'DISTRICT_4' },
  { label: 'DISTRICT_5', value: 'DISTRICT_5' },
  { label: 'DISTRICT_6', value: 'DISTRICT_6' },
  { label: 'DISTRICT_7', value: 'DISTRICT_7' },
  { label: 'DISTRICT_8', value: 'DISTRICT_8' },
  { label: 'DISTRICT_9', value: 'DISTRICT_9' },
  { label: 'DISTRICT_10', value: 'DISTRICT_10' },
  { label: 'DISTRICT_11', value: 'DISTRICT_11' },
  { label: 'DISTRICT_12', value: 'DISTRICT_12' },
  { label: 'DISTRICT_13', value: 'DISTRICT_13' },
  { label: 'DISTRICT_14', value: 'DISTRICT_14' },
  { label: 'DISTRICT_17', value: 'DISTRICT_17' },
  { label: 'DISTRICT_18', value: 'DISTRICT_18' },
  { label: 'DISTRICT_19', value: 'DISTRICT_19' },
  { label: 'DISTRICT_20', value: 'DISTRICT_20' },
  { label: 'DISTRICT_21', value: 'DISTRICT_21' },
  { label: 'DISTRICT_22', value: 'DISTRICT_22' },
  { label: 'DISTRICT_23', value: 'DISTRICT_23' },
  { label: 'DISTRICT_24', value: 'DISTRICT_24' },
  { label: 'DISTRICT_25', value: 'DISTRICT_25' },
  { label: 'DISTRICT_26', value: 'DISTRICT_26' },
  { label: 'DISTRICT_27', value: 'DISTRICT_27' },
  { label: 'DISTRICT_28', value: 'DISTRICT_28' },
  { label: 'HK_HONGKONG', value: 'HK' },
  { label: 'MC_MACAU', value: 'MC' },
  { label: 'TW_TAIWAN', value: 'TW' },
];

export const jeRegions = [
  { label: 'EUROPE', value: 'EU' },
  { label: 'GREATER_CHINA', value: 'GC' },
  { label: 'JAPAN', value: 'JAPAN' },
  { label: 'MEXICO', value: 'MX' },
  { label: 'NORTH_AMERICA', value: 'NA' },
  { label: 'SOCO', value: 'SOCO' },
];

export const jeTerritories = [
  { label: 'ALL', value: 'ALL' },
  { label: 'ARGENTINA', value: 'AR' },
  { label: 'CENTRAL_EASTERN_EUROPE', value: 'CEE' },
  { label: 'CHILE', value: 'CL' },
  { label: 'CHINA_MAINLAND', value: 'ML' },
  { label: 'HONG_KONG', value: 'HK' },
  { label: 'MEXICO', value: 'MX' },
  { label: 'TAIWAN', value: 'TW' },
  { label: 'UNITED_STATES', value: 'US' },
  { label: 'URUGUAY', value: 'UY' },
  { label: 'WESTERN_EUROPE', value: 'WE' },
];

export const keyCityValues = [
  '',
  'BARCELONA', 'BEIJING',
  'BERLIN',
  'LONDON', 'LOS_ANGELES',
  'MEXICO_CITY', 'MILAN',
  'NEW_YORK',
  'PARIS',
  'SEOUL', 'SHANGHAI',
  'TOKYO',
];

export const isoCountryObjectArray = {
  aa: ['aa', 'Afar'],
  ab: ['ab', 'Abkhazian'],
  ae: ['ae', 'Avestan'],
  af: ['af', 'Afrikaans'],
  ak: ['ak', 'Akan'],
  am: ['am', 'Amharic'],
  an: ['an', 'Aragonese'],
  ar: ['ar', 'Arabic'],
  as: ['as', 'Assamese'],
  av: ['av', 'Avaric'],
  ay: ['ay', 'Aymara'],
  az: ['az', 'Azerbaijani'],
  ba: ['ba', 'Bashkir'],
  be: ['be', 'Belarusian'],
  bg: ['bg', 'Bulgarian'],
  bh: ['bh', 'Bihari languages'],
  bi: ['bi', 'Bislama'],
  bm: ['bm', 'Bambara'],
  bn: ['bn', 'Bengali'],
  bo: ['bo', 'Tibetan'],
  br: ['br', 'Breton'],
  bs: ['bs', 'Bosnian'],
  ca: ['ca', 'Catalan'],
  ce: ['ce', 'Chechen'],
  ch: ['ch', 'Chamorro'],
  co: ['co', 'Corsican'],
  cr: ['cr', 'Cree'],
  cs: ['cs', 'Czech'],
  cu: ['cu', 'Church Slavic'],
  cv: ['cv', 'Chuvash'],
  cy: ['cy', 'Welsh'],
  da: ['da', 'Danish'],
  de: ['de', 'German'],
  dv: ['dv', 'Maldivian'],
  dz: ['dz', 'Dzongkha'],
  ee: ['ee', 'Ewe'],
  el: ['el', '"Greek, Modern (1453-)"'],
  en: ['en', 'English'],
  eo: ['eo', 'Esperanto'],
  es: ['es', 'Spanish'],
  et: ['et', 'Estonian'],
  eu: ['eu', 'Basque'],
  fa: ['fa', 'Persian'],
  ff: ['ff', 'Fulah'],
  fi: ['fi', 'Finnish'],
  fj: ['fj', 'Fijian'],
  fo: ['fo', 'Faroese'],
  fr: ['fr', 'French'],
  fy: ['fy', 'Western Frisian'],
  ga: ['ga', 'Irish'],
  gd: ['gd', 'Gaelic'],
  gl: ['gl', 'Galician'],
  gn: ['gn', 'Guarani'],
  gu: ['gu', 'Gujarati'],
  gv: ['gv', 'Manx'],
  ha: ['ha', 'Hausa'],
  he: ['he', 'Hebrew'],
  hi: ['hi', 'Hindi'],
  ho: ['ho', 'Hiri Motu'],
  hr: ['hr', 'Croatian'],
  ht: ['ht', 'Haitian'],
  hu: ['hu', 'Hungarian'],
  hy: ['hy', 'Armenian'],
  hz: ['hz', 'Herero'],
  ia: ['ia', 'Interlingua (International Auxiliary Language Association)'],
  id: ['id', 'Indonesian'],
  ie: ['ie', 'Interlingue'],
  ig: ['ig', 'Igbo'],
  ii: ['ii', 'Sichuan Yi'],
  ik: ['ik', 'Inupiaq'],
  io: ['io', 'Ido'],
  is: ['is', 'Icelandic'],
  it: ['it', 'Italian'],
  iu: ['iu', 'Inuktitut'],
  ja: ['ja', 'Japanese'],
  jv: ['jv', 'Javanese'],
  ka: ['ka', 'Georgian'],
  kg: ['kg', 'Kongo'],
  ki: ['ki', 'Kikuyu'],
  kj: ['kj', 'Kuanyama'],
  kk: ['kk', 'Kazakh'],
  kl: ['kl', 'Kalaallisut'],
  km: ['km', 'Central Khmer'],
  kn: ['kn', 'Kannada'],
  ko: ['ko', 'Korean'],
  kr: ['kr', 'Kanuri'],
  ks: ['ks', 'Kashmiri'],
  ku: ['ku', 'Kurdish'],
  kv: ['kv', 'Komi'],
  kw: ['kw', 'Cornish'],
  ky: ['ky', 'Kirghiz'],
  la: ['la', 'Latin'],
  lb: ['lb', 'Luxembourgish'],
  lg: ['lg', 'Ganda'],
  li: ['li', 'Limburgan'],
  ln: ['ln', 'Lingala'],
  lo: ['lo', 'Lao'],
  lt: ['lt', 'Lithuanian'],
  lu: ['lu', 'Luba-Katanga'],
  lv: ['lv', 'Latvian'],
  mg: ['mg', 'Malagasy'],
  mh: ['mh', 'Marshallese'],
  mi: ['mi', 'Maori'],
  mk: ['mk', 'Macedonian'],
  ml: ['ml', 'Malayalam'],
  mn: ['mn', 'Mongolian'],
  mr: ['mr', 'Marathi'],
  ms: ['ms', 'Malay'],
  mt: ['mt', 'Maltese'],
  my: ['my', 'Burmese'],
  na: ['na', 'Nauru'],
  nb: ['nb', '"Bokmål, Norwegian"'],
  nd: ['nd', '"Ndebele, North"'],
  ne: ['ne', 'Nepali'],
  ng: ['ng', 'Ndonga'],
  nl: ['nl', 'Dutch'],
  nn: ['nn', '"Norwegian Nynorsk"'],
  no: ['no', 'Norwegian'],
  nr: ['nr', '"Ndebele, South"'],
  nv: ['nv', 'Navajo'],
  ny: ['ny', 'Chichewa'],
  oc: ['oc', 'Occitan (post 1500)'],
  oj: ['oj', 'Ojibwa'],
  om: ['om', 'Oromo'],
  or: ['or', 'Oriya'],
  os: ['os', 'Ossetian'],
  pa: ['pa', 'Panjabi'],
  pi: ['pi', 'Pali'],
  pl: ['pl', 'Polish'],
  ps: ['ps', 'Pushto'],
  pt: ['pt', 'Portuguese'],
  qu: ['qu', 'Quechua'],
  rm: ['rm', 'Romansh'],
  rn: ['rn', 'Rundi'],
  ro: ['ro', 'Romanian'],
  ru: ['ru', 'Russian'],
  rw: ['rw', 'Kinyarwanda'],
  sa: ['sa', 'Sanskrit'],
  sc: ['sc', 'Sardinian'],
  sd: ['sd', 'Sindhi'],
  se: ['se', 'Northern Sami'],
  sg: ['sg', 'Sango'],
  si: ['si', 'Sinhala'],
  sk: ['sk', 'Slovak'],
  sl: ['sl', 'Slovenian'],
  sm: ['sm', 'Samoan'],
  sn: ['sn', 'Shona'],
  so: ['so', 'Somali'],
  sq: ['sq', 'Albanian'],
  sr: ['sr', 'Serbian'],
  ss: ['ss', 'Swati'],
  st: ['st', 'Sotho, Southern'],
  su: ['su', 'Sundanese'],
  sv: ['sv', 'Swedish'],
  sw: ['sw', 'Swahili'],
  ta: ['ta', 'Tamil'],
  te: ['te', 'Telugu'],
  tg: ['tg', 'Tajik'],
  th: ['th', 'Thai'],
  ti: ['ti', 'Tigrinya'],
  tk: ['tk', 'Turkmen'],
  tl: ['tl', 'Tagalog'],
  tn: ['tn', 'Tswana'],
  to: ['to', 'Tonga (Tonga Islands)'],
  tr: ['tr', 'Turkish'],
  ts: ['ts', 'Tsonga'],
  tt: ['tt', 'Tatar'],
  tw: ['tw', 'Twi'],
  ty: ['ty', 'Tahitian'],
  ug: ['ug', 'Uighur'],
  uk: ['uk', 'Ukrainian'],
  ur: ['ur', 'Urdu'],
  uz: ['uz', 'Uzbek'],
  ve: ['ve', 'Venda'],
  vi: ['vi', 'Vietnamese'],
  vo: ['vo', 'Volapük'],
  wa: ['wa', 'Walloon'],
  wo: ['wo', 'Wolof'],
  xh: ['xh', 'Xhosa'],
  yi: ['yi', 'Yiddish'],
  yo: ['yo', 'Yoruba'],
  za: ['za', 'Zhuang'],
  zh: ['zh', 'Chinese'],
  zu: ['zu', 'Zulu'],
};

export const languageValues = [
  'ca', 'cs',
  'da', 'de',
  'el', 'en', 'en-GB', 'en-IE', 'en-MY', 'en-NL', 'en-SG', 'en-TH', 'es-419', 'es-ES',
  'fr',
  'hu',
  'it',
  'ja',
  'ko',
  'nl', 'nn', 'no',
  'pl', 'pt-BR', 'pt-PT',
  'ru',
  'sv',
  'th', 'tr',
  'zh-Hans', 'zh-Hant',
];

export const localeValues = [
  'ar-IL', 'ar-SA', 'as-US',
  'ca-ES', 'cs-CZ',
  'da-DK', 'de-AT', 'de-CH', 'de-DE', 'de-GE',
  'el-GR', 'en-AD', 'en-AE', 'en-AM', 'en-AT', 'en-AU', 'en-AZ', 'en-BA', 'en-BE', 'en-BG', 'en-BH', 'en-BY', 'en-CA', 'en-CH', 'en-CY', 'en-CZ', 'en-DE', 'en-DK',
  'en-EE', 'en-EN', 'en-ES', 'en-FI', 'en-FR', 'en-GB', 'en-GE', 'en-GR', 'en-HK', 'en-HR', 'en-HU', 'en-IE', 'en-IL', 'en-IN', 'en-IT', 'en-JO', 'en-JP', 'en-KG',
  'en-KW', 'en-KZ', 'en-LB', 'en-LT', 'en-LV', 'en-MD', 'en-MK', 'en-MX', 'en-MY', 'en-NL', 'en-NO', 'en-NZ', 'en-OM', 'en-PH', 'en-PL', 'en-PT', 'en-QA', 'en-RO',
  'en-RS', 'en-RU', 'en-SA', 'en-SE', 'en-SG', 'en-SK', 'en-TM', 'en-TR', 'en-UA', 'en-US', 'en-UZ', 'en-ZA', 'es-AR', 'es-CL', 'es-ES', 'es-MX', 'es-UY',
  'fi-FI', 'fr-BE', 'fr-CH', 'fr-FR', 'fr-IT',
  'he-IL', 'hu-HU',
  'it-CH', 'it-IT',
  'ja-JP',
  'ko-KR',
  'nl-BE', 'nl-NL', 'nn-NO', 'no-NO',
  'pl-PL', 'po-PL', 'po-PT', 'pt-BR', 'pt-PT', 'pu-AF',
  'ru-RU',
  'sk-SK', 'sp-AR', 'sp-CL', 'sp-ES', 'sv-SE',
  'th-TH', 'tr-TR',
  'zh-CN', 'zh-EN', 'zh-HK', 'zh-MO', 'zh-SG', 'zh-TW', 'zn-CN',
];

export const locationTypes = [
  { label: 'DISTRIBUTION_CENTER', value: 'DC' },
  { label: 'RETAIL_LOCATION', value: 'STORE' },
  { label: 'SATELLITE_DISTRIBUTION_CENTER', value: 'SDC' },
];

export const orderCategories = ['A', 'F', 'I', 'O'];

export const regionCodeValues = ['AMER', 'APLA', 'EU', 'GC', 'NA'];

export const regionIdMappings = {
  18: 'Greater China',
  19: 'Hong Kong',
  27: 'Tai Wan',
  29: 'Mexico',
  3: 'North America',
  4: 'Europe',
  8: 'Japan',
};

export const regionValues = [
  'ASIA_PACIFIC_LATIN_AMERICA',
  'EUROPE_MIDDLE_EAST_AFRICA',
  'EMERGING_MARKETS',
  'GREATER_CHINA',
  'NORTH_AMERICA',
];

export const regionIds = {
  CONVERSE: {
    NORTH_AMERICA: '82fa2b53-4578-4639-8ee7-2b4ce2dd9afc',
  },
  NIKE: {
    ASIA_PACIFIC_LATIN_AMERICA: 'dc99749d-da1e-45c3-a798-0e38f143469b',
    EUROPE_MIDDLE_EAST_AFRICA: '3350ffa3-adb8-4981-8a98-5dc7fddd581c',
    GREATER_CHINA: 'ea242a8c-464a-4991-99e7-1ada3dd4fa41',
    NORTH_AMERICA: 'a469ace0-9f91-4c5e-95bb-37f5403a61f0',
  },
};

export const salesAreas = [
  { label: 'AGS', value: 'AGS' },
  { label: 'ARGENTINA', value: 'ARGENTINA' },
  { label: 'CE', value: 'CE' },
  { label: 'CE_JS', value: 'CE_JS' },
  { label: 'CE_SHNFS', value: 'CE_SHNFS' },
  { label: 'CE_SW', value: 'CE_SW' },
  { label: 'CHILE', value: 'CHILE' },
  { label: 'CN_BJNFS', value: 'CN_BJNFS' },
  { label: 'CN_NE', value: 'CN_NE' },
  { label: 'CS_GZ', value: 'CS_GZ' },
  { label: 'CS_XE', value: 'CS_XE' },
  { label: 'CW_YG', value: 'CW_YG' },
  { label: 'DEFAULT', value: 'DEFAULT' },
  { label: 'DIGITAL', value: 'NA_DIGITAL' },
  { label: 'EMP_CENTRAL', value: 'NA_EMPLOYEE_CENTRAL' },
  { label: 'EMP_NORTHWEST', value: 'NA_EMPLOYEE_NORTHWEST' },
  { label: 'FRANCE', value: 'FRANCE' },
  { label: 'GC_FACTORY_EAST_1', value: 'EAST_1' },
  { label: 'GC_FACTORY_EAST_2', value: 'EAST_2' },
  { label: 'GC_FACTORY_EAST_3', value: 'EAST_3' },
  { label: 'GC_FACTORY_EAST_4', value: 'EAST_4' },
  { label: 'GC_FACTORY_EAST_5', value: 'EAST_5' },
  { label: 'GC_FACTORY_EAST_6', value: 'EAST_6' },
  { label: 'GC_FACTORY_NORTH_1', value: 'NORTH_1' },
  { label: 'GC_FACTORY_NORTH_2', value: 'NORTH_2' },
  { label: 'GC_FACTORY_NORTH_3', value: 'NORTH_3' },
  { label: 'GC_FACTORY_NORTH_4', value: 'NORTH_4' },
  { label: 'GC_FACTORY_NORTH_5', value: 'NORTH_5' },
  { label: 'GC_FACTORY_NORTH_6', value: 'NORTH_6' },
  { label: 'GC_FACTORY_NORTH_7', value: 'NORTH_7' },
  { label: 'GC_FACTORY_NORTH_8', value: 'NORTH_8' },
  { label: 'GC_FACTORY_SOUTH_1', value: 'SOUTH_1' },
  { label: 'GC_FACTORY_SOUTH_2', value: 'SOUTH_2' },
  { label: 'GC_FACTORY_SOUTH_3', value: 'SOUTH_3' },
  { label: 'GC_FACTORY_SOUTH_4', value: 'SOUTH_4' },
  { label: 'GC_FACTORY_SOUTH_5', value: 'SOUTH_5' },
  { label: 'GC_INLINE_EAST', value: 'EAST' },
  { label: 'GC_INLINE_NORTH', value: 'NORTH' },
  { label: 'GC_INLINE_SOUTH', value: 'SOUTH' },
  { label: 'GC_STORES_HONGKONG', value: 'HONGKONG' },
  { label: 'GC_STORES_MACAU', value: 'MACAU' },
  { label: 'GC_STORES_TAIWAN', value: 'TAIWAN' },
  { label: 'GREECE', value: 'GREECE' },
  { label: 'IBERIA', value: 'IBERIA' },
  { label: 'ISRAEL', value: 'ISRAEL' },
  { label: 'ITALY', value: 'ITALY' },
  { label: 'MEXICO', value: 'MEXICO' },
  { label: 'NFS_CENTRAL', value: 'NA_FACTORY_CENTRAL' },
  { label: 'NFS_NORTHEAST', value: 'NA_FACTORY_NORTHEAST' },
  { label: 'NFS_SOUTHEAST', value: 'NA_FACTORY_SOUTHEAST' },
  { label: 'NFS_SOUTHWEST', value: 'NA_FACTORY_SOUTHWEST' },
  { label: 'NFS_WEST', value: 'NA_FACTORY_WEST' },
  { label: 'NORTHERN_EUROPE', value: 'NORTHERN_EUROPE' },
  { label: 'NSO_CENTRAL', value: 'NA_INLINE_CENTRAL' },
  { label: 'NSO_EAST', value: 'NA_INLINE_EAST' },
  { label: 'NSO_NORTHEAST', value: 'NA_INLINE_NORTHEAST' },
  { label: 'NSO_NORTHWEST', value: 'NA_INLINE_NORTHWEST' },
  { label: 'NSO_SOUTHEAST', value: 'NA_INLINE_SOUTHEAST' },
  { label: 'NSO_SOUTHWEST', value: 'NA_INLINE_SOUTHWEST' },
  { label: 'NSO_WEST', value: 'NA_INLINE_WEST' },
  { label: 'POLAND', value: 'POLAND' },
  { label: 'RUSSIA', value: 'RUSSIA' },
  { label: 'TURKEY', value: 'TURKEY' },
  { label: 'UK_IRELAND', value: 'UK_IRELAND' },
  { label: 'URUGUAY', value: 'URUGUAY' },
];

// export const stateValues = [
//   { label: 'Alabama', value: 'AL' },
//   { label: 'Alaska', value: 'AK' },
//   { label: 'American Samoa', value: 'AS' },
//   { label: 'Arizona', value: 'AZ' },
//   { label: 'Arkansas', value: 'AR' },
//   { label: 'California', value: 'CA' },
//   { label: 'Colorado', value: 'CO' },
//   { label: 'Connecticut', value: 'CT' },
//   { label: 'Delaware', value: 'DE' },
//   { label: 'District of Columbia', value: 'DC' },
//   { label: 'Federated States of Micronesia', value: 'FM' },
//   { label: 'Florida', value: 'FL' },
//   { label: 'Georgia', value: 'GA' },
//   { label: 'Guam', value: 'GU' },
//   { label: 'Hawaii', value: 'HI' },
//   { label: 'Idaho', value: 'ID' },
//   { label: 'Illinois', value: 'IL' },
//   { label: 'Indiana', value: 'IN' },
//   { label: 'Iowa', value: 'IA' },
//   { label: 'Kansas', value: 'KS' },
//   { label: 'Kentucky', value: 'KY' },
//   { label: 'Louisiana', value: 'LA' },
//   { label: 'Maine', value: 'ME' },
//   { label: 'Marshall Islands', value: 'MH' },
//   { label: 'Maryland', value: 'MD' },
//   { label: 'Massachusetts', value: 'MA' },
//   { label: 'Michigan', value: 'MI' },
//   { label: 'Minnesota', value: 'MN' },
//   { label: 'Mississippi', value: 'MS' },
//   { label: 'Missouri', value: 'MO' },
//   { label: 'Montana', value: 'MT' },
//   { label: 'Nebraska', value: 'NE' },
//   { label: 'Nevada', value: 'NV' },
//   { label: 'New Hampshire', value: 'NH' },
//   { label: 'New Jersey', value: 'NJ' },
//   { label: 'New Mexico', value: 'NM' },
//   { label: 'New York', value: 'NY' },
//   { label: 'North Carolina', value: 'NC' },
//   { label: 'North Dakota', value: 'ND' },
//   { label: 'Northern Mariana Islands', value: 'MP' },
//   { label: 'Ohio', value: 'OH' },
//   { label: 'Oklahoma', value: 'OK' },
//   { label: 'Oregon', value: 'OR' },
//   { label: 'Palau', value: 'PW' },
//   { label: 'Pennsylvania', value: 'PA' },
//   { label: 'Puerto Rico', value: 'PR' },
//   { label: 'Rhode Island', value: 'RI' },
//   { label: 'South Carolina', value: 'SC' },
//   { label: 'South Dakota', value: 'SD' },
//   { label: 'Tennessee', value: 'TN' },
//   { label: 'Texas', value: 'TX' },
//   { label: 'Utah', value: 'UT' },
//   { label: 'Vermont', value: 'VT' },
//   { label: 'Virginia', value: 'VA' },
//   { label: 'Virgin Islands', value: 'VI' },
//   { label: 'Washington', value: 'WA' },
//   { label: 'West Virginia', value: 'WV' },
//   { label: 'Wisconsin', value: 'WI' },
//   { label: 'Wyoming', value: 'WY' },
// ];

// export const canadaProvinceValues = [
//   'Alberta',
//   'British Columbia',
//   'Manitoba',
//   'New Brunswick',
//   'Newfoundland and Labrador',
//   'Nova Scotia',
//   'Ontario',
//   'Prince Edward Island',
//   'Quebec',
//   'Saskatchewan',
// ].map((province) => ({
//   label: province,
//   value: province,
// }));

export const storeChannelValues = ['DIGITAL'];

export const storeDistricts = [
  'APLA_JP_CENTRAL', 'APLA_JP_EAST', 'APLA_JP_NSO', 'APLA_JP_WEST', 'APLA_JP_NSP',
  'APLA_KR_NVS_DISTRICT_1', 'APLA_KR_NSO', 'APLA_KR_NVS_DISTRICT_2',
  'APLA_MX_DISTRICT_1', 'APLA_MX_DISTRICT_2', 'APLA_MX_DISTRICT_3', 'APLA_MX_DISTRICT_4',
  'APLA_PAC_DISTRICT_1', 'APLA_SEA_SG_NVS', 'APLA_SEA_SG_NSO', 'APLA_SEA_MY_NVS',
  'APLA_SEA_TH_NVS', 'East',
  'EMEA_CENTRAL_EUROPE',
  'EMEA_PARIS_NORTH', 'EMEA_PARIS_SOUTH',
  'EMEA_FRANCE_CENTRAL', 'EMEA_FRANCE_EAST', 'EMEA_FRANCE_NORTH', 'EMEA_FRANCE_SE', 'EMEA_FRANCE_SW',
  'EMEA_GER_MID_SWTZ', 'EMEA_GER_SOUTH_AUS',
  'EMEA_BERLIN', 'EMEA_GERMANY_N_W',
  'EMEA_GREECE',
  'EMEA_HOI',
  'EMEA_ISRAEL',
  'EMEA_ITALY_NE', 'EMEA_ITALY_NW', 'EMEA_MILAN', 'EMEA_ITALY_SOUTH', 'EMEA_MADRID', 'EMEA_ROME',
  'EMEA_NE_MID', 'EMEA_NE_NORTH', 'EMEA_NE_SOUTH',
  'EMEA_POLAND_NORTH', 'EMEA_POLAND_SOUTH',
  'EMEA_RUSSIA_MOSCOW', 'EMEA_RUSSIA_ST_PETE',
  'EMEA_SOUTH_AFRICA',
  'EMEA_SPAIN_CENTRAL', 'EMEA_SPAIN_EAST', 'EMEA_BARCELONA', 'EMEA_PORTUGAL',
  'EMEA_TURKEY', 'EMEA_TURKEY_ISTANBUL',
  'EMEA_UK_EAST', 'EMEA_UK_IRELAND_WEST', 'EMEA_LONDON_NSO', 'EMEA_LONDON_NVS', 'EMEA_UK_MIDLANDS', 'EMEA_UK_NORTH', 'EMEA_UK_NORTH_WEST', 'EMEA_NTL', 'EMEA_UK_SOUTH',
  'GC_CE_SH', 'GC_CE_JS', 'GC_CE_JZ', 'GC_CE_NSO', 'GC_CE_SW', 'GC_CN_BJ',
  'GC_CN_BJNSO', 'GC_CN_JJ', 'GC_CN_LY', 'GC_CN_NE',
  'GC_CS_MGQ', 'GC_CS_NSO', 'GC_CS_GZ', 'GC_CS_SZ', 'GC_CS_XE', 'GC_CW_CY', 'GC_CW_NW', 'GC_CW_YG',
  'GC_HK_MC', 'GC_HK_NSO', 'GC_TW', 'GC_TW_NSO', 'INLINE', 'MID_ATLANTIC',
  '1_NFS_OREGON', '2_NFS_WASHINGTON', '3_NFS_BAY_AREA', '4_NFS_NORTH_LA', '5_NSO_LA',
  '6_NFS_SAN_DIEGO_INLAND_EMPIRE', '7_NSO_NORTHERN_CA_OR_WA', '8_NFS_NORTHERN_CA', '9_NFS_SOUTH_LA_OC', '10_NFS_SOUTH_TEXAS',
  '11_NFS_DESERT_STATES', '12_NFS_MOUNTAIN_STATES', '13_NFS_NORTH_TEXAS', '14_NFS_NV_UT', '15_NSO_TEXAS',
  '16_NSO_DESERT_MOUNTAIN', '17_NFS_EAST_TEXAS', '18_NFS_MIDWEST', '19_NFS_GREAT_LAKES', '20_NFS_CHICAGO_METRO',
  '21_NFS_OHIO_VALLEY', '22_NFS_WEST_CANADA', '23_NFS_EAST_CANADA', '24_NSO_CENTRAL', '25_NSO_OHIO',
  '26_NFS_CAROLINAS', '27_NFS_ORLANDO', '28_NFS_SOUTHERN_FLORIDA', '29_NFS_TENNESSEE', '30_NFS_GULF_STATES',
  '31_NFS_GEORGIA', '32_NFS_SOUTHEAST', '33_CENTRAL_FLORIDA', '34_NSO_FLORIDA', '35_NFS_NEW_ENGLAND',
  '36_NFS_LONG_ISLAND_BROOKLYN', '37_NSO_NYC', '38_NFS_NORTHERN_JERSEY_UPSTATE_NY', '39_NFS_JERSEY_PHILLY', '40_NFS_VIRGINIA',
  '41_NSO_NEW_ENGLAND', '42_NSO_NJ_DMV', '43_NFS_MARYLAND', 'North', 'NORTHEAST', 'NORTHERN_EUROPE', 'PNW_CENTRAL',
  'South', 'SOUTHEAST', 'SOUTHERN_EUROPE', 'SOUTHWEST', 'WEST',
];

export const storeStatusValues = [
  { label: 'Closed', value: 'CLOSED' },
  { label: 'Open', value: 'OPEN' },
  { label: 'Unopened', value: 'UNOPENED' },
];

export const storeSubConcepts = [
  { label: 'BRAND_EXPERIENCE', value: 6 },
  { label: 'CATEGORY', value: 7 },
  { label: 'CLEARANCE', value: 4 },
  { label: 'COMMUNITY', value: 2 },
  { label: 'DIGITAL', value: 9 },
  { label: 'DISTRIBUTION_CENTER', value: 10 },
  { label: 'EMPLOYEE', value: 3 },
  { label: 'FACTORY', value: 5 },
  { label: 'FRANCHISE', value: 13 },
  { label: 'NIKELAB', value: 1 },
  { label: 'POP_UP_STORE', value: 17 },
  { label: 'REGIONAL_DISTRIBUTION_CENTER', value: 16 },
];

export const storeTerritories = [
  'APLA_JP', 'APLA_KR', 'APLA_MX', 'APLA_PAC', 'APLA_SEA',
  'CONVERSE', 'Converse GC',
  'CONVERSE_WE',
  'EMEA_CENTRAL', 'EMEA_EAST_AFRICA', 'EMEA_FRANCE', 'EMEA_SOUTH', 'EMEA_WEST',
  'GC_CE', 'GC_CN', 'GC_CS', 'GC_CW', 'GC_HK_TW_MC', 'GC_HK_NSO', 'GC_CE_SHNSO', 'GC_CN_BJNSO', 'GC_CS_NSO', 'GC_TW_NSO',
  'NA_CENTRAL', 'NA_NORTHEAST', 'NA_SOUTHEAST', 'NA_SOUTHWEST', 'NA_WEST',
];

export const storeTypeValues = [
  '',
  'FACTORY', 'FRANCHISEE_PARTNER_STORE',
  'INLINE',
  'MONO_BRAND_NON_FRANCHISEE_PARTNER_STORE', 'MULTI_BRAND_NON_FRANCHISEE_PARTNER_STORE',
];

export const timezoneValues = momentTZ.tz
  .names()
  .filter((el) => /[a-z]+([_a-z]*[a-z]+)?\/[a-z]+([_a-z]*[a-z]+)?$/i.test(el));

export const typeValues = [
  'Beacon',
  'Clearance', 'Converse',
  'Employee Store',
  'Hurley',
  'Inline Store',
  'Nike Factory Stores', 'Nike Partner Store', 'Nike Running', 'Nike Stores',
  'Standard',
];

export const warehouseCompanyValues = ['Nike', 'Converse', 'FootLocker', 'Nordstrom', 'TopSports'];

export const warehouseIPTypeValues = ['PHYSICAL', 'LOGICAL'];

export const warehouseRegionValues = [
  'ASIA_PACIFIC_LATIN_AMERICA',
  'EMERGING_MARKETS',
  'EUROPE_MIDDLE_EAST_AFRICA',
  'GREATER_CHINA',
  'NORTH_AMERICA',
];

export const warehouseTypeValues = [
  'DISTRIBUTION_CENTER',
  'SATELLITE_DISTRIBUTION_CENTER',
];

export const warehouseChannelValues = [
  'GRPPRCH',
  'HK.COM',
  'JD_KIDS',
  'NIKE.COM',
  'TMALL_FGSP',
  'TMALL_JD',
  'TMALL_HPMK',
  'TMALL_OUTL',
  'TMALL_YA',
];

// export const emeaStateValues = {
//     AGO: [
//         {
//             label: 'Bengo',
//             stateCode: 'BGO',
//             value: 'Bengo'
//         },
//         {
//             label: 'Benguela',
//             stateCode: 'BGU',
//             value: 'Benguela'
//         },
//         {
//             label: 'Bie',
//             stateCode: 'BIE',
//             value: 'Bie'
//         },
//         {
//             label: 'Cabinda',
//             stateCode: 'CAB',
//             value: 'Cabinda'
//         },
//         {
//             label: 'Cuando Cubango',
//             stateCode: 'CCU',
//             value: 'Cuando Cubango'
//         },
//         {
//             label: 'Cunene',
//             stateCode: 'CNN',
//             value: 'Cunene'
//         },
//         {
//             label: 'Cuanza Norte',
//             stateCode: 'CNO',
//             value: 'Cuanza Norte'
//         },
//         {
//             label: 'Cuanza Sul',
//             stateCode: 'CUS',
//             value: 'Cuanza Sul'
//         },
//         {
//             label: 'Huambo',
//             stateCode: 'HUA',
//             value: 'Huambo'
//         },
//         {
//             label: 'Huila',
//             stateCode: 'HUI',
//             value: 'Huila'
//         },
//         {
//             label: 'Lunda Norte',
//             stateCode: 'LNO',
//             value: 'Lunda Norte'
//         },
//         {
//             label: 'Lunda Sul',
//             stateCode: 'LSU',
//             value: 'Lunda Sul'
//         },
//         {
//             label: 'Luanda',
//             stateCode: 'LUA',
//             value: 'Luanda'
//         },
//         {
//             label: 'Malanje',
//             stateCode: 'MAL',
//             value: 'Malanje'
//         },
//         {
//             label: 'Moxico',
//             stateCode: 'MOX',
//             value: 'Moxico'
//         },
//         {
//             label: 'Namibe',
//             stateCode: 'NAM',
//             value: 'Namibe'
//         },
//         {
//             label: 'Uige',
//             stateCode: 'UIG',
//             value: 'Uige'
//         },
//         {
//             label: 'Zaire',
//             stateCode: 'ZAI',
//             value: 'Zaire'
//         }
//     ],
//     AND: [
//         {
//             label: 'Andorra la Vella',
//             stateCode: '07',
//             value: 'Andorra la Vella'
//         },
//         {
//             label: 'Canillo',
//             stateCode: '02',
//             value: 'Canillo'
//         },
//         {
//             label: 'Encamp',
//             stateCode: '03',
//             value: 'Encamp'
//         },
//         {
//             label: 'Escalades-Engordany',
//             stateCode: '08',
//             value: 'Escalades-Engordany'
//         },
//         {
//             label: 'La Massana',
//             stateCode: '04',
//             value: 'La Massana'
//         },
//         {
//             label: 'Ordino',
//             stateCode: '05',
//             value: 'Ordino'
//         },
//         {
//             label: 'Sant Julia de Loria',
//             stateCode: '06',
//             value: 'Sant Julia de Loria'
//         }
//     ],
//     ARE: [
//         {
//             label: 'Ajmān',
//             stateCode: 'AJ',
//             value: 'Ajmān'
//         },
//         {
//             label: 'Abu Dhabi',
//             stateCode: 'AZ',
//             value: 'Abu Dhabi'
//         },
//         {
//             label: 'Fujaryrah',
//             stateCode: 'FU',
//             value: 'Fujaryrah'
//         },
//         {
//             label: 'Sharjah',
//             stateCode: 'SH',
//             value: 'Sharjah'
//         },
//         {
//             label: 'Dubai',
//             stateCode: 'DU',
//             value: 'Dubai'
//         },
//         {
//             label: 'Ras Al Khaimah',
//             stateCode: 'RK',
//             value: 'Ras Al Khaimah'
//         },
//         {
//             label: 'Umm Al Quwain',
//             stateCode: 'UQ',
//             value: 'Umm Al Quwain'
//         }
//     ],
//     ARM: [
//         {
//             label: 'Aragatzotn',
//             stateCode: 'AG',
//             value: 'Aragatzotn'
//         },
//         {
//             label: 'Ararat',
//             stateCode: 'AR',
//             value: 'Ararat'
//         },
//         {
//             label: 'Armawir',
//             stateCode: 'AV',
//             value: 'Armawir'
//         },
//         {
//             label: 'Yerevan',
//             stateCode: 'ER',
//             value: 'Yerevan'
//         },
//         {
//             label: 'Gegharkunik',
//             stateCode: 'GR',
//             value: 'Gegharkunik'
//         },
//         {
//             label: 'Kotayk',
//             stateCode: 'KT',
//             value: 'Kotayk'
//         },
//         {
//             label: 'Lori',
//             stateCode: 'LO',
//             value: 'Lori'
//         },
//         {
//             label: 'Schirak',
//             stateCode: 'SH',
//             value: 'Schirak'
//         },
//         {
//             label: 'Syunik',
//             stateCode: 'SU',
//             value: 'Syunik'
//         },
//         {
//             label: 'Tavush',
//             stateCode: 'TV',
//             value: 'Tavush'
//         },
//         {
//             label: 'Vayots Dzor',
//             stateCode: 'VD',
//             value: 'Vayots Dzor'
//         }
//     ],
//     AUT: [
//         {
//             label: 'Burgenland',
//             stateCode: '01',
//             value: 'Burgenland'
//         },
//         {
//             label: 'Carinthia',
//             stateCode: '02',
//             value: 'Carinthia'
//         },
//         {
//             label: 'Lower Austria',
//             stateCode: '03',
//             value: 'Lower Austria'
//         },
//         {
//             label: 'Upper Austria',
//             stateCode: '04',
//             value: 'Upper Austria'
//         },
//         {
//             label: 'Salzburg',
//             stateCode: '05',
//             value: 'Salzburg'
//         },
//         {
//             label: 'Styria',
//             stateCode: '06',
//             value: 'Styria'
//         },
//         {
//             label: 'Tyrol',
//             stateCode: '07',
//             value: 'Tyrol'
//         },
//         {
//             label: 'Vorarlberg',
//             stateCode: '08',
//             value: 'Vorarlberg'
//         },
//         {
//             label: 'Vienna',
//             stateCode: '09',
//             value: 'Vienna'
//         }
//     ],
//     BEL: [
//         {
//             label: 'Brussels',
//             stateCode: 'BRU',
//             value: 'Brussels'
//         },
//         {
//             label: 'Flanders',
//             stateCode: 'VLG',
//             value: 'Flanders'
//         },
//         {
//             label: 'Wallonia',
//             stateCode: 'WAL',
//             value: 'Wallonia'
//         }
//     ],
//     BGR: [
//         {
//             label: 'Blagoevgrad',
//             stateCode: '01',
//             value: 'Blagoevgrad'
//         },
//         {
//             label: 'Burgas',
//             stateCode: '02',
//             value: 'Burgas'
//         },
//         {
//             label: 'Varna',
//             stateCode: '03',
//             value: 'Varna'
//         },
//         {
//             label: 'Veliko Tarnovo',
//             stateCode: '04',
//             value: 'Veliko Tarnovo'
//         },
//         {
//             label: 'Vidin',
//             stateCode: '05',
//             value: 'Vidin'
//         },
//         {
//             label: 'Vratsa',
//             stateCode: '06',
//             value: 'Vratsa'
//         },
//         {
//             label: 'Gabrovo',
//             stateCode: '07',
//             value: 'Gabrovo'
//         },
//         {
//             label: 'Dobrich',
//             stateCode: '08',
//             value: 'Dobrich'
//         },
//         {
//             label: 'Kardzhali',
//             stateCode: '09',
//             value: 'Kardzhali'
//         },
//         {
//             label: 'Kyustendil',
//             stateCode: '10',
//             value: 'Kyustendil'
//         },
//         {
//             label: 'Lovech',
//             stateCode: '11',
//             value: 'Lovech'
//         },
//         {
//             label: 'Montana',
//             stateCode: '12',
//             value: 'Montana'
//         },
//         {
//             label: 'Pazardzhik',
//             stateCode: '13',
//             value: 'Pazardzhik'
//         },
//         {
//             label: 'Pernik',
//             stateCode: '14',
//             value: 'Pernik'
//         },
//         {
//             label: 'Pleven',
//             stateCode: '15',
//             value: 'Pleven'
//         },
//         {
//             label: 'Plovdiv',
//             stateCode: '16',
//             value: 'Plovdiv'
//         },
//         {
//             label: 'Razgrad',
//             stateCode: '17',
//             value: 'Razgrad'
//         },
//         {
//             label: 'Ruse',
//             stateCode: '18',
//             value: 'Ruse'
//         },
//         {
//             label: 'Silistra',
//             stateCode: '19',
//             value: 'Silistra'
//         },
//         {
//             label: 'Sliven',
//             stateCode: '20',
//             value: 'Sliven'
//         },
//         {
//             label: 'Smolyan',
//             stateCode: '21',
//             value: 'Smolyan'
//         },
//         {
//             label: 'Sofia-Grad',
//             stateCode: '22',
//             value: 'Sofia-Grad'
//         },
//         {
//             label: 'Sofia',
//             stateCode: '23',
//             value: 'Sofia'
//         },
//         {
//             label: 'Stara Zagora',
//             stateCode: '24',
//             value: 'Stara Zagora'
//         },
//         {
//             label: 'Targovishte',
//             stateCode: '25',
//             value: 'Targovishte'
//         },
//         {
//             label: 'Haskovo',
//             stateCode: '26',
//             value: 'Haskovo'
//         },
//         {
//             label: 'Shumen',
//             stateCode: '27',
//             value: 'Shumen'
//         },
//         {
//             label: 'Yambol',
//             stateCode: '28',
//             value: 'Yambol'
//         }
//     ],
//     BIH: [
//         {
//             label: 'Federacija Bosna i H',
//             stateCode: 'BIH',
//             value: 'Federacija Bosna i H'
//         },
//         {
//             label: 'Republika Srpska',
//             stateCode: 'SRP',
//             value: 'Republika Srpska'
//         },
//         {
//             label: 'Brčko District',
//             stateCode: 'BRC',
//             value: 'Brčko District'
//         }
//     ],
//     BWA: [
//         {
//             label: 'Central',
//             stateCode: 'CE',
//             value: 'Central'
//         },
//         {
//             label: 'Chobe',
//             stateCode: 'CH',
//             value: 'Chobe'
//         },
//         {
//             label: 'Francistown',
//             stateCode: 'FR',
//             value: 'Francistown'
//         },
//         {
//             label: 'Gaborone',
//             stateCode: 'GA',
//             value: 'Gaborone'
//         },
//         {
//             label: 'Ghanzi',
//             stateCode: 'GH',
//             value: 'Ghanzi'
//         },
//         {
//             label: 'Jwaneng',
//             stateCode: 'JW',
//             value: 'Jwaneng'
//         },
//         {
//             label: 'Kgalagadi',
//             stateCode: 'KG',
//             value: 'Kgalagadi'
//         },
//         {
//             label: 'Kgatleng',
//             stateCode: 'KL',
//             value: 'Kgatleng'
//         },
//         {
//             label: 'Kweneng',
//             stateCode: 'KW',
//             value: 'Kweneng'
//         },
//         {
//             label: 'Lobatse',
//             stateCode: 'LO',
//             value: 'Lobatse'
//         },
//         {
//             label: 'North East',
//             stateCode: 'NE',
//             value: 'North East'
//         },
//         {
//             label: 'North West',
//             stateCode: 'NW',
//             value: 'North West'
//         },
//         {
//             label: 'South East',
//             stateCode: 'SE',
//             value: 'South East'
//         },
//         {
//             label: 'Southern',
//             stateCode: 'SO',
//             value: 'Southern'
//         },
//         {
//             label: 'Selebi-Phikwe',
//             stateCode: 'SP',
//             value: 'Selebi-Phikwe'
//         },
//         {
//             label: 'Sowa Township',
//             stateCode: 'ST',
//             value: 'Sowa Township'
//         }
//     ],
//     CAN: [
//         {
//             label: 'Alberta',
//             stateCode: 'AB',
//             value: 'Alberta'
//         },
//         {
//             label: 'British Columbia',
//             stateCode: 'BC',
//             value: 'British Columbia'
//         },
//         {
//             label: 'Manitoba',
//             stateCode: 'MB',
//             value: 'Manitoba'
//         },
//         {
//             label: 'New Brunswick',
//             stateCode: 'NB',
//             value: 'New Brunswick'
//         },
//         {
//             label: 'Newfoundland & Labr.',
//             stateCode: 'NL',
//             value: 'Newfoundland & Labr.'
//         },
//         {
//             label: 'Nova Scotia',
//             stateCode: 'NS',
//             value: 'Nova Scotia'
//         },
//         {
//             label: 'Northwest Territory',
//             stateCode: 'NT',
//             value: 'Northwest Territory'
//         },
//         {
//             label: 'Nunavut',
//             stateCode: 'NU',
//             value: 'Nunavut'
//         },
//         {
//             label: 'Ontario',
//             stateCode: 'ON',
//             value: 'Ontario'
//         },
//         {
//             label: 'Prince Edward Island',
//             stateCode: 'PE',
//             value: 'Prince Edward Island'
//         },
//         {
//             label: 'Quebec',
//             stateCode: 'QC',
//             value: 'Quebec'
//         },
//         {
//             label: 'Saskatchewan',
//             stateCode: 'SK',
//             value: 'Saskatchewan'
//         },
//         {
//             label: 'Yukon',
//             stateCode: 'YT',
//             value: 'Yukon'
//         }
//     ],
//     CHE: [
//         {
//             label: 'Aargau',
//             stateCode: 'AG',
//             value: 'Aargau'
//         },
//         {
//             label: 'Inner-Rhoden',
//             stateCode: 'AI',
//             value: 'Inner-Rhoden'
//         },
//         {
//             label: 'Ausser-Rhoden',
//             stateCode: 'AR',
//             value: 'Ausser-Rhoden'
//         },
//         {
//             label: 'Bern',
//             stateCode: 'BE',
//             value: 'Bern'
//         },
//         {
//             label: 'Basel Land',
//             stateCode: 'BL',
//             value: 'Basel Land'
//         },
//         {
//             label: 'Basel Stadt',
//             stateCode: 'BS',
//             value: 'Basel Stadt'
//         },
//         {
//             label: 'Fribourg',
//             stateCode: 'FR',
//             value: 'Fribourg'
//         },
//         {
//             label: 'Genève',
//             stateCode: 'GE',
//             value: 'Genève'
//         },
//         {
//             label: 'Glarus',
//             stateCode: 'GL',
//             value: 'Glarus'
//         },
//         {
//             label: 'Graubuenden',
//             stateCode: 'GR',
//             value: 'Graubuenden'
//         },
//         {
//             label: 'Jura',
//             stateCode: 'JU',
//             value: 'Jura'
//         },
//         {
//             label: 'Luzern',
//             stateCode: 'LU',
//             value: 'Luzern'
//         },
//         {
//             label: 'Neuchatel',
//             stateCode: 'NE',
//             value: 'Neuchatel'
//         },
//         {
//             label: 'Nidwalden',
//             stateCode: 'NW',
//             value: 'Nidwalden'
//         },
//         {
//             label: 'Obwalden',
//             stateCode: 'OW',
//             value: 'Obwalden'
//         },
//         {
//             label: 'St. Gallen',
//             stateCode: 'SG',
//             value: 'St. Gallen'
//         },
//         {
//             label: 'Schaffhausen',
//             stateCode: 'SH',
//             value: 'Schaffhausen'
//         },
//         {
//             label: 'Solothurn',
//             stateCode: 'SO',
//             value: 'Solothurn'
//         },
//         {
//             label: 'Schwyz',
//             stateCode: 'SZ',
//             value: 'Schwyz'
//         },
//         {
//             label: 'Thurgau',
//             stateCode: 'TG',
//             value: 'Thurgau'
//         },
//         {
//             label: 'Ticino',
//             stateCode: 'TI',
//             value: 'Ticino'
//         },
//         {
//             label: 'Uri',
//             stateCode: 'UR',
//             value: 'Uri'
//         },
//         {
//             label: 'Vaud',
//             stateCode: 'VD',
//             value: 'Vaud'
//         },
//         {
//             label: 'Valais',
//             stateCode: 'VS',
//             value: 'Valais'
//         },
//         {
//             label: 'Zug',
//             stateCode: 'ZG',
//             value: 'Zug'
//         },
//         {
//             label: 'Zurich',
//             stateCode: 'ZH',
//             value: 'Zurich'
//         }
//     ],
//     CIV: [
//         {
//             label: 'Abidjan',
//             stateCode: 'AB',
//             value: 'Abidjan'
//         },
//         {
//             label: 'Bas-Sassandra',
//             stateCode: 'BS',
//             value: 'Bas-Sassandra'
//         },
//         {
//             label: 'Comoe',
//             stateCode: 'CM',
//             value: 'Comoe'
//         },
//         {
//             label: 'Denguele',
//             stateCode: 'DN',
//             value: 'Denguele'
//         },
//         {
//             label: 'Goh-Djiboua',
//             stateCode: 'GD',
//             value: 'Goh-Djiboua'
//         },
//         {
//             label: 'Lacs',
//             stateCode: 'LC',
//             value: 'Lacs'
//         },
//         {
//             label: 'Lagunes',
//             stateCode: 'LG',
//             value: 'Lagunes'
//         },
//         {
//             label: 'Montagnes',
//             stateCode: 'MG',
//             value: 'Montagnes'
//         },
//         {
//             label: 'Sassandra-Marahoue',
//             stateCode: 'SM',
//             value: 'Sassandra-Marahoue'
//         },
//         {
//             label: 'Savanes',
//             stateCode: 'SV',
//             value: 'Savanes'
//         },
//         {
//             label: 'Bandama Valley',
//             stateCode: 'VB',
//             value: 'Bandama Valley'
//         },
//         {
//             label: 'Woroba',
//             stateCode: 'WR',
//             value: 'Woroba'
//         },
//         {
//             label: 'Yamoussoukro',
//             stateCode: 'YM',
//             value: 'Yamoussoukro'
//         },
//         {
//             label: 'Zanzan',
//             stateCode: 'ZZ',
//             value: 'Zanzan'
//         }
//     ],
//     COL: [
//         {
//             label: 'Amazonia',
//             stateCode: 'AMA',
//             value: 'Amazonia'
//         },
//         {
//             label: 'Antioquia',
//             stateCode: 'ANT',
//             value: 'Antioquia'
//         },
//         {
//             label: 'Arauca',
//             stateCode: 'ARA',
//             value: 'Arauca'
//         },
//         {
//             label: 'Atlantico',
//             stateCode: 'ATL',
//             value: 'Atlantico'
//         },
//         {
//             label: 'Bolivar',
//             stateCode: 'BOL',
//             value: 'Bolivar'
//         },
//         {
//             label: 'Boyaca',
//             stateCode: 'BOY',
//             value: 'Boyaca'
//         },
//         {
//             label: 'Caldas',
//             stateCode: 'CAL',
//             value: 'Caldas'
//         },
//         {
//             label: 'Caqueta',
//             stateCode: 'CAQ',
//             value: 'Caqueta'
//         },
//         {
//             label: 'Casanare',
//             stateCode: 'CAS',
//             value: 'Casanare'
//         },
//         {
//             label: 'Cauca',
//             stateCode: 'CAU',
//             value: 'Cauca'
//         },
//         {
//             label: 'Cesar',
//             stateCode: 'CES',
//             value: 'Cesar'
//         },
//         {
//             label: 'Cordoba',
//             stateCode: 'COR',
//             value: 'Cordoba'
//         },
//         {
//             label: 'Cundinamarca',
//             stateCode: 'CUN',
//             value: 'Cundinamarca'
//         },
//         {
//             label: 'Choco',
//             stateCode: 'CHO',
//             value: 'Choco'
//         },
//         {
//             label: 'Bogota',
//             stateCode: 'DC',
//             value: 'Bogota'
//         },
//         {
//             label: 'Guainia',
//             stateCode: 'GUA',
//             value: 'Guainia'
//         },
//         {
//             label: 'Guaviare',
//             stateCode: 'GUV',
//             value: 'Guaviare'
//         },
//         {
//             label: 'Huila',
//             stateCode: 'HUI',
//             value: 'Huila'
//         },
//         {
//             label: 'La Guajira',
//             stateCode: 'LAG',
//             value: 'La Guajira'
//         },
//         {
//             label: 'Magdalena',
//             stateCode: 'MAG',
//             value: 'Magdalena'
//         },
//         {
//             label: 'Meta',
//             stateCode: 'MET',
//             value: 'Meta'
//         },
//         {
//             label: 'Narino',
//             stateCode: 'NAR',
//             value: 'Narino'
//         },
//         {
//             label: 'Norte Santander',
//             stateCode: 'NSA',
//             value: 'Norte Santander'
//         },
//         {
//             label: 'Putumayo',
//             stateCode: 'PUT',
//             value: 'Putumayo'
//         },
//         {
//             label: 'Quindio',
//             stateCode: 'QUI',
//             value: 'Quindio'
//         },
//         {
//             label: 'Risaralda',
//             stateCode: 'RIS',
//             value: 'Risaralda'
//         },
//         {
//             label: 'San Andres',
//             stateCode: 'SAP',
//             value: 'San Andres'
//         },
//         {
//             label: 'Santander',
//             stateCode: 'SAN',
//             value: 'Santander'
//         },
//         {
//             label: 'Sucre',
//             stateCode: 'SUC',
//             value: 'Sucre'
//         },
//         {
//             label: 'Tolima',
//             stateCode: 'TOL',
//             value: 'Tolima'
//         },
//         {
//             label: 'Valle',
//             stateCode: 'VAC',
//             value: 'Valle'
//         },
//         {
//             label: 'Vaupes',
//             stateCode: 'VAU',
//             value: 'Vaupes'
//         },
//         {
//             label: 'Vichada',
//             stateCode: 'VID',
//             value: 'Vichada'
//         }
//     ],
//     CYP: [
//         {
//             label: 'Nicosia',
//             stateCode: '01',
//             value: 'Nicosia'
//         },
//         {
//             label: 'Limassol',
//             stateCode: '02',
//             value: 'Limassol'
//         },
//         {
//             label: 'Larnaca',
//             stateCode: '03',
//             value: 'Larnaca'
//         },
//         {
//             label: 'Famagusta',
//             stateCode: '04',
//             value: 'Famagusta'
//         },
//         {
//             label: 'Paphos',
//             stateCode: '05',
//             value: 'Paphos'
//         },
//         {
//             label: 'Kyrenia',
//             stateCode: '06',
//             value: 'Kyrenia'
//         }
//     ],
//     CZE: [
//         {
//             label: 'South Bohemia',
//             stateCode: '31',
//             value: 'South Bohemia'
//         },
//         {
//             label: 'South Moravia',
//             stateCode: '64',
//             value: 'South Moravia'
//         },
//         {
//             label: 'Karlovy Vary',
//             stateCode: '41',
//             value: 'Karlovy Vary'
//         },
//         {
//             label: 'Hradec Kralove',
//             stateCode: '52',
//             value: 'Hradec Kralove'
//         },
//         {
//             label: 'Liberec',
//             stateCode: '51',
//             value: 'Liberec'
//         },
//         {
//             label: 'Moravia-Silesia',
//             stateCode: '80',
//             value: 'Moravia-Silesia'
//         },
//         {
//             label: 'Olomouc',
//             stateCode: '71',
//             value: 'Olomouc'
//         },
//         {
//             label: 'Pardubice',
//             stateCode: '53',
//             value: 'Pardubice'
//         },
//         {
//             label: 'Plzen',
//             stateCode: '32',
//             value: 'Plzen'
//         },
//         {
//             label: 'Prague',
//             stateCode: '10',
//             value: 'Prague'
//         },
//         {
//             label: 'Central Bohemia',
//             stateCode: '20',
//             value: 'Central Bohemia'
//         },
//         {
//             label: 'Usti and Labem',
//             stateCode: '42',
//             value: 'Usti and Labem'
//         },
//         {
//             label: 'Vysocina',
//             stateCode: '63',
//             value: 'Vysocina'
//         },
//         {
//             label: 'Zlin',
//             stateCode: '72',
//             value: 'Zlin'
//         }
//     ],
//     DEU: [
//         {
//             label: 'Baden-Wurttemberg',
//             stateCode: 'BW',
//             value: 'Baden-Wurttemberg'
//         },
//         {
//             label: 'Bavaria',
//             stateCode: 'BY',
//             value: 'Bavaria'
//         },
//         {
//             label: 'Berlin',
//             stateCode: 'BE',
//             value: 'Berlin'
//         },
//         {
//             label: 'Brandenburg',
//             stateCode: 'BB',
//             value: 'Brandenburg'
//         },
//         {
//             label: 'Bremen',
//             stateCode: 'HB',
//             value: 'Bremen'
//         },
//         {
//             label: 'Hamburg',
//             stateCode: 'HH',
//             value: 'Hamburg'
//         },
//         {
//             label: 'Hesse',
//             stateCode: 'HE',
//             value: 'Hesse'
//         },
//         {
//             label: 'Mecklenburg-Vorpomm.',
//             stateCode: 'MV',
//             value: 'Mecklenburg-Vorpomm.'
//         },
//         {
//             label: 'Lower Saxony',
//             stateCode: 'NI',
//             value: 'Lower Saxony'
//         },
//         {
//             label: 'North Rhine-Westphalia',
//             stateCode: 'NW',
//             value: 'North Rhine-Westphalia'
//         },
//         {
//             label: 'Rhineland Palatinate',
//             stateCode: 'RP',
//             value: 'Rhineland Palatinate'
//         },
//         {
//             label: 'Saarland',
//             stateCode: 'SL',
//             value: 'Saarland'
//         },
//         {
//             label: 'Saxony',
//             stateCode: 'SN',
//             value: 'Saxony'
//         },
//         {
//             label: 'Saxony-Anhalt',
//             stateCode: 'ST',
//             value: 'Saxony-Anhalt'
//         },
//         {
//             label: 'Schleswig-Hoistein',
//             stateCode: 'SH',
//             value: 'Schleswig-Hoistein'
//         },
//         {
//             label: 'Thuringia',
//             stateCode: 'TH',
//             value: 'Thuringia'
//         }
//     ],
//     DNK: [
//         {
//             label: 'Capital Region',
//             stateCode: '84',
//             value: 'Capital Region'
//         },
//         {
//             label: 'Central Demark',
//             stateCode: '82',
//             value: 'Central Demark'
//         },
//         {
//             label: 'North Demark',
//             stateCode: '81',
//             value: 'North Demark'
//         },
//         {
//             label: 'Zealand',
//             stateCode: '85',
//             value: 'Zealand'
//         },
//         {
//             label: 'Southern Denmark',
//             stateCode: '83',
//             value: 'Southern Denmark'
//         }
//     ],
//     EGY: [
//         {
//             label: 'Alexandria',
//             stateCode: 'ALX',
//             value: 'Alexandria'
//         },
//         {
//             label: 'Aswan',
//             stateCode: 'ASN',
//             value: 'Aswan'
//         },
//         {
//             label: 'Asyut',
//             stateCode: 'AST',
//             value: 'Asyut'
//         },
//         {
//             label: 'Red Sea',
//             stateCode: 'BA',
//             value: 'Red Sea'
//         },
//         {
//             label: 'Beheira',
//             stateCode: 'BH',
//             value: 'Beheira'
//         },
//         {
//             label: 'Beni Suef',
//             stateCode: 'BNS',
//             value: 'Beni Suef'
//         },
//         {
//             label: 'Cairo',
//             stateCode: 'C',
//             value: 'Cairo'
//         },
//         {
//             label: 'Dakahlia',
//             stateCode: 'DK',
//             value: 'Dakahlia'
//         },
//         {
//             label: 'Damietta',
//             stateCode: 'DT',
//             value: 'Damietta'
//         },
//         {
//             label: 'Faiyum',
//             stateCode: 'FYM',
//             value: 'Faiyum'
//         },
//         {
//             label: 'Gharbia',
//             stateCode: 'GH',
//             value: 'Gharbia'
//         },
//         {
//             label: 'Giza',
//             stateCode: 'GZ',
//             value: 'Giza'
//         },
//         {
//             label: 'Ismailia',
//             stateCode: 'IS',
//             value: 'Ismailia'
//         },
//         {
//             label: 'South Sinai',
//             stateCode: 'JS',
//             value: 'South Sinai'
//         },
//         {
//             label: 'Qalyubia',
//             stateCode: 'KB',
//             value: 'Qalyubia'
//         },
//         {
//             label: 'Kafr El Sheikh',
//             stateCode: 'KFS',
//             value: 'Kafr El Sheikh'
//         },
//         {
//             label: 'Qena',
//             stateCode: 'KN',
//             value: 'Qena'
//         },
//         {
//             label: 'Luxor',
//             stateCode: 'LX',
//             value: 'Luxor'
//         },
//         {
//             label: 'Minya',
//             stateCode: 'MN',
//             value: 'Minya'
//         },
//         {
//             label: 'Monufia',
//             stateCode: 'MNF',
//             value: 'Monufia'
//         },
//         {
//             label: 'Matruh',
//             stateCode: 'MT',
//             value: 'Matruh'
//         },
//         {
//             label: 'Port Said',
//             stateCode: 'PTS',
//             value: 'Port Said'
//         },
//         {
//             label: 'Sohag',
//             stateCode: 'SHG',
//             value: 'Sohag'
//         },
//         {
//             label: 'Sharqia',
//             stateCode: 'SHR',
//             value: 'Sharqia'
//         },
//         {
//             label: 'North Sinai',
//             stateCode: 'SIN',
//             value: 'North Sinai'
//         },
//         {
//             label: 'Suez',
//             stateCode: 'SUZ',
//             value: 'Suez'
//         },
//         {
//             label: 'New Valley',
//             stateCode: 'WAD',
//             value: 'New Valley'
//         }
//     ],
//     ESP: [
//         {
//             label: 'Andalusia',
//             stateCode: 'AN',
//             value: 'Andalusia'
//         },
//         {
//             label: 'Aragon',
//             stateCode: 'AR',
//             value: 'Aragon'
//         },
//         {
//             label: 'Principality of Asturias',
//             stateCode: 'AS',
//             value: 'Principality of Asturias'
//         },
//         {
//             label: 'Canary Islands',
//             stateCode: 'CN',
//             value: 'Canary Islands'
//         },
//         {
//             label: 'Cantabria',
//             stateCode: 'CB',
//             value: 'Cantabria'
//         },
//         {
//             label: 'Castilla y Leon',
//             stateCode: 'CL',
//             value: 'Castilla y Leon'
//         },
//         {
//             label: 'Castilla-La Mancha',
//             stateCode: 'CM',
//             value: 'Castilla-La Mancha'
//         },
//         {
//             label: 'Catalonia',
//             stateCode: 'CT',
//             value: 'Catalonia'
//         },
//         {
//             label: 'Ceuta',
//             stateCode: 'CE',
//             value: 'Ceuta'
//         },
//         {
//             label: 'Extremadura',
//             stateCode: 'EX',
//             value: 'Extremadura'
//         },
//         {
//             label: 'Galicia',
//             stateCode: 'GA',
//             value: 'Galicia'
//         },
//         {
//             label: 'Balearic Islands',
//             stateCode: 'IB',
//             value: 'Balearic Islands'
//         },
//         {
//             label: 'La Rioja',
//             stateCode: 'RI',
//             value: 'La Rioja'
//         },
//         {
//             label: 'Community of Madrid',
//             stateCode: 'MD',
//             value: 'Community of Madrid'
//         },
//         {
//             label: 'Melilla',
//             stateCode: 'ML',
//             value: 'Melilla'
//         },
//         {
//             label: 'Region of Murcia',
//             stateCode: 'MC',
//             value: 'Region of Murcia'
//         },
//         {
//             label: 'Chartered Community of Navarre',
//             stateCode: 'NC',
//             value: 'Chartered Community of Navarre'
//         },
//         {
//             label: 'Basque Country',
//             stateCode: 'PV',
//             value: 'Basque Country'
//         },
//         {
//             label: 'Valencian Community',
//             stateCode: 'VC',
//             value: 'Valencian Community'
//         }
//     ],
//     EST: [
//         {
//             label: 'Harju',
//             stateCode: '37',
//             value: 'Harju'
//         },
//         {
//             label: 'Hiiu',
//             stateCode: '39',
//             value: 'Hiiu'
//         },
//         {
//             label: 'Ida-Viru',
//             stateCode: '44',
//             value: 'Ida-Viru'
//         },
//         {
//             label: 'Jogeva',
//             stateCode: '49',
//             value: 'Jogeva'
//         },
//         {
//             label: 'Jarva',
//             stateCode: '51',
//             value: 'Jarva'
//         },
//         {
//             label: 'Laane',
//             stateCode: '56',
//             value: 'Laane'
//         },
//         {
//             label: 'Laane-Viru',
//             stateCode: '60',
//             value: 'Laane-Viru'
//         },
//         {
//             label: 'Polva',
//             stateCode: '64',
//             value: 'Polva'
//         },
//         {
//             label: 'Parnu',
//             stateCode: '68',
//             value: 'Parnu'
//         },
//         {
//             label: 'Rapla',
//             stateCode: '71',
//             value: 'Rapla'
//         },
//         {
//             label: 'Saare',
//             stateCode: '74',
//             value: 'Saare'
//         },
//         {
//             label: 'Tartu',
//             stateCode: '79',
//             value: 'Tartu'
//         },
//         {
//             label: 'Valga',
//             stateCode: '81',
//             value: 'Valga'
//         },
//         {
//             label: 'Vijandi',
//             stateCode: '84',
//             value: 'Vijandi'
//         },
//         {
//             label: 'Voru',
//             stateCode: '87',
//             value: 'Voru'
//         }
//     ],
//     FIN: [
//         {
//             label: 'Aland',
//             stateCode: '01',
//             value: 'Aland'
//         },
//         {
//             label: 'South Karelia',
//             stateCode: '02',
//             value: 'South Karelia'
//         },
//         {
//             label: 'Southern Ostrobothni',
//             stateCode: '03',
//             value: 'Southern Ostrobothni'
//         },
//         {
//             label: 'Southern Savonia',
//             stateCode: '04',
//             value: 'Southern Savonia'
//         },
//         {
//             label: 'Kainuu',
//             stateCode: '05',
//             value: 'Kainuu'
//         },
//         {
//             label: 'Tavastia Proper',
//             stateCode: '06',
//             value: 'Tavastia Proper'
//         },
//         {
//             label: 'Central Ostrobothnia',
//             stateCode: '07',
//             value: 'Central Ostrobothnia'
//         },
//         {
//             label: 'Central Finland',
//             stateCode: '08',
//             value: 'Central Finland'
//         },
//         {
//             label: 'Kymenlaakso',
//             stateCode: '09',
//             value: 'Kymenlaakso'
//         },
//         {
//             label: 'Lapland',
//             stateCode: '10',
//             value: 'Lapland'
//         },
//         {
//             label: 'Pirkanmaa',
//             stateCode: '11',
//             value: 'Pirkanmaa'
//         },
//         {
//             label: 'Ostrobothnia',
//             stateCode: '12',
//             value: 'Ostrobothnia'
//         },
//         {
//             label: 'North Karelia',
//             stateCode: '13',
//             value: 'North Karelia'
//         },
//         {
//             label: 'North. Ostrobothnia',
//             stateCode: '14',
//             value: 'North. Ostrobothnia'
//         },
//         {
//             label: 'Northern Savonia',
//             stateCode: '15',
//             value: 'Northern Savonia'
//         },
//         {
//             label: 'Paijanne Tavastia',
//             stateCode: '16',
//             value: 'Paijanne Tavastia'
//         },
//         {
//             label: 'Satakunta',
//             stateCode: '17',
//             value: 'Satakunta'
//         },
//         {
//             label: 'Uusimaa',
//             stateCode: '18',
//             value: 'Uusimaa'
//         },
//         {
//             label: 'Finland Proper',
//             stateCode: '19',
//             value: 'Finland Proper'
//         }
//     ],
//     FRA: [
//         {
//             label: 'Ain',
//             stateCode: '01',
//             value: 'Ain'
//         },
//         {
//             label: 'Aisne',
//             stateCode: '02',
//             value: 'Aisne'
//         },
//         {
//             label: 'Allier',
//             stateCode: '03',
//             value: 'Allier'
//         },
//         {
//             label: 'Alpes-de-Haute-Provence',
//             stateCode: '04',
//             value: 'Alpes-de-Haute-Provence'
//         },
//         {
//             label: 'Hautes-Alpes',
//             stateCode: '05',
//             value: 'Hautes-Alpes'
//         },
//         {
//             label: 'Alpes-Maritimes',
//             stateCode: '06',
//             value: 'Alpes-Maritimes'
//         },
//         {
//             label: 'Alsace',
//             stateCode: '6AE',
//             value: 'Alsace'
//         },
//         {
//             label: 'Ardeche',
//             stateCode: '07',
//             value: 'Ardeche'
//         },
//         {
//             label: 'Ardennes',
//             stateCode: '08',
//             value: 'Ardennes'
//         },
//         {
//             label: 'Ariege',
//             stateCode: '09',
//             value: 'Ariege'
//         },
//         {
//             label: 'Aube',
//             stateCode: '10',
//             value: 'Aube'
//         },
//         {
//             label: 'Aude',
//             stateCode: '11',
//             value: 'Aude'
//         },
//         {
//             label: 'Aveyron',
//             stateCode: '12',
//             value: 'Aveyron'
//         },
//         {
//             label: 'Bouches-du-Rhone',
//             stateCode: '13',
//             value: 'Bouches-du-Rhone'
//         },
//         {
//             label: 'Calvados',
//             stateCode: '14',
//             value: 'Calvados'
//         },
//         {
//             label: 'Cantal',
//             stateCode: '15',
//             value: 'Cantal'
//         },
//         {
//             label: 'Charente',
//             stateCode: '16',
//             value: 'Charente'
//         },
//         {
//             label: 'Charente-Maritime',
//             stateCode: '17',
//             value: 'Charente-Maritime'
//         },
//         {
//             label: 'Cher',
//             stateCode: '18',
//             value: 'Cher'
//         },
//         {
//             label: 'Correze',
//             stateCode: '19',
//             value: 'Correze'
//         },
//         {
//             label: 'Calvados',
//             stateCode: '14',
//             value: 'Calvados'
//         },
//         {
//             label: 'Cantal',
//             stateCode: '15',
//             value: 'Cantal'
//         },
//         {
//             label: 'Charente',
//             stateCode: '16',
//             value: 'Charente'
//         },
//         {
//             label: 'Charente-Maritime',
//             stateCode: '17',
//             value: 'Charente-Maritime'
//         },
//         {
//             label: 'Cher',
//             stateCode: '18',
//             value: 'Cher'
//         },
//         {
//             label: 'Correze',
//             stateCode: '19',
//             value: 'Correze'
//         },
//         {
//             label: "Cote-d'Or",
//             stateCode: '21',
//             value: "Cote-d'Or"
//         },
//         {
//             label: "Cotes-d'Armor",
//             stateCode: '22',
//             value: "Cotes-d'Armor"
//         },
//         {
//             label: 'Creuse',
//             stateCode: '23',
//             value: 'Creuse'
//         },
//         {
//             label: 'Dordogne',
//             stateCode: '24',
//             value: 'Dordogne'
//         },
//         {
//             label: 'Doubs',
//             stateCode: '25',
//             value: 'Doubs'
//         },
//         {
//             label: 'Drome',
//             stateCode: '26',
//             value: 'Drome'
//         },
//         {
//             label: 'Essonne',
//             stateCode: '91',
//             value: 'Essonne'
//         },
//         {
//             label: 'Eure',
//             stateCode: '27',
//             value: 'Eure'
//         },
//         {
//             label: 'Eure-et-Loir',
//             stateCode: '28',
//             value: 'Eure-et-Loir'
//         },
//         {
//             label: 'Finistere',
//             stateCode: '29',
//             value: 'Finistere'
//         },
//         {
//             label: 'Corse-du-Sud',
//             stateCode: '2A',
//             value: 'Corse-du-Sud'
//         },
//         {
//             label: 'Haute-Corse',
//             stateCode: '2B',
//             value: 'Haute-Corse'
//         },
//         {
//             label: 'Gard',
//             stateCode: '30',
//             value: 'Gard'
//         },
//         {
//             label: 'Haute-Garonne',
//             stateCode: '31',
//             value: 'Haute-Garonne'
//         },
//         {
//             label: 'Gers',
//             stateCode: '32',
//             value: 'Gers'
//         },
//         {
//             label: 'Gironde',
//             stateCode: '33',
//             value: 'Gironde'
//         },
//         {
//             label: 'Herault',
//             stateCode: '34',
//             value: 'Herault'
//         },
//         {
//             label: 'Ille-et-Vilaine',
//             stateCode: '35',
//             value: 'Ille-et-Vilaine'
//         },
//         {
//             label: 'Indre',
//             stateCode: '36',
//             value: 'Indre'
//         },
//         {
//             label: 'Indre-et-Loire',
//             stateCode: '37',
//             value: 'Indre-et-Loire'
//         },
//         {
//             label: 'Isere',
//             stateCode: '38',
//             value: 'Isere'
//         },
//         {
//             label: 'Jura',
//             stateCode: '39',
//             value: 'Jura'
//         },
//         {
//             label: 'Landes',
//             stateCode: '40',
//             value: 'Landes'
//         },
//         {
//             label: 'Loir-et-Cher',
//             stateCode: '41',
//             value: 'Loir-et-Cher'
//         },
//         {
//             label: 'Loire',
//             stateCode: '42',
//             value: 'Loire'
//         },
//         {
//             label: 'Haute-Loire',
//             stateCode: '43',
//             value: 'Haute-Loire'
//         },
//         {
//             label: 'Loire-Atlantique',
//             stateCode: '44',
//             value: 'Loire-Atlantique'
//         },
//         {
//             label: 'Loiret',
//             stateCode: '45',
//             value: 'Loiret'
//         },
//         {
//             label: 'Lot',
//             stateCode: '46',
//             value: 'Lot'
//         },
//         {
//             label: 'Lot-et-Garonne',
//             stateCode: '47',
//             value: 'Lot-et-Garonne'
//         },
//         {
//             label: 'Lozere',
//             stateCode: '48',
//             value: 'Lozere'
//         },
//         {
//             label: 'Maine-et-Loire',
//             stateCode: '49',
//             value: 'Maine-et-Loire'
//         },
//         {
//             label: 'Manche',
//             stateCode: '50',
//             value: 'Manche'
//         },
//         {
//             label: 'Marne',
//             stateCode: '51',
//             value: 'Marne'
//         },
//         {
//             label: 'Haute-Marne',
//             stateCode: '52',
//             value: 'Haute-Marne'
//         },
//         {
//             label: 'Mayenne',
//             stateCode: '53',
//             value: 'Mayenne'
//         },
//         {
//             label: 'Meurthe-et-Moselle',
//             stateCode: '54',
//             value: 'Meurthe-et-Moselle'
//         },
//         {
//             label: 'Meuse',
//             stateCode: '55',
//             value: 'Meuse'
//         },
//         {
//             label: 'Morbihan',
//             stateCode: '56',
//             value: 'Morbihan'
//         },
//         {
//             label: 'Moselle',
//             stateCode: '57',
//             value: 'Moselle'
//         },
//         {
//             label: 'Nievre',
//             stateCode: '58',
//             value: 'Nievre'
//         },
//         {
//             label: 'Nord',
//             stateCode: '59',
//             value: 'Nord'
//         },
//         {
//             label: 'Oise',
//             stateCode: '60',
//             value: 'Oise'
//         },
//         {
//             label: 'Orne',
//             stateCode: '61',
//             value: 'Orne'
//         },
//         {
//             label: 'Pas-de-Calais',
//             stateCode: '62',
//             value: 'Pas-de-Calais'
//         },
//         {
//             label: 'Puy-de-Dome',
//             stateCode: '63',
//             value: 'Puy-de-Dome'
//         },
//         {
//             label: 'Pyrenees-Atlantiques',
//             stateCode: '64',
//             value: 'Pyrenees-Atlantiques'
//         },
//         {
//             label: 'Haute-Pyrenees',
//             stateCode: '65',
//             value: 'Haute-Pyrenees'
//         },
//         {
//             label: 'Pyrenees-Orientales',
//             stateCode: '66',
//             value: 'Pyrenees-Orientales'
//         },
//         {
//             label: 'Rhone',
//             stateCode: '69',
//             value: 'Rhone'
//         },
//         {
//             label: 'Haute-Saone',
//             stateCode: '70',
//             value: 'Haute-Saone'
//         },
//         {
//             label: 'Saone-et-Loire',
//             stateCode: '71',
//             value: 'Saone-et-Loire'
//         },
//         {
//             label: 'Sarthe',
//             stateCode: '72',
//             value: 'Sarthe'
//         },
//         {
//             label: 'Savoie',
//             stateCode: '73',
//             value: 'Savoie'
//         },
//         {
//             label: 'Haute-Savoie',
//             stateCode: '74',
//             value: 'Haute-Savoie'
//         },
//         {
//             label: 'Paris City',
//             stateCode: '75C',
//             value: 'Paris City'
//         },
//         {
//             label: 'Seine-Maritime',
//             stateCode: '76',
//             value: 'Seine-Maritime'
//         },
//         {
//             label: 'Seine-et-Marne',
//             stateCode: '77',
//             value: 'Seine-et-Marne'
//         },
//         {
//             label: 'Yvelines',
//             stateCode: '78',
//             value: 'Yvelines'
//         },
//         {
//             label: 'Deux-Sevres',
//             stateCode: '79',
//             value: 'Deux-Sevres'
//         },
//         {
//             label: 'Somme',
//             stateCode: '80',
//             value: 'Somme'
//         },
//         {
//             label: 'Tarn',
//             stateCode: '81',
//             value: 'Tarn'
//         },
//         {
//             label: 'Tarn-et-Garonne',
//             stateCode: '82',
//             value: 'Tarn-et-Garonne'
//         },
//         {
//             label: 'Var',
//             stateCode: '83',
//             value: 'Var'
//         },
//         {
//             label: 'Vaucluse',
//             stateCode: '84',
//             value: 'Vaucluse'
//         },
//         {
//             label: 'Vendee',
//             stateCode: '85',
//             value: 'Vendee'
//         },
//         {
//             label: 'Vienne',
//             stateCode: '86',
//             value: 'Vienne'
//         },
//         {
//             label: 'Haute-Vienne',
//             stateCode: '87',
//             value: 'Haute-Vienne'
//         },
//         {
//             label: 'Vosges',
//             stateCode: '88',
//             value: 'Vosges'
//         },
//         {
//             label: 'Yonne',
//             stateCode: '89',
//             value: 'Yonne'
//         },
//         {
//             label: 'Territ.-de-Belfort',
//             stateCode: '90',
//             value: 'Territ.-de-Belfort'
//         },
//         {
//             label: 'Hauts-de-Seine',
//             stateCode: '92',
//             value: 'Hauts-de-Seine'
//         },
//         {
//             label: 'Seine-Saint-Denis',
//             stateCode: '93',
//             value: 'Seine-Saint-Denis'
//         },
//         {
//             label: 'Val-de-Marne',
//             stateCode: '94',
//             value: 'Val-de-Marne'
//         },
//         {
//             label: "Val-d'Oise",
//             stateCode: '95',
//             value: "Val-d'Oise"
//         },
//         {
//             label: 'Guadeloupe',
//             stateCode: '971',
//             value: 'Guadeloupe'
//         },
//         {
//             label: 'Martinique',
//             stateCode: '972',
//             value: 'Martinique'
//         },
//         {
//             label: 'Guyane',
//             stateCode: '973',
//             value: 'Guyane'
//         },
//         {
//             label: 'La Reunion',
//             stateCode: '974',
//             value: 'La Reunion'
//         },
//         {
//             label: 'Mayotte',
//             stateCode: '976',
//             value: 'Mayotte'
//         },
//         {
//             label: 'Bas-Rhin',
//             stateCode: '67',
//             value: 'Bas-Rhin'
//         },
//         {
//             label: 'Haut-Rhin',
//             stateCode: '68',
//             value: 'Haut-Rhin'
//         },
//         {
//             label: 'Saint Barthelemy',
//             stateCode: 'BL',
//             value: 'Saint Barthelemy'
//         },
//         {
//             label: 'Saint Martin',
//             stateCode: 'MF',
//             value: 'Saint Martin'
//         },
//         {
//             label: 'French South. Terr.',
//             stateCode: 'TF',
//             value: 'French South. Terr.'
//         },
//         {
//             label: 'Wallis-et-Futuna',
//             stateCode: 'WF',
//             value: 'Wallis-et-Futuna'
//         },
//         {
//             label: 'French Polynesia',
//             stateCode: 'PF',
//             value: 'French Polynesia'
//         },
//         {
//             label: 'New Caledonia',
//             stateCode: 'NC',
//             value: 'New Caledonia'
//         },
//         {
//             label: 'Clipperton',
//             stateCode: 'CP',
//             value: 'Clipperton'
//         },
//         {
//             label: 'Saint-Pierre-et-Miquelon',
//             stateCode: 'PM',
//             value: 'Saint-Pierre-et-Miquelon'
//         }
//     ],
//     FRO: [
//         {
//             label: 'NULL',
//             stateCode: 'NULL',
//             value: 'NULL'
//         }
//     ],
//     GBR: [
//         {
//             label: 'Armagh City, Banbridge and Craigavon',
//             stateCode: 'ABC',
//             value: 'Armagh City, Banbridge and Craigavon'
//         },
//         {
//             label: 'Aberdeenshire',
//             stateCode: 'ABD',
//             value: 'Aberdeenshire'
//         },
//         {
//             label: 'City of Aberdeen',
//             stateCode: 'ABE',
//             value: 'City of Aberdeen'
//         },
//         {
//             label: 'Argyll and Bute',
//             stateCode: 'AGB',
//             value: 'Argyll and Bute'
//         },
//         {
//             label: 'Isle of Anglesey',
//             stateCode: 'AGY',
//             value: 'Isle of Anglesey'
//         },
//         {
//             label: 'Ards and North Down',
//             stateCode: 'AND',
//             value: 'Ards and North Down'
//         },
//         {
//             label: 'Antrim and Newtownabbey',
//             stateCode: 'ANN',
//             value: 'Antrim and Newtownabbey'
//         },
//         {
//             label: 'Angus',
//             stateCode: 'ANS',
//             value: 'Angus'
//         },
//         {
//             label: 'Bath and North East Somerset',
//             stateCode: 'BAS',
//             value: 'Bath and North East Somerset'
//         },
//         {
//             label: 'Blackburn with Darwen',
//             stateCode: 'BBD',
//             value: 'Blackburn with Darwen'
//         },
//         {
//             label: 'Bournemouth, Christchurch and Poole',
//             stateCode: 'BCP',
//             value: 'Bournemouth, Christchurch and Poole'
//         },
//         {
//             label: 'Bedford',
//             stateCode: 'BDF',
//             value: 'Bedford'
//         },
//         {
//             label: 'Barking and Dagenham',
//             stateCode: 'BDG',
//             value: 'Barking and Dagenham'
//         },
//         {
//             label: 'Brent',
//             stateCode: 'BEN',
//             value: 'Brent'
//         },
//         {
//             label: 'Bexley',
//             stateCode: 'BEX',
//             value: 'Bexley'
//         },
//         {
//             label: 'Belfast',
//             stateCode: 'BFS',
//             value: 'Belfast'
//         },
//         {
//             label: 'Bridgend',
//             stateCode: 'BGE',
//             value: 'Bridgend'
//         },
//         {
//             label: 'Blaenau Gwent',
//             stateCode: 'BGW',
//             value: 'Blaenau Gwent'
//         },
//         {
//             label: 'Birmingham',
//             stateCode: 'BIR',
//             value: 'Birmingham'
//         },
//         {
//             label: 'Buckinghamshire',
//             stateCode: 'BKM',
//             value: 'Buckinghamshire'
//         },
//         {
//             label: 'Barnet',
//             stateCode: 'BNE',
//             value: 'Barnet'
//         },
//         {
//             label: 'Brighton and Hove',
//             stateCode: 'BNH',
//             value: 'Brighton and Hove'
//         },
//         {
//             label: 'Barnsley',
//             stateCode: 'BNS',
//             value: 'Barnsley'
//         },
//         {
//             label: 'Bolton',
//             stateCode: 'BOL',
//             value: 'Bolton'
//         },
//         {
//             label: 'Blackpool',
//             stateCode: 'BPL',
//             value: 'Blackpool'
//         },
//         {
//             label: 'Bracknell Forest',
//             stateCode: 'BRC',
//             value: 'Bracknell Forest'
//         },
//         {
//             label: 'Bradford',
//             stateCode: 'BRD',
//             value: 'Bradford'
//         },
//         {
//             label: 'Bromley',
//             stateCode: 'BRY',
//             value: 'Bromley'
//         },
//         {
//             label: 'City of Bristol',
//             stateCode: 'BST',
//             value: 'City of Bristol'
//         },
//         {
//             label: 'Bury',
//             stateCode: 'BUR',
//             value: 'Bury'
//         },
//         {
//             label: 'Cambridgeshire',
//             stateCode: 'CAM',
//             value: 'Cambridgeshire'
//         },
//         {
//             label: 'Caerphilly',
//             stateCode: 'CAY',
//             value: 'Caerphilly'
//         },
//         {
//             label: 'Central Bedfordshire',
//             stateCode: 'CBF',
//             value: 'Central Bedfordshire'
//         },
//         {
//             label: 'Causeway Coast and Glens',
//             stateCode: 'CCG',
//             value: 'Causeway Coast and Glens'
//         },
//         {
//             label: 'Ceredigion',
//             stateCode: 'CGN',
//             value: 'Ceredigion'
//         },
//         {
//             label: 'Cheshire East',
//             stateCode: 'CHE',
//             value: 'Cheshire East'
//         },
//         {
//             label: 'Cheshire W and Chester',
//             stateCode: 'CHW',
//             value: 'Cheshire W and Chester'
//         },
//         {
//             label: 'Calderdale',
//             stateCode: 'CLD',
//             value: 'Calderdale'
//         },
//         {
//             label: 'Clackmannanshire',
//             stateCode: 'CLK',
//             value: 'Clackmannanshire'
//         },
//         {
//             label: 'Cumbria',
//             stateCode: 'CMA',
//             value: 'Cumbria'
//         },
//         {
//             label: 'Camden',
//             stateCode: 'CMD',
//             value: 'Camden'
//         },
//         {
//             label: 'Carmarthenshire',
//             stateCode: 'CMN',
//             value: 'Carmarthenshire'
//         },
//         {
//             label: 'Cornwall',
//             stateCode: 'CON',
//             value: 'Cornwall'
//         },
//         {
//             label: 'Coventry',
//             stateCode: 'COV',
//             value: 'Coventry'
//         },
//         {
//             label: 'Cardiff',
//             stateCode: 'CRF',
//             value: 'Cardiff'
//         },
//         {
//             label: 'Croydon',
//             stateCode: 'CRY',
//             value: 'Croydon'
//         },
//         {
//             label: 'Conwy',
//             stateCode: 'CWY',
//             value: 'Conwy'
//         },
//         {
//             label: 'Darlington',
//             stateCode: 'DAL',
//             value: 'Darlington'
//         },
//         {
//             label: 'Derbyshire',
//             stateCode: 'DBY',
//             value: 'Derbyshire'
//         },
//         {
//             label: 'Denbighshire',
//             stateCode: 'DEN',
//             value: 'Denbighshire'
//         },
//         {
//             label: 'Derby',
//             stateCode: 'DER',
//             value: 'Derby'
//         },
//         {
//             label: 'Devon',
//             stateCode: 'DEV',
//             value: 'Devon'
//         },
//         {
//             label: 'Dumfries and Galloway',
//             stateCode: 'DGY',
//             value: 'Dumfries and Galloway'
//         },
//         {
//             label: 'Doncaster',
//             stateCode: 'DNC',
//             value: 'Doncaster'
//         },
//         {
//             label: 'City of Dundee',
//             stateCode: 'DND',
//             value: 'City of Dundee'
//         },
//         {
//             label: 'Dorset',
//             stateCode: 'DOR',
//             value: 'Dorset'
//         },
//         {
//             label: 'Derry and Strabane',
//             stateCode: 'DRS',
//             value: 'Derry and Strabane'
//         },
//         {
//             label: 'Dudley',
//             stateCode: 'DUD',
//             value: 'Dudley'
//         },
//         {
//             label: 'County Durham',
//             stateCode: 'DUR',
//             value: 'County Durham'
//         },
//         {
//             label: 'Ealing',
//             stateCode: 'EAL',
//             value: 'Ealing'
//         },
//         {
//             label: 'East Ayrshire',
//             stateCode: 'EAY',
//             value: 'East Ayrshire'
//         },
//         {
//             label: 'Edinburgh',
//             stateCode: 'EDH',
//             value: 'Edinburgh'
//         },
//         {
//             label: 'East Dunbartonshire',
//             stateCode: 'EDU',
//             value: 'East Dunbartonshire'
//         },
//         {
//             label: 'East Lothian',
//             stateCode: 'ELN',
//             value: 'East Lothian'
//         },
//         {
//             label: 'Eilean Siar',
//             stateCode: 'ELS',
//             value: 'Eilean Siar'
//         },
//         {
//             label: 'Enfield',
//             stateCode: 'ENF',
//             value: 'Enfield'
//         },
//         {
//             label: 'East Renfrewshire',
//             stateCode: 'ERW',
//             value: 'East Renfrewshire'
//         },
//         {
//             label: 'East Riding of Yorkshire',
//             stateCode: 'ERY',
//             value: 'East Riding of Yorkshire'
//         },
//         {
//             label: 'Essex',
//             stateCode: 'ESS',
//             value: 'Essex'
//         },
//         {
//             label: 'East Sussex',
//             stateCode: 'ESX',
//             value: 'East Sussex'
//         },
//         {
//             label: 'Falkirk',
//             stateCode: 'FAL',
//             value: 'Falkirk'
//         },
//         {
//             label: 'Fife',
//             stateCode: 'FIF',
//             value: 'Fife'
//         },
//         {
//             label: 'Flintshire',
//             stateCode: 'FLN',
//             value: 'Flintshire'
//         },
//         {
//             label: 'Fermanagh and Omagh',
//             stateCode: 'FMO',
//             value: 'Fermanagh and Omagh'
//         },
//         {
//             label: 'Gateshead',
//             stateCode: 'GAT',
//             value: 'Gateshead'
//         },
//         {
//             label: 'City of Glasgow',
//             stateCode: 'GLG',
//             value: 'City of Glasgow'
//         },
//         {
//             label: 'Gloucestershire',
//             stateCode: 'GLS',
//             value: 'Gloucestershire'
//         },
//         {
//             label: 'Greenwich',
//             stateCode: 'GRE',
//             value: 'Greenwich'
//         },
//         {
//             label: 'Gwynedd',
//             stateCode: 'GWN',
//             value: 'Gwynedd'
//         },
//         {
//             label: 'Halton',
//             stateCode: 'HAL',
//             value: 'Halton'
//         },
//         {
//             label: 'Hampshire',
//             stateCode: 'HAM',
//             value: 'Hampshire'
//         },
//         {
//             label: 'Havering',
//             stateCode: 'HAV',
//             value: 'Havering'
//         },
//         {
//             label: 'Hackney',
//             stateCode: 'HCK',
//             value: 'Hackney'
//         },
//         {
//             label: 'Herefordshire',
//             stateCode: 'HEF',
//             value: 'Herefordshire'
//         },
//         {
//             label: 'Hillingdon',
//             stateCode: 'HIL',
//             value: 'Hillingdon'
//         },
//         {
//             label: 'Highland',
//             stateCode: 'HLD',
//             value: 'Highland'
//         },
//         {
//             label: 'Hammersm and Fulham',
//             stateCode: 'HMF',
//             value: 'Hammersm and Fulham'
//         },
//         {
//             label: 'Hounslow',
//             stateCode: 'HNS',
//             value: 'Hounslow'
//         },
//         {
//             label: 'Hartlepool',
//             stateCode: 'HPL',
//             value: 'Hartlepool'
//         },
//         {
//             label: 'Hertfordshire',
//             stateCode: 'HRT',
//             value: 'Hertfordshire'
//         },
//         {
//             label: 'Harrow',
//             stateCode: 'HRW',
//             value: 'Harrow'
//         },
//         {
//             label: 'Haringey',
//             stateCode: 'HRY',
//             value: 'Haringey'
//         },
//         {
//             label: 'Isles of Scilly',
//             stateCode: 'IOS',
//             value: 'Isles of Scilly'
//         },
//         {
//             label: 'Isle of Wight',
//             stateCode: 'IOW',
//             value: 'Isle of Wight'
//         },
//         {
//             label: 'Islington',
//             stateCode: 'ISL',
//             value: 'Islington'
//         },
//         {
//             label: 'Inverclyde',
//             stateCode: 'IVC',
//             value: 'Inverclyde'
//         },
//         {
//             label: 'Kensington and Chelsea',
//             stateCode: 'KEC',
//             value: 'Kensington and Chelsea'
//         },
//         {
//             label: 'Kent',
//             stateCode: 'KEN',
//             value: 'Kent'
//         },
//         {
//             label: 'Kingston upon Hull',
//             stateCode: 'KHL',
//             value: 'Kingston upon Hull'
//         },
//         {
//             label: 'Kirklees',
//             stateCode: 'KIR',
//             value: 'Kirklees'
//         },
//         {
//             label: 'Kingston upon Thames',
//             stateCode: 'KTT',
//             value: 'Kingston upon Thames'
//         },
//         {
//             label: 'Knowsley',
//             stateCode: 'KWL',
//             value: 'Knowsley'
//         },
//         {
//             label: 'Lancashire',
//             stateCode: 'LAN',
//             value: 'Lancashire'
//         },
//         {
//             label: 'Lisburn and Castlereagh',
//             stateCode: 'LBC',
//             value: 'Lisburn and Castlereagh'
//         },
//         {
//             label: 'Lambeth',
//             stateCode: 'LBH',
//             value: 'Lambeth'
//         },
//         {
//             label: 'Leicester',
//             stateCode: 'LCE',
//             value: 'Leicester'
//         },
//         {
//             label: 'Leeds',
//             stateCode: 'LDS',
//             value: 'Leeds'
//         },
//         {
//             label: 'Leicestershire',
//             stateCode: 'LEC',
//             value: 'Leicestershire'
//         },
//         {
//             label: 'Lewisham',
//             stateCode: 'LEW',
//             value: 'Lewisham'
//         },
//         {
//             label: 'Lincolnshire',
//             stateCode: 'LIN',
//             value: 'Lincolnshire'
//         },
//         {
//             label: 'Liverpool',
//             stateCode: 'LIV',
//             value: 'Liverpool'
//         },
//         {
//             label: 'London',
//             stateCode: 'LND',
//             value: 'London'
//         },
//         {
//             label: 'Luton',
//             stateCode: 'LUT',
//             value: 'Luton'
//         },
//         {
//             label: 'Manchester',
//             stateCode: 'MAN',
//             value: 'Manchester'
//         },
//         {
//             label: 'Middlesbrough',
//             stateCode: 'MDB',
//             value: 'Middlesbrough'
//         },
//         {
//             label: 'Medway',
//             stateCode: 'MDW',
//             value: 'Medway'
//         },
//         {
//             label: 'Mid & East Antrim',
//             stateCode: 'MEA',
//             value: 'Mid & East Antrim'
//         },
//         {
//             label: 'Milton Keynes',
//             stateCode: 'MIK',
//             value: 'Milton Keynes'
//         },
//         {
//             label: 'Midlothian',
//             stateCode: 'MLN',
//             value: 'Midlothian'
//         },
//         {
//             label: 'Monmouthshire',
//             stateCode: 'MON',
//             value: 'Monmouthshire'
//         },
//         {
//             label: 'Merton',
//             stateCode: 'MRT',
//             value: 'Merton'
//         },
//         {
//             label: 'Moray',
//             stateCode: 'MRY',
//             value: 'Moray'
//         },
//         {
//             label: 'Merthyr Tydfil',
//             stateCode: 'MTY',
//             value: 'Merthyr Tydfil'
//         },
//         {
//             label: 'Mid-Ulster',
//             stateCode: 'MUL',
//             value: 'Mid-Ulster'
//         },
//         {
//             label: 'North Ayrshire',
//             stateCode: 'NAY',
//             value: 'North Ayrshire'
//         },
//         {
//             label: 'Northumberland',
//             stateCode: 'NBL',
//             value: 'Northumberland'
//         },
//         {
//             label: 'North East Lincolnshire',
//             stateCode: 'NEL',
//             value: 'North East Lincolnshire'
//         },
//         {
//             label: 'Newcastle upon Tyne',
//             stateCode: 'NET',
//             value: 'Newcastle upon Tyne'
//         },
//         {
//             label: 'Norfolk',
//             stateCode: 'NFK',
//             value: 'Norfolk'
//         },
//         {
//             label: 'Nottingham',
//             stateCode: 'NGM',
//             value: 'Nottingham'
//         },
//         {
//             label: 'North Lanarkshire',
//             stateCode: 'NLK',
//             value: 'North Lanarkshire'
//         },
//         {
//             label: 'North Lincolnshire',
//             stateCode: 'NLN',
//             value: 'North Lincolnshire'
//         },
//         {
//             label: 'Newry, Mourne and Down',
//             stateCode: 'NMD',
//             value: 'Newry, Mourne and Down'
//         },
//         {
//             label: 'North Somerset',
//             stateCode: 'NSM',
//             value: 'North Somerset'
//         },
//         {
//             label: 'North Northamptonshire',
//             stateCode: 'NTH',
//             value: 'North Northamptonshire'
//         },
//         {
//             label: 'Neath Port Talbot',
//             stateCode: 'NTL',
//             value: 'Neath Port Talbot'
//         },
//         {
//             label: 'Nottinghamshire',
//             stateCode: 'NTT',
//             value: 'Nottinghamshire'
//         },
//         {
//             label: 'North Tyneside',
//             stateCode: 'NTY',
//             value: 'North Tyneside'
//         },
//         {
//             label: 'Newham',
//             stateCode: 'NWM',
//             value: 'Newham'
//         },
//         {
//             label: 'Newport',
//             stateCode: 'NWP',
//             value: 'Newport'
//         },
//         {
//             label: 'North Yorkshire',
//             stateCode: 'NYK',
//             value: 'North Yorkshire'
//         },
//         {
//             label: 'Oldham',
//             stateCode: 'OLD',
//             value: 'Oldham'
//         },
//         {
//             label: 'Orkney Islands',
//             stateCode: 'ORK',
//             value: 'Orkney Islands'
//         },
//         {
//             label: 'Oxfordshire',
//             stateCode: 'OXF',
//             value: 'Oxfordshire'
//         },
//         {
//             label: 'Pembrokeshire',
//             stateCode: 'PEM',
//             value: 'Pembrokeshire'
//         },
//         {
//             label: 'Perth and Kinross',
//             stateCode: 'PKN',
//             value: 'Perth and Kinross'
//         },
//         {
//             label: 'Plymouth',
//             stateCode: 'PLY',
//             value: 'Plymouth'
//         },
//         {
//             label: 'Portsmouth',
//             stateCode: 'POR',
//             value: 'Portsmouth'
//         },
//         {
//             label: 'Powys',
//             stateCode: 'POW',
//             value: 'Powys'
//         },
//         {
//             label: 'Peterborough',
//             stateCode: 'PTE',
//             value: 'Peterborough'
//         },
//         {
//             label: 'Redcar and Cleveland',
//             stateCode: 'RCC',
//             value: 'Redcar and Cleveland'
//         },
//         {
//             label: 'Rochdale',
//             stateCode: 'RCH',
//             value: 'Rochdale'
//         },
//         {
//             label: 'Rhondda Cynon Taf',
//             stateCode: 'RCT',
//             value: 'Rhondda Cynon Taf'
//         },
//         {
//             label: 'Redbridge',
//             stateCode: 'RDB',
//             value: 'Redbridge'
//         },
//         {
//             label: 'Reading',
//             stateCode: 'RDG',
//             value: 'Reading'
//         },
//         {
//             label: 'Renfrewshire',
//             stateCode: 'RFW',
//             value: 'Renfrewshire'
//         },
//         {
//             label: 'Richmond upon Thames',
//             stateCode: 'RIC',
//             value: 'Richmond upon Thames'
//         },
//         {
//             label: 'Rotherham',
//             stateCode: 'ROT',
//             value: 'Rotherham'
//         },
//         {
//             label: 'Rutland',
//             stateCode: 'RUT',
//             value: 'Rutland'
//         },
//         {
//             label: 'Sandwell',
//             stateCode: 'SAW',
//             value: 'Sandwell'
//         },
//         {
//             label: 'South Ayrshire',
//             stateCode: 'SAY',
//             value: 'South Ayrshire'
//         },
//         {
//             label: 'Scottish Borders',
//             stateCode: 'SCB',
//             value: 'Scottish Borders'
//         },
//         {
//             label: 'Suffolk',
//             stateCode: 'SFK',
//             value: 'Suffolk'
//         },
//         {
//             label: 'Sefton',
//             stateCode: 'SFT',
//             value: 'Sefton'
//         },
//         {
//             label: 'S Gloucestershire',
//             stateCode: 'SGC',
//             value: 'S Gloucestershire'
//         },
//         {
//             label: 'Sheffield',
//             stateCode: 'SHF',
//             value: 'Sheffield'
//         },
//         {
//             label: 'Saint Helens',
//             stateCode: 'SHN',
//             value: 'Saint Helens'
//         },
//         {
//             label: 'Shropshire',
//             stateCode: 'SHR',
//             value: 'Shropshire'
//         },
//         {
//             label: 'Stockport',
//             stateCode: 'SKP',
//             value: 'Stockport'
//         },
//         {
//             label: 'Salford',
//             stateCode: 'SLF',
//             value: 'Salford'
//         },
//         {
//             label: 'Slough',
//             stateCode: 'SLG',
//             value: 'Slough'
//         },
//         {
//             label: 'South Lanarkshire',
//             stateCode: 'SLK',
//             value: 'South Lanarkshire'
//         },
//         {
//             label: 'Sunderland',
//             stateCode: 'SND',
//             value: 'Sunderland'
//         },
//         {
//             label: 'Solihull',
//             stateCode: 'SOL',
//             value: 'Solihull'
//         },
//         {
//             label: 'Somerset',
//             stateCode: 'SOM',
//             value: 'Somerset'
//         },
//         {
//             label: 'Southend-on-Sea',
//             stateCode: 'SOS',
//             value: 'Southend-on-Sea'
//         },
//         {
//             label: 'Surrey',
//             stateCode: 'SRY',
//             value: 'Surrey'
//         },
//         {
//             label: 'Stoke-on-Trent',
//             stateCode: 'STE',
//             value: 'Stoke-on-Trent'
//         },
//         {
//             label: 'Stirling',
//             stateCode: 'STG',
//             value: 'Stirling'
//         },
//         {
//             label: 'Southampton',
//             stateCode: 'STH',
//             value: 'Southampton'
//         },
//         {
//             label: 'Sutton',
//             stateCode: 'STN',
//             value: 'Sutton'
//         },
//         {
//             label: 'Staffordshire',
//             stateCode: 'STS',
//             value: 'Staffordshire'
//         },
//         {
//             label: 'Stockton-on-Tees',
//             stateCode: 'STT',
//             value: 'Stockton-on-Tees'
//         },
//         {
//             label: 'South Tyneside',
//             stateCode: 'STY',
//             value: 'South Tyneside'
//         },
//         {
//             label: 'Swansea',
//             stateCode: 'SWA',
//             value: 'Swansea'
//         },
//         {
//             label: 'Swindon',
//             stateCode: 'SWD',
//             value: 'Swindon'
//         },
//         {
//             label: 'Southwark',
//             stateCode: 'SWK',
//             value: 'Southwark'
//         },
//         {
//             label: 'Tameside',
//             stateCode: 'TAM',
//             value: 'Tameside'
//         },
//         {
//             label: 'Telford and Wrekin',
//             stateCode: 'TFW',
//             value: 'Telford and Wrekin'
//         },
//         {
//             label: 'Thurrock',
//             stateCode: 'THR',
//             value: 'Thurrock'
//         },
//         {
//             label: 'Torbay',
//             stateCode: 'TOB',
//             value: 'Torbay'
//         },
//         {
//             label: 'Torfaen',
//             stateCode: 'TOF',
//             value: 'Torfaen'
//         },
//         {
//             label: 'Trafford',
//             stateCode: 'TRF',
//             value: 'Trafford'
//         },
//         {
//             label: 'Tower Hamlets',
//             stateCode: 'TWH',
//             value: 'Tower Hamlets'
//         },
//         {
//             label: 'Vale of Glamorgan',
//             stateCode: 'VGL',
//             value: 'Vale of Glamorgan'
//         },
//         {
//             label: 'Warwickshire',
//             stateCode: 'WAR',
//             value: 'Warwickshire'
//         },
//         {
//             label: 'West Berkshire',
//             stateCode: 'WBK',
//             value: 'West Berkshire'
//         },
//         {
//             label: 'West Dunbartonshire',
//             stateCode: 'WDU',
//             value: 'West Dunbartonshire'
//         },
//         {
//             label: 'Waltham Forest',
//             stateCode: 'WFT',
//             value: 'Waltham Forest'
//         },
//         {
//             label: 'Wigan',
//             stateCode: 'WGN',
//             value: 'Wigan'
//         },
//         {
//             label: 'Wiltshire',
//             stateCode: 'WIL',
//             value: 'Wiltshire'
//         },
//         {
//             label: 'Wakefield',
//             stateCode: 'WKF',
//             value: 'Wakefield'
//         },
//         {
//             label: 'Walsall',
//             stateCode: 'WLL',
//             value: 'Walsall'
//         },
//         {
//             label: 'West Lothian',
//             stateCode: 'WLN',
//             value: 'West Lothian'
//         },
//         {
//             label: 'Wolverhampton',
//             stateCode: 'WLV',
//             value: 'Wolverhampton'
//         },
//         {
//             label: 'Wandsworth',
//             stateCode: 'WND',
//             value: 'Wandsworth'
//         },
//         {
//             label: 'West Northamptonshire',
//             stateCode: 'WNH',
//             value: 'West Northamptonshire'
//         },
//         {
//             label: 'Windsor and Maidenhead',
//             stateCode: 'WNM',
//             value: 'Windsor and Maidenhead'
//         },
//         {
//             label: 'Wokingham',
//             stateCode: 'WOK',
//             value: 'Wokingham'
//         },
//         {
//             label: 'Worcestershire',
//             stateCode: 'WOR',
//             value: 'Worcestershire'
//         },
//         {
//             label: 'Wirral',
//             stateCode: 'WRL',
//             value: 'Wirral'
//         },
//         {
//             label: 'Warrington',
//             stateCode: 'WRT',
//             value: 'Warrington'
//         },
//         {
//             label: 'Wrexham',
//             stateCode: 'WRX',
//             value: 'Wrexham'
//         },
//         {
//             label: 'Westminster',
//             stateCode: 'WSM',
//             value: 'Westminster'
//         },
//         {
//             label: 'West Sussex',
//             stateCode: 'WSX',
//             value: 'West Sussex'
//         },
//         {
//             label: 'York',
//             stateCode: 'YOR',
//             value: 'York'
//         },
//         {
//             label: 'Shetland Islands',
//             stateCode: 'ZET',
//             value: 'Shetland Islands'
//         }
//     ],
//     GGY: [
//         {
//             label: 'NULL',
//             stateCode: 'NULL',
//             value: 'NULL'
//         }
//     ],
//     GIB: [
//         {
//             label: 'NULL',
//             stateCode: 'NULL',
//             value: 'NULL'
//         }
//     ],
//     GLP: [
//         {
//             label: 'NULL',
//             stateCode: 'NULL',
//             value: 'NULL'
//         }
//     ],
//     GRC: [
//         {
//             label: 'Mount Athos',
//             stateCode: '69',
//             value: 'Mount Athos'
//         },
//         {
//             label: 'Eastern Macedonia and Thrace',
//             stateCode: 'A',
//             value: 'Eastern Macedonia and Thrace'
//         },
//         {
//             label: 'Attica',
//             stateCode: 'I',
//             value: 'Attica'
//         },
//         {
//             label: 'Western Greece',
//             stateCode: 'G',
//             value: 'Western Greece'
//         },
//         {
//             label: 'Western Macedonia',
//             stateCode: 'C',
//             value: 'Western Macedonia'
//         },
//         {
//             label: 'Ionian Islands',
//             stateCode: 'F',
//             value: 'Ionian Islands'
//         },
//         {
//             label: 'Epirus',
//             stateCode: 'D',
//             value: 'Epirus'
//         },
//         {
//             label: 'Central Macedonia',
//             stateCode: 'B',
//             value: 'Central Macedonia'
//         },
//         {
//             label: 'Crete',
//             stateCode: 'M',
//             value: 'Crete'
//         },
//         {
//             label: 'Southern Aegean',
//             stateCode: 'L',
//             value: 'Southern Aegean'
//         },
//         {
//             label: 'Peloponnese',
//             stateCode: 'J',
//             value: 'Peloponnese'
//         },
//         {
//             label: 'Central Greece',
//             stateCode: 'H',
//             value: 'Central Greece'
//         },
//         {
//             label: 'Thessaly',
//             stateCode: 'E',
//             value: 'Thessaly'
//         },
//         {
//             label: 'Northern Aegean',
//             stateCode: 'K',
//             value: 'Northern Aegean'
//         }
//     ],
//     GRL: [
//         {
//             label: 'Avannaata',
//             stateCode: 'AV',
//             value: 'Avannaata'
//         },
//         {
//             label: 'Kujalleq',
//             stateCode: 'KU',
//             value: 'Kujalleq'
//         },
//         {
//             label: 'Qeqertalik',
//             stateCode: 'QT',
//             value: 'Qeqertalik'
//         },
//         {
//             label: 'Sermersooq',
//             stateCode: 'SM',
//             value: 'Sermersooq'
//         },
//         {
//             label: 'Qeqqata',
//             stateCode: 'QE',
//             value: 'Qeqqata'
//         }
//     ],
//     HRV: [
//         {
//             label: 'Zagreb County',
//             stateCode: '01',
//             value: 'Zagreb County'
//         },
//         {
//             label: 'Krapina-Zagorje',
//             stateCode: '02',
//             value: 'Krapina-Zagorje'
//         },
//         {
//             label: 'Sisak-Moslavina',
//             stateCode: '03',
//             value: 'Sisak-Moslavina'
//         },
//         {
//             label: 'Karlovac',
//             stateCode: '04',
//             value: 'Karlovac'
//         },
//         {
//             label: 'Varazdin',
//             stateCode: '05',
//             value: 'Varazdin'
//         },
//         {
//             label: 'Koprivnica-Krizevci',
//             stateCode: '06',
//             value: 'Koprivnica-Krizevci'
//         },
//         {
//             label: 'Bjelovar-Bilogora',
//             stateCode: '07',
//             value: 'Bjelovar-Bilogora'
//         },
//         {
//             label: 'Primorje-Gorski Kotar',
//             stateCode: '08',
//             value: 'Primorje-Gorski Kotar'
//         },
//         {
//             label: 'Lika-Senj',
//             stateCode: '09',
//             value: 'Lika-Senj'
//         },
//         {
//             label: 'Virovitica-Podravina',
//             stateCode: '10',
//             value: 'Virovitica-Podravina'
//         },
//         {
//             label: 'Pozega-Slavonia',
//             stateCode: '11',
//             value: 'Pozega-Slavonia'
//         },
//         {
//             label: 'Brod-Posavina',
//             stateCode: '12',
//             value: 'Brod-Posavina'
//         },
//         {
//             label: 'Zadar',
//             stateCode: '13',
//             value: 'Zadar'
//         },
//         {
//             label: 'Osijek-Baranja',
//             stateCode: '14',
//             value: 'Osijek-Baranja'
//         },
//         {
//             label: 'Sibenik-Knin',
//             stateCode: '15',
//             value: 'Sibenik-Knin'
//         },
//         {
//             label: 'Vukovar-Srijem',
//             stateCode: '16',
//             value: 'Vukovar-Srijem'
//         },
//         {
//             label: 'Split-Dalmatia',
//             stateCode: '17',
//             value: 'Split-Dalmatia'
//         },
//         {
//             label: 'Istria',
//             stateCode: '18',
//             value: 'Istria'
//         },
//         {
//             label: 'Dubrovnik-Neretva',
//             stateCode: '19',
//             value: 'Dubrovnik-Neretva'
//         },
//         {
//             label: 'Međimurje',
//             stateCode: '20',
//             value: 'Međimurje'
//         },
//         {
//             label: 'Zagreb City',
//             stateCode: '21',
//             value: 'Zagreb City'
//         }
//     ],
//     HUN: [
//         {
//             label: 'Bacs-Kiskun',
//             stateCode: 'BK',
//             value: 'Bacs-Kiskun'
//         },
//         {
//             label: 'Baranya',
//             stateCode: 'BA',
//             value: 'Baranya'
//         },
//         {
//             label: 'Bekes',
//             stateCode: 'BE',
//             value: 'Bekes'
//         },
//         {
//             label: 'Bekescsaba',
//             stateCode: 'BC',
//             value: 'Bekescsaba'
//         },
//         {
//             label: 'Borsod-Abauj-Zemplen',
//             stateCode: 'BZ',
//             value: 'Borsod-Abauj-Zemplen'
//         },
//         {
//             label: 'Budapest',
//             stateCode: 'BU',
//             value: 'Budapest'
//         },
//         {
//             label: 'Csongrad',
//             stateCode: 'CS',
//             value: 'Csongrad'
//         },
//         {
//             label: 'Debrecen',
//             stateCode: 'DE',
//             value: 'Debrecen'
//         },
//         {
//             label: 'Dunaujvaros',
//             stateCode: 'DU',
//             value: 'Dunaujvaros'
//         },
//         {
//             label: 'Eger',
//             stateCode: 'EG',
//             value: 'Eger'
//         },
//         {
//             label: 'Erd',
//             stateCode: 'ER',
//             value: 'Erd'
//         },
//         {
//             label: 'Fejer',
//             stateCode: 'FE',
//             value: 'Fejer'
//         },
//         {
//             label: 'Gyor',
//             stateCode: 'GY',
//             value: 'Gyor'
//         },
//         {
//             label: 'Gyor-Moson-Sopron',
//             stateCode: 'GS',
//             value: 'Gyor-Moson-Sopron'
//         },
//         {
//             label: 'Hajdu-Bihar',
//             stateCode: 'HB',
//             value: 'Hajdu-Bihar'
//         },
//         {
//             label: 'Heves',
//             stateCode: 'HE',
//             value: 'Heves'
//         },
//         {
//             label: 'Hodmezovasarhely',
//             stateCode: 'HV',
//             value: 'Hodmezovasarhely'
//         },
//         {
//             label: 'Jasz-Nagykun-Szolnok',
//             stateCode: 'JN',
//             value: 'Jasz-Nagykun-Szolnok'
//         },
//         {
//             label: 'Kaposvar',
//             stateCode: 'KV',
//             value: 'Kaposvar'
//         },
//         {
//             label: 'Kecskemet',
//             stateCode: 'KM',
//             value: 'Kecskemet'
//         },
//         {
//             label: 'Komarom-Esztergom',
//             stateCode: 'KE',
//             value: 'Komarom-Esztergom'
//         },
//         {
//             label: 'Miskolc',
//             stateCode: 'MI',
//             value: 'Miskolc'
//         },
//         {
//             label: 'Nagykanizsa',
//             stateCode: 'NK',
//             value: 'Nagykanizsa'
//         },
//         {
//             label: 'Nograd',
//             stateCode: 'NO',
//             value: 'Nograd'
//         },
//         {
//             label: 'Nyiregyhaza',
//             stateCode: 'NY',
//             value: 'Nyiregyhaza'
//         },
//         {
//             label: 'Pecs',
//             stateCode: 'PS',
//             value: 'Pecs'
//         },
//         {
//             label: 'Pest',
//             stateCode: 'PE',
//             value: 'Pest'
//         },
//         {
//             label: 'Salgotarjan',
//             stateCode: 'ST',
//             value: 'Salgotarjan'
//         },
//         {
//             label: 'Somogy',
//             stateCode: 'SO',
//             value: 'Somogy'
//         },
//         {
//             label: 'Sopron',
//             stateCode: 'SN',
//             value: 'Sopron'
//         },
//         {
//             label: 'Szabolcs-Szat.-Bereg',
//             stateCode: 'SZ',
//             value: 'Szabolcs-Szat.-Bereg'
//         },
//         {
//             label: 'Szeged',
//             stateCode: 'SD',
//             value: 'Szeged'
//         },
//         {
//             label: 'Szekesfehervar',
//             stateCode: 'SF',
//             value: 'Szekesfehervar'
//         },
//         {
//             label: 'Szekszard',
//             stateCode: 'SS',
//             value: 'Szekszard'
//         },
//         {
//             label: 'Szolnok',
//             stateCode: 'SK',
//             value: 'Szolnok'
//         },
//         {
//             label: 'Szombathely',
//             stateCode: 'SH',
//             value: 'Szombathely'
//         },
//         {
//             label: 'Tatabanya',
//             stateCode: 'TB',
//             value: 'Tatabanya'
//         },
//         {
//             label: 'Tolna',
//             stateCode: 'TO',
//             value: 'Tolna'
//         },
//         {
//             label: 'Vas',
//             stateCode: 'VA',
//             value: 'Vas'
//         },
//         {
//             label: 'Veszprem',
//             stateCode: 'VM',
//             value: 'Veszprem'
//         },
//         {
//             label: 'Zala',
//             stateCode: 'ZA',
//             value: 'Zala'
//         },
//         {
//             label: 'Zalaegerszeg',
//             stateCode: 'ZE',
//             value: 'Zalaegerszeg'
//         }
//     ],
//     IRL: [
//         {
//             label: 'Clare',
//             stateCode: 'CE',
//             value: 'Clare'
//         },
//         {
//             label: 'Cork',
//             stateCode: 'CO',
//             value: 'Cork'
//         },
//         {
//             label: 'Cavan',
//             stateCode: 'CN',
//             value: 'Cavan'
//         },
//         {
//             label: 'Carlow',
//             stateCode: 'CW',
//             value: 'Carlow'
//         },
//         {
//             label: 'Dublin',
//             stateCode: 'D',
//             value: 'Dublin'
//         },
//         {
//             label: 'Donegal',
//             stateCode: 'DL',
//             value: 'Donegal'
//         },
//         {
//             label: 'Galway',
//             stateCode: 'G',
//             value: 'Galway'
//         },
//         {
//             label: 'Kildare',
//             stateCode: 'KE',
//             value: 'Kildare'
//         },
//         {
//             label: 'Kilkenny',
//             stateCode: 'KK',
//             value: 'Kilkenny'
//         },
//         {
//             label: 'Kerry',
//             stateCode: 'KY',
//             value: 'Kerry'
//         },
//         {
//             label: 'Longford',
//             stateCode: 'LD',
//             value: 'Longford'
//         },
//         {
//             label: 'Louth',
//             stateCode: 'LH',
//             value: 'Louth'
//         },
//         {
//             label: 'Limerick',
//             stateCode: 'LK',
//             value: 'Limerick'
//         },
//         {
//             label: 'Leitrim',
//             stateCode: 'LM',
//             value: 'Leitrim'
//         },
//         {
//             label: 'Laois',
//             stateCode: 'LS',
//             value: 'Laois'
//         },
//         {
//             label: 'Meath',
//             stateCode: 'MH',
//             value: 'Meath'
//         },
//         {
//             label: 'Monaghan',
//             stateCode: 'MN',
//             value: 'Monaghan'
//         },
//         {
//             label: 'Mayo',
//             stateCode: 'MO',
//             value: 'Mayo'
//         },
//         {
//             label: 'Offaly',
//             stateCode: 'OY',
//             value: 'Offaly'
//         },
//         {
//             label: 'Roscommon',
//             stateCode: 'RN',
//             value: 'Roscommon'
//         },
//         {
//             label: 'Silgo',
//             stateCode: 'SO',
//             value: 'Silgo'
//         },
//         {
//             label: 'Tipperary',
//             stateCode: 'TA',
//             value: 'Tipperary'
//         },
//         {
//             label: 'Waterford',
//             stateCode: 'WD',
//             value: 'Waterford'
//         },
//         {
//             label: 'Westmeath',
//             stateCode: 'WH',
//             value: 'Westmeath'
//         },
//         {
//             label: 'Wicklow',
//             stateCode: 'WK',
//             value: 'Wicklow'
//         },
//         {
//             label: 'Wexford',
//             stateCode: 'WX',
//             value: 'Wexford'
//         }
//     ],
//     ISL: [
//         {
//             label: 'Capital Region',
//             stateCode: '1',
//             value: 'Capital Region'
//         },
//         {
//             label: 'Southern Peninsula',
//             stateCode: '2',
//             value: 'Southern Peninsula'
//         },
//         {
//             label: 'Western Region',
//             stateCode: '3',
//             value: 'Western Region'
//         },
//         {
//             label: 'Westfjords',
//             stateCode: '4',
//             value: 'Westfjords'
//         },
//         {
//             label: 'Northwestern Region',
//             stateCode: '5',
//             value: 'Northwestern Region'
//         },
//         {
//             label: 'Northeastern Region',
//             stateCode: '6',
//             value: 'Northeastern Region'
//         },
//         {
//             label: 'Eastern Region',
//             stateCode: '7',
//             value: 'Eastern Region'
//         },
//         {
//             label: 'Southern Region',
//             stateCode: '8',
//             value: 'Southern Region'
//         }
//     ],
//     ISR: [
//         {
//             label: 'Central',
//             stateCode: 'M',
//             value: 'Central'
//         },
//         {
//             label: 'Haifa',
//             stateCode: 'HA',
//             value: 'Haifa'
//         },
//         {
//             label: 'Jerusalem',
//             stateCode: 'JM',
//             value: 'Jerusalem'
//         },
//         {
//             label: 'Northern',
//             stateCode: 'Z',
//             value: 'Northern'
//         },
//         {
//             label: 'Southern',
//             stateCode: 'D',
//             value: 'Southern'
//         },
//         {
//             label: 'Tel Aviv',
//             stateCode: 'TA',
//             value: 'Tel Aviv'
//         }
//     ],
//     ITA: [
//         {
//             label: 'Abruzzo',
//             stateCode: '65',
//             value: 'Abruzzo'
//         },
//         {
//             label: 'Basilicata',
//             stateCode: '77',
//             value: 'Basilicata'
//         },
//         {
//             label: 'Calabria',
//             stateCode: '78',
//             value: 'Calabria'
//         },
//         {
//             label: 'Camapania',
//             stateCode: '72',
//             value: 'Camapania'
//         },
//         {
//             label: 'Emilia-Romagna',
//             stateCode: '45',
//             value: 'Emilia-Romagna'
//         },
//         {
//             label: 'Friuli Venezia Giulia',
//             stateCode: '36',
//             value: 'Friuli Venezia Giulia'
//         },
//         {
//             label: 'Lazio',
//             stateCode: '62',
//             value: 'Lazio'
//         },
//         {
//             label: 'Liguria',
//             stateCode: '42',
//             value: 'Liguria'
//         },
//         {
//             label: 'Lombardy',
//             stateCode: '25',
//             value: 'Lombardy'
//         },
//         {
//             label: 'Marche',
//             stateCode: '57',
//             value: 'Marche'
//         },
//         {
//             label: 'Molise',
//             stateCode: '67',
//             value: 'Molise'
//         },
//         {
//             label: 'Piedmont',
//             stateCode: '21',
//             value: 'Piedmont'
//         },
//         {
//             label: 'Apulia',
//             stateCode: '75',
//             value: 'Apulia'
//         },
//         {
//             label: 'Sardinia',
//             stateCode: '88',
//             value: 'Sardinia'
//         },
//         {
//             label: 'Sicily',
//             stateCode: '82',
//             value: 'Sicily'
//         },
//         {
//             label: 'Tuscany',
//             stateCode: '52',
//             value: 'Tuscany'
//         },
//         {
//             label: 'Trentino-South Tyrol',
//             stateCode: '32',
//             value: 'Trentino-South Tyrol'
//         },
//         {
//             label: 'Umbria',
//             stateCode: '55',
//             value: 'Umbria'
//         },
//         {
//             label: 'Aosta Valley',
//             stateCode: '23',
//             value: 'Aosta Valley'
//         },
//         {
//             label: 'Veneto',
//             stateCode: '34',
//             value: 'Veneto'
//         }
//     ],
//     JEY: [
//         {
//             label: 'NULL',
//             stateCode: 'NULL',
//             value: 'NULL'
//         }
//     ],
//     JOR: [
//         {
//             label: 'Ajloun',
//             stateCode: 'AJ',
//             value: 'Ajloun'
//         },
//         {
//             label: 'Amman',
//             stateCode: 'AM',
//             value: 'Amman'
//         },
//         {
//             label: 'Aqaba',
//             stateCode: 'AQ',
//             value: 'Aqaba'
//         },
//         {
//             label: 'Tafilah',
//             stateCode: 'AT',
//             value: 'Tafilah'
//         },
//         {
//             label: 'Zarqa',
//             stateCode: 'AZ',
//             value: 'Zarqa'
//         },
//         {
//             label: 'Balqa',
//             stateCode: 'BA',
//             value: 'Balqa'
//         },
//         {
//             label: 'Irbid',
//             stateCode: 'IR',
//             value: 'Irbid'
//         },
//         {
//             label: 'Jerash',
//             stateCode: 'JA',
//             value: 'Jerash'
//         },
//         {
//             label: 'Karak',
//             stateCode: 'KA',
//             value: 'Karak'
//         },
//         {
//             label: 'Mafraq',
//             stateCode: 'MA',
//             value: 'Mafraq'
//         },
//         {
//             label: 'Madaba',
//             stateCode: 'MD',
//             value: 'Madaba'
//         },
//         {
//             label: "Ma'an",
//             stateCode: 'MN',
//             value: "Ma'an"
//         }
//     ],
//     KAZ: [
//         {
//             label: 'Abai',
//             stateCode: '10',
//             value: 'Abai'
//         },
//         {
//             label: 'Akmola',
//             stateCode: '11',
//             value: 'Akmola'
//         },
//         {
//             label: 'Aktobe',
//             stateCode: '15',
//             value: 'Aktobe'
//         },
//         {
//             label: 'Almaty',
//             stateCode: '19',
//             value: 'Almaty'
//         },
//         {
//             label: 'Atyrau',
//             stateCode: '23',
//             value: 'Atyrau'
//         },
//         {
//             label: 'West Kazakhstan',
//             stateCode: '27',
//             value: 'West Kazakhstan'
//         },
//         {
//             label: 'Jambyl',
//             stateCode: '31',
//             value: 'Jambyl'
//         },
//         {
//             label: 'Jetisu',
//             stateCode: '33',
//             value: 'Jetisu'
//         },
//         {
//             label: 'Karaganda',
//             stateCode: '35',
//             value: 'Karaganda'
//         },
//         {
//             label: 'Kostanay',
//             stateCode: '39',
//             value: 'Kostanay'
//         },
//         {
//             label: 'Kyzylorda',
//             stateCode: '43',
//             value: 'Kyzylorda'
//         },
//         {
//             label: 'Mangystau',
//             stateCode: '47',
//             value: 'Mangystau'
//         },
//         {
//             label: 'Pavlodar',
//             stateCode: '55',
//             value: 'Pavlodar'
//         },
//         {
//             label: 'North Kazakhstan',
//             stateCode: '59',
//             value: 'North Kazakhstan'
//         },
//         {
//             label: 'Turkistan',
//             stateCode: '61',
//             value: 'Turkistan'
//         },
//         {
//             label: 'Ulytau',
//             stateCode: '62',
//             value: 'Ulytau'
//         },
//         {
//             label: 'East Kazakhstan',
//             stateCode: '63',
//             value: 'East Kazakhstan'
//         },
//         {
//             label: 'Astana',
//             stateCode: '71',
//             value: 'Astana'
//         },
//         {
//             label: 'Almaty City',
//             stateCode: '75',
//             value: 'Almaty City'
//         },
//         {
//             label: 'Shymkent',
//             stateCode: '79',
//             value: 'Shymkent'
//         }
//     ],
//     KEN: [
//         {
//             label: 'Baringo',
//             stateCode: '01',
//             value: 'Baringo'
//         },
//         {
//             label: 'Bomet',
//             stateCode: '02',
//             value: 'Bomet'
//         },
//         {
//             label: 'Bungoma',
//             stateCode: '03',
//             value: 'Bungoma'
//         },
//         {
//             label: 'Busia',
//             stateCode: '04',
//             value: 'Busia'
//         },
//         {
//             label: 'Elgeyo-Marakwet',
//             stateCode: '05',
//             value: 'Elgeyo-Marakwet'
//         },
//         {
//             label: 'Embu',
//             stateCode: '06',
//             value: 'Embu'
//         },
//         {
//             label: 'Garissa',
//             stateCode: '07',
//             value: 'Garissa'
//         },
//         {
//             label: 'Homa Bay',
//             stateCode: '08',
//             value: 'Homa Bay'
//         },
//         {
//             label: 'Isiolo',
//             stateCode: '09',
//             value: 'Isiolo'
//         },
//         {
//             label: 'Kajiado',
//             stateCode: '10',
//             value: 'Kajiado'
//         },
//         {
//             label: 'Kakamega',
//             stateCode: '11',
//             value: 'Kakamega'
//         },
//         {
//             label: 'Kericho',
//             stateCode: '12',
//             value: 'Kericho'
//         },
//         {
//             label: 'Kiambu',
//             stateCode: '13',
//             value: 'Kiambu'
//         },
//         {
//             label: 'Kilifi',
//             stateCode: '14',
//             value: 'Kilifi'
//         },
//         {
//             label: 'Kirinyaga',
//             stateCode: '15',
//             value: 'Kirinyaga'
//         },
//         {
//             label: 'Kisii',
//             stateCode: '16',
//             value: 'Kisii'
//         },
//         {
//             label: 'Kisumu',
//             stateCode: '17',
//             value: 'Kisumu'
//         },
//         {
//             label: 'Kitui',
//             stateCode: '18',
//             value: 'Kitui'
//         },
//         {
//             label: 'Kwale',
//             stateCode: '19',
//             value: 'Kwale'
//         },
//         {
//             label: 'Laikipia',
//             stateCode: '20',
//             value: 'Laikipia'
//         },
//         {
//             label: 'Lamu',
//             stateCode: '21',
//             value: 'Lamu'
//         },
//         {
//             label: 'Machakos',
//             stateCode: '22',
//             value: 'Machakos'
//         },
//         {
//             label: 'Makueni',
//             stateCode: '23',
//             value: 'Makueni'
//         },
//         {
//             label: 'Mandera',
//             stateCode: '24',
//             value: 'Mandera'
//         },
//         {
//             label: 'Marsabit',
//             stateCode: '25',
//             value: 'Marsabit'
//         },
//         {
//             label: 'Meru',
//             stateCode: '26',
//             value: 'Meru'
//         },
//         {
//             label: 'Migori',
//             stateCode: '27',
//             value: 'Migori'
//         },
//         {
//             label: 'Mombasa',
//             stateCode: '28',
//             value: 'Mombasa'
//         },
//         {
//             label: "Murang'a",
//             stateCode: '29',
//             value: "Murang'a"
//         },
//         {
//             label: 'Nairobi City',
//             stateCode: '30',
//             value: 'Nairobi City'
//         },
//         {
//             label: 'Nakuru',
//             stateCode: '31',
//             value: 'Nakuru'
//         },
//         {
//             label: 'Nandi',
//             stateCode: '32',
//             value: 'Nandi'
//         },
//         {
//             label: 'Narok',
//             stateCode: '33',
//             value: 'Narok'
//         },
//         {
//             label: 'Nyamira',
//             stateCode: '34',
//             value: 'Nyamira'
//         },
//         {
//             label: 'Nyandarua',
//             stateCode: '35',
//             value: 'Nyandarua'
//         },
//         {
//             label: 'Nyeri',
//             stateCode: '36',
//             value: 'Nyeri'
//         },
//         {
//             label: 'Samburu',
//             stateCode: '37',
//             value: 'Samburu'
//         },
//         {
//             label: 'Siaya',
//             stateCode: '38',
//             value: 'Siaya'
//         },
//         {
//             label: 'Taita-Taveta',
//             stateCode: '39',
//             value: 'Taita-Taveta'
//         },
//         {
//             label: 'Tana River',
//             stateCode: '40',
//             value: 'Tana River'
//         },
//         {
//             label: 'Tharaka-Nithi',
//             stateCode: '41',
//             value: 'Tharaka-Nithi'
//         },
//         {
//             label: 'Trans-Nzoia',
//             stateCode: '42',
//             value: 'Trans-Nzoia'
//         },
//         {
//             label: 'Turkana',
//             stateCode: '43',
//             value: 'Turkana'
//         },
//         {
//             label: 'Uasin Gishu',
//             stateCode: '44',
//             value: 'Uasin Gishu'
//         },
//         {
//             label: 'Vihiga',
//             stateCode: '45',
//             value: 'Vihiga'
//         },
//         {
//             label: 'Wajir',
//             stateCode: '46',
//             value: 'Wajir'
//         },
//         {
//             label: 'West Pokot',
//             stateCode: '47',
//             value: 'West Pokot'
//         }
//     ],
//     KWT: [
//         {
//             label: 'Ahmadi',
//             stateCode: 'AH',
//             value: 'Ahmadi'
//         },
//         {
//             label: 'Farwaniya',
//             stateCode: 'FA',
//             value: 'Farwaniya'
//         },
//         {
//             label: 'Hawalli',
//             stateCode: 'HA',
//             value: 'Hawalli'
//         },
//         {
//             label: 'Jahra',
//             stateCode: 'JA',
//             value: 'Jahra'
//         },
//         {
//             label: 'Capital',
//             stateCode: 'KU',
//             value: 'Capital'
//         },
//         {
//             label: 'Mubarak Al-Krabeer',
//             stateCode: 'MU',
//             value: 'Mubarak Al-Krabeer'
//         }
//     ],
//     LBN: [
//         {
//             label: 'Akkar',
//             stateCode: 'AK',
//             value: 'Akkar'
//         },
//         {
//             label: 'North Lebanon',
//             stateCode: 'AS',
//             value: 'North Lebanon'
//         },
//         {
//             label: 'Beirut',
//             stateCode: 'BA',
//             value: 'Beirut'
//         },
//         {
//             label: 'Baalbek-Hermel',
//             stateCode: 'BH',
//             value: 'Baalbek-Hermel'
//         },
//         {
//             label: 'Beqaa',
//             stateCode: 'BI',
//             value: 'Beqaa'
//         },
//         {
//             label: 'South Lebanon',
//             stateCode: 'JA',
//             value: 'South Lebanon'
//         },
//         {
//             label: 'Mount Lebanon',
//             stateCode: 'JL',
//             value: 'Mount Lebanon'
//         },
//         {
//             label: 'Nabatieh',
//             stateCode: 'NA',
//             value: 'Nabatieh'
//         }
//     ],
//     LTU: [
//         {
//             label: 'Alytus County',
//             stateCode: 'AL',
//             value: 'Alytus County'
//         },
//         {
//             label: 'Klaipeda County',
//             stateCode: 'KL',
//             value: 'Klaipeda County'
//         },
//         {
//             label: 'Kaunas County',
//             stateCode: 'KU',
//             value: 'Kaunas County'
//         },
//         {
//             label: 'Marijampole County',
//             stateCode: 'MR',
//             value: 'Marijampole County'
//         },
//         {
//             label: 'Panevezys County',
//             stateCode: 'PN',
//             value: 'Panevezys County'
//         },
//         {
//             label: 'Siauliai County',
//             stateCode: 'SA',
//             value: 'Siauliai County'
//         },
//         {
//             label: 'Taurage County',
//             stateCode: 'TA',
//             value: 'Taurage County'
//         },
//         {
//             label: 'Telsiai County',
//             stateCode: 'TE',
//             value: 'Telsiai County'
//         },
//         {
//             label: 'Utena County',
//             stateCode: 'UT',
//             value: 'Utena County'
//         },
//         {
//             label: 'Vilnius County',
//             stateCode: 'VL',
//             value: 'Vilnius County'
//         }
//     ],
//     LUX: [
//         {
//             label: 'Capellen',
//             stateCode: 'CA',
//             value: 'Capellen'
//         },
//         {
//             label: 'Clervaux',
//             stateCode: 'CL',
//             value: 'Clervaux'
//         },
//         {
//             label: 'Diekirch',
//             stateCode: 'DI',
//             value: 'Diekirch'
//         },
//         {
//             label: 'Echternach',
//             stateCode: 'EC',
//             value: 'Echternach'
//         },
//         {
//             label: 'Esch-sur-Alzette',
//             stateCode: 'ES',
//             value: 'Esch-sur-Alzette'
//         },
//         {
//             label: 'Grevenmacher',
//             stateCode: 'GR',
//             value: 'Grevenmacher'
//         },
//         {
//             label: 'Luxembourg',
//             stateCode: 'LU',
//             value: 'Luxembourg'
//         },
//         {
//             label: 'Mersch',
//             stateCode: 'ME',
//             value: 'Mersch'
//         },
//         {
//             label: 'Redange',
//             stateCode: 'RD',
//             value: 'Redange'
//         },
//         {
//             label: 'Remich',
//             stateCode: 'RM',
//             value: 'Remich'
//         },
//         {
//             label: 'Vianden',
//             stateCode: 'VD',
//             value: 'Vianden'
//         },
//         {
//             label: 'Wiltz',
//             stateCode: 'WI',
//             value: 'Wiltz'
//         }
//     ],
//     LVA: [
//         {
//             label: 'Aizkraukle',
//             stateCode: '002',
//             value: 'Aizkraukle'
//         },
//         {
//             label: 'Aluksne',
//             stateCode: '007',
//             value: 'Aluksne'
//         },
//         {
//             label: 'Adazi',
//             stateCode: '011',
//             value: 'Adazi'
//         },
//         {
//             label: 'Balvi',
//             stateCode: '015',
//             value: 'Balvi'
//         },
//         {
//             label: 'Bauska',
//             stateCode: '016',
//             value: 'Bauska'
//         },
//         {
//             label: 'Cesis',
//             stateCode: '022',
//             value: 'Cesis'
//         },
//         {
//             label: 'Dobele',
//             stateCode: '026',
//             value: 'Dobele'
//         },
//         {
//             label: 'Gulbene',
//             stateCode: '033',
//             value: 'Gulbene'
//         },
//         {
//             label: 'Jelgava',
//             stateCode: '041',
//             value: 'Jelgava'
//         },
//         {
//             label: 'Jekabpils',
//             stateCode: '042',
//             value: 'Jekabpils'
//         },
//         {
//             label: 'Kraslava',
//             stateCode: '047',
//             value: 'Kraslava'
//         },
//         {
//             label: 'Kuldiga',
//             stateCode: '050',
//             value: 'Kuldiga'
//         },
//         {
//             label: 'Kekava',
//             stateCode: '052',
//             value: 'Kekava'
//         },
//         {
//             label: 'Limbazi',
//             stateCode: '054',
//             value: 'Limbazi'
//         },
//         {
//             label: 'Livani',
//             stateCode: '056',
//             value: 'Livani'
//         },
//         {
//             label: 'Ludza',
//             stateCode: '058',
//             value: 'Ludza'
//         },
//         {
//             label: 'Madona',
//             stateCode: '059',
//             value: 'Madona'
//         },
//         {
//             label: 'Marupe',
//             stateCode: '062',
//             value: 'Marupe'
//         },
//         {
//             label: 'Ogre',
//             stateCode: '067',
//             value: 'Ogre'
//         },
//         {
//             label: 'Olaine',
//             stateCode: '068',
//             value: 'Olaine'
//         },
//         {
//             label: 'Preili',
//             stateCode: '073',
//             value: 'Preili'
//         },
//         {
//             label: 'Rezekne',
//             stateCode: '077',
//             value: 'Rezekne'
//         },
//         {
//             label: 'Rapazi',
//             stateCode: '080',
//             value: 'Rapazi'
//         },
//         {
//             label: 'Salaspils',
//             stateCode: '087',
//             value: 'Salaspils'
//         },
//         {
//             label: 'Saldus',
//             stateCode: '088',
//             value: 'Saldus'
//         },
//         {
//             label: 'Saulkrasti',
//             stateCode: '089',
//             value: 'Saulkrasti'
//         },
//         {
//             label: 'Sigulda',
//             stateCode: '091',
//             value: 'Sigulda'
//         },
//         {
//             label: 'Smiltene',
//             stateCode: '094',
//             value: 'Smiltene'
//         },
//         {
//             label: 'Talsi',
//             stateCode: '097',
//             value: 'Talsi'
//         },
//         {
//             label: 'Tukums',
//             stateCode: '099',
//             value: 'Tukums'
//         },
//         {
//             label: 'Valka',
//             stateCode: '101',
//             value: 'Valka'
//         },
//         {
//             label: 'Varaklani',
//             stateCode: '102',
//             value: 'Varaklani'
//         },
//         {
//             label: 'Ventsplis',
//             stateCode: '106',
//             value: 'Ventsplis'
//         },
//         {
//             label: 'Augsdaugava',
//             stateCode: '111',
//             value: 'Augsdaugava'
//         },
//         {
//             label: 'Dienvidkurzeme',
//             stateCode: '112',
//             value: 'Dienvidkurzeme'
//         },
//         {
//             label: 'Valmiera',
//             stateCode: '113',
//             value: 'Valmiera'
//         },
//         {
//             label: 'Daugavpils',
//             stateCode: 'DGV',
//             value: 'Daugavpils'
//         },
//         {
//             label: 'Jelgava',
//             stateCode: 'JEL',
//             value: 'Jelgava'
//         },
//         {
//             label: 'Jurmala',
//             stateCode: 'JUR',
//             value: 'Jurmala'
//         },
//         {
//             label: 'Liepaja',
//             stateCode: 'LPX',
//             value: 'Liepaja'
//         },
//         {
//             label: 'Rezekne',
//             stateCode: 'REZ',
//             value: 'Rezekne'
//         },
//         {
//             label: 'Riga',
//             stateCode: 'RIX',
//             value: 'Riga'
//         },
//         {
//             label: 'Ventsplis',
//             stateCode: 'VEN',
//             value: 'Ventsplis'
//         }
//     ],
//     MCO: [
//         {
//             label: 'La Colle',
//             stateCode: 'CL',
//             value: 'La Colle'
//         },
//         {
//             label: 'La Condamine',
//             stateCode: 'CO',
//             value: 'La Condamine'
//         },
//         {
//             label: 'Fontvieille',
//             stateCode: 'FO',
//             value: 'Fontvieille'
//         },
//         {
//             label: 'La Gare',
//             stateCode: 'GA',
//             value: 'La Gare'
//         },
//         {
//             label: 'Jardin Exotique',
//             stateCode: 'JE',
//             value: 'Jardin Exotique'
//         },
//         {
//             label: 'Larvotto',
//             stateCode: 'LA',
//             value: 'Larvotto'
//         },
//         {
//             label: 'Malbousquet',
//             stateCode: 'MA',
//             value: 'Malbousquet'
//         },
//         {
//             label: 'Monte-Carlo',
//             stateCode: 'MC',
//             value: 'Monte-Carlo'
//         },
//         {
//             label: 'Moneghetti',
//             stateCode: 'MG',
//             value: 'Moneghetti'
//         },
//         {
//             label: 'Monaco-Ville',
//             stateCode: 'MO',
//             value: 'Monaco-Ville'
//         },
//         {
//             label: 'Moulins',
//             stateCode: 'MU',
//             value: 'Moulins'
//         },
//         {
//             label: 'Port-Hercule',
//             stateCode: 'PH',
//             value: 'Port-Hercule'
//         },
//         {
//             label: 'Sainte-Dévote',
//             stateCode: 'SD',
//             value: 'Sainte-Dévote'
//         },
//         {
//             label: 'La Source',
//             stateCode: 'SO',
//             value: 'La Source'
//         },
//         {
//             label: 'Spélugues',
//             stateCode: 'SP',
//             value: 'Spélugues'
//         },
//         {
//             label: 'Saint-Roman',
//             stateCode: 'SR',
//             value: 'Saint-Roman'
//         },
//         {
//             label: 'Vallon de la Rousse',
//             stateCode: 'VR',
//             value: 'Vallon de la Rousse'
//         }
//     ],
//     MLT: [
//         {
//             label: 'Attard',
//             stateCode: '01',
//             value: 'Attard'
//         },
//         {
//             label: 'Balzan',
//             stateCode: '02',
//             value: 'Balzan'
//         },
//         {
//             label: 'Birgu',
//             stateCode: '03',
//             value: 'Birgu'
//         },
//         {
//             label: 'Birkirkara',
//             stateCode: '04',
//             value: 'Birkirkara'
//         },
//         {
//             label: 'Birzebbuga',
//             stateCode: '05',
//             value: 'Birzebbuga'
//         },
//         {
//             label: 'Bormla',
//             stateCode: '06',
//             value: 'Bormla'
//         },
//         {
//             label: 'Dingli',
//             stateCode: '07',
//             value: 'Dingli'
//         },
//         {
//             label: 'Fgura',
//             stateCode: '08',
//             value: 'Fgura'
//         },
//         {
//             label: 'Floriana',
//             stateCode: '09',
//             value: 'Floriana'
//         },
//         {
//             label: 'Fontana',
//             stateCode: '10',
//             value: 'Fontana'
//         },
//         {
//             label: 'Gudja',
//             stateCode: '11',
//             value: 'Gudja'
//         },
//         {
//             label: 'Gzira',
//             stateCode: '12',
//             value: 'Gzira'
//         },
//         {
//             label: 'Ghajnsielem',
//             stateCode: '13',
//             value: 'Ghajnsielem'
//         },
//         {
//             label: 'Gharb',
//             stateCode: '14',
//             value: 'Gharb'
//         },
//         {
//             label: 'Gharghur',
//             stateCode: '15',
//             value: 'Gharghur'
//         },
//         {
//             label: 'Ghasri',
//             stateCode: '16',
//             value: 'Ghasri'
//         },
//         {
//             label: 'Ghaxaq',
//             stateCode: '17',
//             value: 'Ghaxaq'
//         },
//         {
//             label: 'Hamrun',
//             stateCode: '18',
//             value: 'Hamrun'
//         },
//         {
//             label: 'Iklin',
//             stateCode: '19',
//             value: 'Iklin'
//         },
//         {
//             label: 'Isla',
//             stateCode: '20',
//             value: 'Isla'
//         },
//         {
//             label: 'Kalkara',
//             stateCode: '21',
//             value: 'Kalkara'
//         },
//         {
//             label: 'Kercem',
//             stateCode: '22',
//             value: 'Kercem'
//         },
//         {
//             label: 'Kirkop',
//             stateCode: '23',
//             value: 'Kirkop'
//         },
//         {
//             label: 'Lija',
//             stateCode: '24',
//             value: 'Lija'
//         },
//         {
//             label: 'Luqa',
//             stateCode: '25',
//             value: 'Luqa'
//         },
//         {
//             label: 'Marsa',
//             stateCode: '26',
//             value: 'Marsa'
//         },
//         {
//             label: 'Marsaskala',
//             stateCode: '27',
//             value: 'Marsaskala'
//         },
//         {
//             label: 'Marsaxlokk',
//             stateCode: '28',
//             value: 'Marsaxlokk'
//         },
//         {
//             label: 'Mdina',
//             stateCode: '29',
//             value: 'Mdina'
//         },
//         {
//             label: 'Mellieha',
//             stateCode: '30',
//             value: 'Mellieha'
//         },
//         {
//             label: 'Mgarr',
//             stateCode: '31',
//             value: 'Mgarr'
//         },
//         {
//             label: 'Mosta',
//             stateCode: '32',
//             value: 'Mosta'
//         },
//         {
//             label: 'Mqabba',
//             stateCode: '33',
//             value: 'Mqabba'
//         },
//         {
//             label: 'Msida',
//             stateCode: '34',
//             value: 'Msida'
//         },
//         {
//             label: 'Mtarfa',
//             stateCode: '35',
//             value: 'Mtarfa'
//         },
//         {
//             label: 'Munxar',
//             stateCode: '36',
//             value: 'Munxar'
//         },
//         {
//             label: 'Nadur',
//             stateCode: '37',
//             value: 'Nadur'
//         },
//         {
//             label: 'Naxxar',
//             stateCode: '38',
//             value: 'Naxxar'
//         },
//         {
//             label: 'Paola',
//             stateCode: '39',
//             value: 'Paola'
//         },
//         {
//             label: 'Pembroke',
//             stateCode: '40',
//             value: 'Pembroke'
//         },
//         {
//             label: 'Tal-Pieta',
//             stateCode: '41',
//             value: 'Tal-Pieta'
//         },
//         {
//             label: 'Qala',
//             stateCode: '42',
//             value: 'Qala'
//         },
//         {
//             label: 'Qormi',
//             stateCode: '43',
//             value: 'Qormi'
//         },
//         {
//             label: 'Qrendi',
//             stateCode: '44',
//             value: 'Qrendi'
//         },
//         {
//             label: 'Rabat Gozo',
//             stateCode: '45',
//             value: 'Rabat Gozo'
//         },
//         {
//             label: 'Rabat Malta',
//             stateCode: '46',
//             value: 'Rabat Malta'
//         },
//         {
//             label: 'Safi',
//             stateCode: '47',
//             value: 'Safi'
//         },
//         {
//             label: "Saint Julian's",
//             stateCode: '48',
//             value: "Saint Julian's"
//         },
//         {
//             label: 'Saint John',
//             stateCode: '49',
//             value: 'Saint John'
//         },
//         {
//             label: 'Saint Lawrence',
//             stateCode: '50',
//             value: 'Saint Lawrence'
//         },
//         {
//             label: "Saint Paul's Bay",
//             stateCode: '51',
//             value: "Saint Paul's Bay"
//         },
//         {
//             label: 'Sannat',
//             stateCode: '52',
//             value: 'Sannat'
//         },
//         {
//             label: "Saint Lucia's",
//             stateCode: '53',
//             value: "Saint Lucia's"
//         },
//         {
//             label: 'Santa Venera',
//             stateCode: '54',
//             value: 'Santa Venera'
//         },
//         {
//             label: 'Siggiewi',
//             stateCode: '55',
//             value: 'Siggiewi'
//         },
//         {
//             label: 'Tas-Sliema',
//             stateCode: '56',
//             value: 'Tas-Sliema'
//         },
//         {
//             label: 'Swieqi',
//             stateCode: '57',
//             value: 'Swieqi'
//         },
//         {
//             label: "Ta' Xbiex",
//             stateCode: '58',
//             value: "Ta' Xbiex"
//         },
//         {
//             label: 'Tarxien',
//             stateCode: '59',
//             value: 'Tarxien'
//         },
//         {
//             label: 'Valletta',
//             stateCode: '60',
//             value: 'Valletta'
//         },
//         {
//             label: 'Xaghra',
//             stateCode: '61',
//             value: 'Xaghra'
//         },
//         {
//             label: 'Xewkija',
//             stateCode: '62',
//             value: 'Xewkija'
//         },
//         {
//             label: 'Xghajra',
//             stateCode: '63',
//             value: 'Xghajra'
//         },
//         {
//             label: 'Zabbar',
//             stateCode: '64',
//             value: 'Zabbar'
//         },
//         {
//             label: 'Zebbug Gozo',
//             stateCode: '65',
//             value: 'Zebbug Gozo'
//         },
//         {
//             label: 'Zebbug Malta',
//             stateCode: '66',
//             value: 'Zebbug Malta'
//         },
//         {
//             label: 'Zejtun',
//             stateCode: '67',
//             value: 'Zejtun'
//         },
//         {
//             label: 'Zurrieq',
//             stateCode: '68',
//             value: 'Zurrieq'
//         }
//     ],
//     MNE: [
//         {
//             label: 'Andrijevica',
//             stateCode: '01',
//             value: 'Andrijevica'
//         },
//         {
//             label: 'Bar',
//             stateCode: '02',
//             value: 'Bar'
//         },
//         {
//             label: 'Berane',
//             stateCode: '03',
//             value: 'Berane'
//         },
//         {
//             label: 'Bijelo Polje',
//             stateCode: '04',
//             value: 'Bijelo Polje'
//         },
//         {
//             label: 'Budva',
//             stateCode: '05',
//             value: 'Budva'
//         },
//         {
//             label: 'Cetinje',
//             stateCode: '06',
//             value: 'Cetinje'
//         },
//         {
//             label: 'Danilovgrad',
//             stateCode: '07',
//             value: 'Danilovgrad'
//         },
//         {
//             label: 'Herceg-Novi',
//             stateCode: '08',
//             value: 'Herceg-Novi'
//         },
//         {
//             label: 'Kolasin',
//             stateCode: '09',
//             value: 'Kolasin'
//         },
//         {
//             label: 'Kotor',
//             stateCode: '10',
//             value: 'Kotor'
//         },
//         {
//             label: 'Mojkovac',
//             stateCode: '11',
//             value: 'Mojkovac'
//         },
//         {
//             label: 'Niksic',
//             stateCode: '12',
//             value: 'Niksic'
//         },
//         {
//             label: 'Plav',
//             stateCode: '13',
//             value: 'Plav'
//         },
//         {
//             label: 'Pljevlja',
//             stateCode: '14',
//             value: 'Pljevlja'
//         },
//         {
//             label: 'Pluzine',
//             stateCode: '15',
//             value: 'Pluzine'
//         },
//         {
//             label: 'Podgorica',
//             stateCode: '16',
//             value: 'Podgorica'
//         },
//         {
//             label: 'Rozaje',
//             stateCode: '17',
//             value: 'Rozaje'
//         },
//         {
//             label: 'Savnik',
//             stateCode: '18',
//             value: 'Savnik'
//         },
//         {
//             label: 'Tivat',
//             stateCode: '19',
//             value: 'Tivat'
//         },
//         {
//             label: 'Ulcinj',
//             stateCode: '20',
//             value: 'Ulcinj'
//         },
//         {
//             label: 'Zabljak',
//             stateCode: '21',
//             value: 'Zabljak'
//         },
//         {
//             label: 'Gusinje',
//             stateCode: '22',
//             value: 'Gusinje'
//         },
//         {
//             label: 'Petnjica',
//             stateCode: '23',
//             value: 'Petnjica'
//         }
//     ],
//     MTQ: [
//         {
//             label: 'NULL',
//             stateCode: 'NULL',
//             value: 'NULL'
//         }
//     ],
//     MUS: [
//         {
//             label: 'Agalega Islands',
//             stateCode: 'AG',
//             value: 'Agalega Islands'
//         },
//         {
//             label: 'Black River',
//             stateCode: 'BL',
//             value: 'Black River'
//         },
//         {
//             label: 'St. Brandon Islands',
//             stateCode: 'CC',
//             value: 'St. Brandon Islands'
//         },
//         {
//             label: 'Flacq',
//             stateCode: 'FL',
//             value: 'Flacq'
//         },
//         {
//             label: 'Grand Port',
//             stateCode: 'GP',
//             value: 'Grand Port'
//         },
//         {
//             label: 'Moka',
//             stateCode: 'MO',
//             value: 'Moka'
//         },
//         {
//             label: 'Pamplemousses',
//             stateCode: 'PA',
//             value: 'Pamplemousses'
//         },
//         {
//             label: 'Port Louis',
//             stateCode: 'PL',
//             value: 'Port Louis'
//         },
//         {
//             label: 'Plaines Wilhems',
//             stateCode: 'PW',
//             value: 'Plaines Wilhems'
//         },
//         {
//             label: 'Rodrigues Island',
//             stateCode: 'RO',
//             value: 'Rodrigues Island'
//         },
//         {
//             label: 'Riviere du Rempart',
//             stateCode: 'RR',
//             value: 'Riviere du Rempart'
//         },
//         {
//             label: 'Savanne',
//             stateCode: 'SA',
//             value: 'Savanne'
//         }
//     ],
//     NAM: [
//         {
//             label: 'Zambezi',
//             stateCode: 'CA',
//             value: 'Zambezi'
//         },
//         {
//             label: 'Erongo',
//             stateCode: 'ER',
//             value: 'Erongo'
//         },
//         {
//             label: 'Hardap',
//             stateCode: 'HA',
//             value: 'Hardap'
//         },
//         {
//             label: 'Karas',
//             stateCode: 'KA',
//             value: 'Karas'
//         },
//         {
//             label: 'Kavango East',
//             stateCode: 'KE',
//             value: 'Kavango East'
//         },
//         {
//             label: 'Khomas',
//             stateCode: 'KH',
//             value: 'Khomas'
//         },
//         {
//             label: 'Kunene',
//             stateCode: 'KU',
//             value: 'Kunene'
//         },
//         {
//             label: 'Kavango West',
//             stateCode: 'KW',
//             value: 'Kavango West'
//         },
//         {
//             label: 'Otjozondjupa',
//             stateCode: 'OD',
//             value: 'Otjozondjupa'
//         },
//         {
//             label: 'Omaheke',
//             stateCode: 'OH',
//             value: 'Omaheke'
//         },
//         {
//             label: 'Oshana',
//             stateCode: 'ON',
//             value: 'Oshana'
//         },
//         {
//             label: 'Omusati',
//             stateCode: 'OS',
//             value: 'Omusati'
//         },
//         {
//             label: 'Oshikoto',
//             stateCode: 'OT',
//             value: 'Oshikoto'
//         },
//         {
//             label: 'Ohangwena',
//             stateCode: 'OW',
//             value: 'Ohangwena'
//         }
//     ],
//     NGA: [
//         {
//             label: 'Abia',
//             stateCode: 'AB',
//             value: 'Abia'
//         },
//         {
//             label: 'Adamawa',
//             stateCode: 'AD',
//             value: 'Adamawa'
//         },
//         {
//             label: 'Akwa Ibom',
//             stateCode: 'AK',
//             value: 'Akwa Ibom'
//         },
//         {
//             label: 'Anambra',
//             stateCode: 'AN',
//             value: 'Anambra'
//         },
//         {
//             label: 'Bauchi',
//             stateCode: 'BA',
//             value: 'Bauchi'
//         },
//         {
//             label: 'Benue',
//             stateCode: 'BE',
//             value: 'Benue'
//         },
//         {
//             label: 'Borno',
//             stateCode: 'BO',
//             value: 'Borno'
//         },
//         {
//             label: 'Bayelsa',
//             stateCode: 'BY',
//             value: 'Bayelsa'
//         },
//         {
//             label: 'Cross River',
//             stateCode: 'CR',
//             value: 'Cross River'
//         },
//         {
//             label: 'Delta',
//             stateCode: 'DE',
//             value: 'Delta'
//         },
//         {
//             label: 'Ebonyi',
//             stateCode: 'EB',
//             value: 'Ebonyi'
//         },
//         {
//             label: 'Edo',
//             stateCode: 'ED',
//             value: 'Edo'
//         },
//         {
//             label: 'Ekiti',
//             stateCode: 'EK',
//             value: 'Ekiti'
//         },
//         {
//             label: 'Enugu',
//             stateCode: 'EN',
//             value: 'Enugu'
//         },
//         {
//             label: 'Abuja Federal Capital Territory',
//             stateCode: 'FC',
//             value: 'Abuja Federal Capital Territory'
//         },
//         {
//             label: 'Gombe',
//             stateCode: 'GO',
//             value: 'Gombe'
//         },
//         {
//             label: 'Imo',
//             stateCode: 'IM',
//             value: 'Imo'
//         },
//         {
//             label: 'Jigawa',
//             stateCode: 'JI',
//             value: 'Jigawa'
//         },
//         {
//             label: 'Kaduna',
//             stateCode: 'KD',
//             value: 'Kaduna'
//         },
//         {
//             label: 'Kebbi',
//             stateCode: 'KE',
//             value: 'Kebbi'
//         },
//         {
//             label: 'Kano',
//             stateCode: 'KN',
//             value: 'Kano'
//         },
//         {
//             label: 'Kogi',
//             stateCode: 'KO',
//             value: 'Kogi'
//         },
//         {
//             label: 'Katsina',
//             stateCode: 'KT',
//             value: 'Katsina'
//         },
//         {
//             label: 'Kwara',
//             stateCode: 'KW',
//             value: 'Kwara'
//         },
//         {
//             label: 'Lagos',
//             stateCode: 'LA',
//             value: 'Lagos'
//         },
//         {
//             label: 'Nasarawa',
//             stateCode: 'NA',
//             value: 'Nasarawa'
//         },
//         {
//             label: 'Niger',
//             stateCode: 'NI',
//             value: 'Niger'
//         },
//         {
//             label: 'Ogun',
//             stateCode: 'OG',
//             value: 'Ogun'
//         },
//         {
//             label: 'Ondo',
//             stateCode: 'ON',
//             value: 'Ondo'
//         },
//         {
//             label: 'Osun',
//             stateCode: 'OS',
//             value: 'Osun'
//         },
//         {
//             label: 'Oyo',
//             stateCode: 'OY',
//             value: 'Oyo'
//         },
//         {
//             label: 'Plateau',
//             stateCode: 'PL',
//             value: 'Plateau'
//         },
//         {
//             label: 'Rivers',
//             stateCode: 'RI',
//             value: 'Rivers'
//         },
//         {
//             label: 'Sokoto',
//             stateCode: 'SO',
//             value: 'Sokoto'
//         },
//         {
//             label: 'Taraba',
//             stateCode: 'TA',
//             value: 'Taraba'
//         },
//         {
//             label: 'Yobe',
//             stateCode: 'YO',
//             value: 'Yobe'
//         },
//         {
//             label: 'Zamfara',
//             stateCode: 'ZA',
//             value: 'Zamfara'
//         }
//     ],
//     NLD: [
//         {
//             label: 'Drenthe',
//             stateCode: 'DR',
//             value: 'Drenthe'
//         },
//         {
//             label: 'Flevoland',
//             stateCode: 'FL',
//             value: 'Flevoland'
//         },
//         {
//             label: 'Friesland',
//             stateCode: 'FR',
//             value: 'Friesland'
//         },
//         {
//             label: 'Gelderland',
//             stateCode: 'GE',
//             value: 'Gelderland'
//         },
//         {
//             label: 'Groningen',
//             stateCode: 'GR',
//             value: 'Groningen'
//         },
//         {
//             label: 'Limburg',
//             stateCode: 'LI',
//             value: 'Limburg'
//         },
//         {
//             label: 'North Brabant',
//             stateCode: 'NB',
//             value: 'North Brabant'
//         },
//         {
//             label: 'North Holland',
//             stateCode: 'NH',
//             value: 'North Holland'
//         },
//         {
//             label: 'Overijssel',
//             stateCode: 'OV',
//             value: 'Overijssel'
//         },
//         {
//             label: 'Utrecht',
//             stateCode: 'UT',
//             value: 'Utrecht'
//         },
//         {
//             label: 'Zeeland',
//             stateCode: 'ZE',
//             value: 'Zeeland'
//         },
//         {
//             label: 'South Holland',
//             stateCode: 'ZH',
//             value: 'South Holland'
//         }
//     ],
//     NOR: [
//         {
//             label: 'Oslo',
//             stateCode: '03',
//             value: 'Oslo'
//         },
//         {
//             label: 'Rogaland',
//             stateCode: '11',
//             value: 'Rogaland'
//         },
//         {
//             label: 'More and Romsdal',
//             stateCode: '15',
//             value: 'More and Romsdal'
//         },
//         {
//             label: 'Northland',
//             stateCode: '18',
//             value: 'Northland'
//         },
//         {
//             label: 'Svalbard',
//             stateCode: '21',
//             value: 'Svalbard'
//         },
//         {
//             label: 'Jan Mayen',
//             stateCode: '22',
//             value: 'Jan Mayen'
//         },
//         {
//             label: 'Viken',
//             stateCode: '30',
//             value: 'Viken'
//         },
//         {
//             label: 'Inland',
//             stateCode: '34',
//             value: 'Inland'
//         },
//         {
//             label: 'Vestfold and Telemark',
//             stateCode: '38',
//             value: 'Vestfold and Telemark'
//         },
//         {
//             label: 'Agder',
//             stateCode: '42',
//             value: 'Agder'
//         },
//         {
//             label: 'Westland',
//             stateCode: '46',
//             value: 'Westland'
//         },
//         {
//             label: 'Trondelag',
//             stateCode: '50',
//             value: 'Trondelag'
//         },
//         {
//             label: 'Troms and Finnmark',
//             stateCode: '54',
//             value: 'Troms and Finnmark'
//         }
//     ],
//     PER: [
//         {
//             label: 'Amazonas',
//             stateCode: 'AMA',
//             value: 'Amazonas'
//         },
//         {
//             label: 'Ancash',
//             stateCode: 'ANC',
//             value: 'Ancash'
//         },
//         {
//             label: 'Apurimac',
//             stateCode: 'APU',
//             value: 'Apurimac'
//         },
//         {
//             label: 'Arequipa',
//             stateCode: 'ARE',
//             value: 'Arequipa'
//         },
//         {
//             label: 'Ayacucho',
//             stateCode: 'AYA',
//             value: 'Ayacucho'
//         },
//         {
//             label: 'Cajamarca',
//             stateCode: 'CAJ',
//             value: 'Cajamarca'
//         },
//         {
//             label: 'El Callao',
//             stateCode: 'CAL',
//             value: 'El Callao'
//         },
//         {
//             label: 'Cuzco (Cusco)',
//             stateCode: 'CUS',
//             value: 'Cuzco (Cusco)'
//         },
//         {
//             label: 'Huanuco',
//             stateCode: 'HUC',
//             value: 'Huanuco'
//         },
//         {
//             label: 'Huancavelica',
//             stateCode: 'HUV',
//             value: 'Huancavelica'
//         },
//         {
//             label: 'Ica',
//             stateCode: 'ICA',
//             value: 'Ica'
//         },
//         {
//             label: 'Junin',
//             stateCode: 'JUN',
//             value: 'Junin'
//         },
//         {
//             label: 'La Libertad',
//             stateCode: 'LAL',
//             value: 'La Libertad'
//         },
//         {
//             label: 'Lambayeque',
//             stateCode: 'LAM',
//             value: 'Lambayeque'
//         },
//         {
//             label: 'Lima',
//             stateCode: 'LIM',
//             value: 'Lima'
//         },
//         {
//             label: 'Municipalidad Metropolitana de Lima',
//             stateCode: 'LMA',
//             value: 'Municipalidad Metropolitana de Lima'
//         },
//         {
//             label: 'Loreto',
//             stateCode: 'LOR',
//             value: 'Loreto'
//         },
//         {
//             label: 'Madre de Dios',
//             stateCode: 'MDD',
//             value: 'Madre de Dios'
//         },
//         {
//             label: 'Moquegua',
//             stateCode: 'MOQ',
//             value: 'Moquegua'
//         },
//         {
//             label: 'Pasco',
//             stateCode: 'PAS',
//             value: 'Pasco'
//         },
//         {
//             label: 'Piura',
//             stateCode: 'PIU',
//             value: 'Piura'
//         },
//         {
//             label: 'Puno',
//             stateCode: 'PUN',
//             value: 'Puno'
//         },
//         {
//             label: 'San Martin',
//             stateCode: 'SAM',
//             value: 'San Martin'
//         },
//         {
//             label: 'Tacna',
//             stateCode: 'TAC',
//             value: 'Tacna'
//         },
//         {
//             label: 'Tumbes',
//             stateCode: 'TUM',
//             value: 'Tumbes'
//         },
//         {
//             label: 'Ucayali',
//             stateCode: 'UCA',
//             value: 'Ucayali'
//         }
//     ],
//     POL: [
//         {
//             label: 'Lower Silesia',
//             stateCode: '02',
//             value: 'Lower Silesia'
//         },
//         {
//             label: 'Kuyavia-Pomerania',
//             stateCode: '04',
//             value: 'Kuyavia-Pomerania'
//         },
//         {
//             label: 'Lublin',
//             stateCode: '06',
//             value: 'Lublin'
//         },
//         {
//             label: 'Lubusz',
//             stateCode: '08',
//             value: 'Lubusz'
//         },
//         {
//             label: 'Lodz',
//             stateCode: '10',
//             value: 'Lodz'
//         },
//         {
//             label: 'Lesser Poland',
//             stateCode: '12',
//             value: 'Lesser Poland'
//         },
//         {
//             label: 'Mazovia',
//             stateCode: '14',
//             value: 'Mazovia'
//         },
//         {
//             label: 'Upper Silesia',
//             stateCode: '16',
//             value: 'Upper Silesia'
//         },
//         {
//             label: 'Subcarpathia',
//             stateCode: '18',
//             value: 'Subcarpathia'
//         },
//         {
//             label: 'Podlaskie',
//             stateCode: '20',
//             value: 'Podlaskie'
//         },
//         {
//             label: 'Pomerania',
//             stateCode: '22',
//             value: 'Pomerania'
//         },
//         {
//             label: 'Silesia',
//             stateCode: '24',
//             value: 'Silesia'
//         },
//         {
//             label: 'Holy Cross',
//             stateCode: '26',
//             value: 'Holy Cross'
//         },
//         {
//             label: 'Warmia-Masuria',
//             stateCode: '28',
//             value: 'Warmia-Masuria'
//         },
//         {
//             label: 'Greater Poland',
//             stateCode: '30',
//             value: 'Greater Poland'
//         },
//         {
//             label: 'West Pomerania',
//             stateCode: '32',
//             value: 'West Pomerania'
//         }
//     ],
//     PRT: [
//         {
//             label: 'Aveiro',
//             stateCode: '01',
//             value: 'Aveiro'
//         },
//         {
//             label: 'Beja',
//             stateCode: '02',
//             value: 'Beja'
//         },
//         {
//             label: 'Braga',
//             stateCode: '03',
//             value: 'Braga'
//         },
//         {
//             label: 'Braganca',
//             stateCode: '04',
//             value: 'Braganca'
//         },
//         {
//             label: 'White Castle',
//             stateCode: '05',
//             value: 'White Castle'
//         },
//         {
//             label: 'Coimbra',
//             stateCode: '06',
//             value: 'Coimbra'
//         },
//         {
//             label: 'Evora',
//             stateCode: '07',
//             value: 'Evora'
//         },
//         {
//             label: 'Faro',
//             stateCode: '08',
//             value: 'Faro'
//         },
//         {
//             label: 'Guarda',
//             stateCode: '09',
//             value: 'Guarda'
//         },
//         {
//             label: 'Leiria',
//             stateCode: '10',
//             value: 'Leiria'
//         },
//         {
//             label: 'Lisbon',
//             stateCode: '11',
//             value: 'Lisbon'
//         },
//         {
//             label: 'Portalegre',
//             stateCode: '12',
//             value: 'Portalegre'
//         },
//         {
//             label: 'Porto',
//             stateCode: '13',
//             value: 'Porto'
//         },
//         {
//             label: 'Madeira',
//             stateCode: '30',
//             value: 'Madeira'
//         },
//         {
//             label: 'Azores',
//             stateCode: '20',
//             value: 'Azores'
//         },
//         {
//             label: 'Santarem',
//             stateCode: '14',
//             value: 'Santarem'
//         },
//         {
//             label: 'Setubal',
//             stateCode: '15',
//             value: 'Setubal'
//         },
//         {
//             label: 'Viana do Castelo',
//             stateCode: '16',
//             value: 'Viana do Castelo'
//         },
//         {
//             label: 'Royal Town',
//             stateCode: '17',
//             value: 'Royal Town'
//         },
//         {
//             label: 'Viseu',
//             stateCode: '18',
//             value: 'Viseu'
//         }
//     ],
//     PRY: [
//         {
//             label: 'Concepcion',
//             stateCode: '1',
//             value: 'Concepcion'
//         },
//         {
//             label: 'San Pedro',
//             stateCode: '2',
//             value: 'San Pedro'
//         },
//         {
//             label: 'Cordillera',
//             stateCode: '3',
//             value: 'Cordillera'
//         },
//         {
//             label: 'Guaira',
//             stateCode: '4',
//             value: 'Guaira'
//         },
//         {
//             label: 'Caaguazu',
//             stateCode: '5',
//             value: 'Caaguazu'
//         },
//         {
//             label: 'Caazapa',
//             stateCode: '6',
//             value: 'Caazapa'
//         },
//         {
//             label: 'Itapua',
//             stateCode: '7',
//             value: 'Itapua'
//         },
//         {
//             label: 'Misiones',
//             stateCode: '8',
//             value: 'Misiones'
//         },
//         {
//             label: 'Paraguari',
//             stateCode: '9',
//             value: 'Paraguari'
//         },
//         {
//             label: 'Alto Parana',
//             stateCode: '10',
//             value: 'Alto Parana'
//         },
//         {
//             label: 'Central',
//             stateCode: '11',
//             value: 'Central'
//         },
//         {
//             label: 'Neembucu',
//             stateCode: '12',
//             value: 'Neembucu'
//         },
//         {
//             label: 'Amambay',
//             stateCode: '13',
//             value: 'Amambay'
//         },
//         {
//             label: 'Canindeyu',
//             stateCode: '14',
//             value: 'Canindeyu'
//         },
//         {
//             label: 'Presidente Hayes',
//             stateCode: '15',
//             value: 'Presidente Hayes'
//         },
//         {
//             label: 'Alto Paraguay',
//             stateCode: '16',
//             value: 'Alto Paraguay'
//         },
//         {
//             label: 'Boqueron',
//             stateCode: '19',
//             value: 'Boqueron'
//         },
//         {
//             label: 'Asuncion',
//             stateCode: 'ASU',
//             value: 'Asuncion'
//         }
//     ],
//     QAT: [
//         {
//             label: 'Doha',
//             stateCode: 'DA',
//             value: 'Doha'
//         },
//         {
//             label: 'Khor',
//             stateCode: 'KH',
//             value: 'Khor'
//         },
//         {
//             label: 'North',
//             stateCode: 'MS',
//             value: 'North'
//         },
//         {
//             label: 'Rayyan',
//             stateCode: 'RA',
//             value: 'Rayyan'
//         },
//         {
//             label: 'Shahaniya',
//             stateCode: 'SH',
//             value: 'Shahaniya'
//         },
//         {
//             label: 'Umm Salal',
//             stateCode: 'US',
//             value: 'Umm Salal'
//         },
//         {
//             label: 'Wakra',
//             stateCode: 'WA',
//             value: 'Wakra'
//         },
//         {
//             label: 'Daayen',
//             stateCode: 'ZA',
//             value: 'Daayen'
//         }
//     ],
//     ROU: [
//         {
//             label: 'Alba',
//             stateCode: 'AB',
//             value: 'Alba'
//         },
//         {
//             label: 'Arad',
//             stateCode: 'AR',
//             value: 'Arad'
//         },
//         {
//             label: 'Arges',
//             stateCode: 'AG',
//             value: 'Arges'
//         },
//         {
//             label: 'Bacau',
//             stateCode: 'BC',
//             value: 'Bacau'
//         },
//         {
//             label: 'Bihor',
//             stateCode: 'BH',
//             value: 'Bihor'
//         },
//         {
//             label: 'Bistrita-Nasaud',
//             stateCode: 'BN',
//             value: 'Bistrita-Nasaud'
//         },
//         {
//             label: 'Botosani',
//             stateCode: 'BT',
//             value: 'Botosani'
//         },
//         {
//             label: 'Brasov',
//             stateCode: 'BV',
//             value: 'Brasov'
//         },
//         {
//             label: 'Braila',
//             stateCode: 'BR',
//             value: 'Braila'
//         },
//         {
//             label: 'Bucuresti',
//             stateCode: 'B',
//             value: 'Bucuresti'
//         },
//         {
//             label: 'Buzau',
//             stateCode: 'BZ',
//             value: 'Buzau'
//         },
//         {
//             label: 'Caras-Severin',
//             stateCode: 'CS',
//             value: 'Caras-Severin'
//         },
//         {
//             label: 'Calarasi',
//             stateCode: 'CL',
//             value: 'Calarasi'
//         },
//         {
//             label: 'Cluj',
//             stateCode: 'CJ',
//             value: 'Cluj'
//         },
//         {
//             label: 'Constanta',
//             stateCode: 'CT',
//             value: 'Constanta'
//         },
//         {
//             label: 'Covasna',
//             stateCode: 'CV',
//             value: 'Covasna'
//         },
//         {
//             label: 'Dimbovita',
//             stateCode: 'DB',
//             value: 'Dimbovita'
//         },
//         {
//             label: 'Dolj',
//             stateCode: 'DJ',
//             value: 'Dolj'
//         },
//         {
//             label: 'Galati',
//             stateCode: 'GL',
//             value: 'Galati'
//         },
//         {
//             label: 'Giurgiu',
//             stateCode: 'GR',
//             value: 'Giurgiu'
//         },
//         {
//             label: 'Gorj',
//             stateCode: 'GJ',
//             value: 'Gorj'
//         },
//         {
//             label: 'Harghita',
//             stateCode: 'HR',
//             value: 'Harghita'
//         },
//         {
//             label: 'Hunedoara',
//             stateCode: 'HD',
//             value: 'Hunedoara'
//         },
//         {
//             label: 'Ialomita',
//             stateCode: 'IL',
//             value: 'Ialomita'
//         },
//         {
//             label: 'Iasi',
//             stateCode: 'IS',
//             value: 'Iasi'
//         },
//         {
//             label: 'Ilfov',
//             stateCode: 'IF',
//             value: 'Ilfov'
//         },
//         {
//             label: 'Maramures',
//             stateCode: 'MM',
//             value: 'Maramures'
//         },
//         {
//             label: 'Mehedinti',
//             stateCode: 'MH',
//             value: 'Mehedinti'
//         },
//         {
//             label: 'Mures',
//             stateCode: 'MS',
//             value: 'Mures'
//         },
//         {
//             label: 'Neamt',
//             stateCode: 'NT',
//             value: 'Neamt'
//         },
//         {
//             label: 'Olt',
//             stateCode: 'OT',
//             value: 'Olt'
//         },
//         {
//             label: 'Prahova',
//             stateCode: 'PH',
//             value: 'Prahova'
//         },
//         {
//             label: 'Satu Mare',
//             stateCode: 'SM',
//             value: 'Satu Mare'
//         },
//         {
//             label: 'Salaj',
//             stateCode: 'SJ',
//             value: 'Salaj'
//         },
//         {
//             label: 'Sibiu',
//             stateCode: 'SB',
//             value: 'Sibiu'
//         },
//         {
//             label: 'Suceava',
//             stateCode: 'SV',
//             value: 'Suceava'
//         },
//         {
//             label: 'Teleorman',
//             stateCode: 'TR',
//             value: 'Teleorman'
//         },
//         {
//             label: 'Timis',
//             stateCode: 'TM',
//             value: 'Timis'
//         },
//         {
//             label: 'Tulcea',
//             stateCode: 'TL',
//             value: 'Tulcea'
//         },
//         {
//             label: 'Vaslui',
//             stateCode: 'VS',
//             value: 'Vaslui'
//         },
//         {
//             label: 'Vilcea',
//             stateCode: 'VL',
//             value: 'Vilcea'
//         },
//         {
//             label: 'Vrancea',
//             stateCode: 'VN',
//             value: 'Vrancea'
//         }
//     ],
//     RWA: [
//         {
//             label: 'City of Kigali',
//             stateCode: '01',
//             value: 'City of Kigali'
//         },
//         {
//             label: 'Eastern',
//             stateCode: '02',
//             value: 'Eastern'
//         },
//         {
//             label: 'Northern',
//             stateCode: '03',
//             value: 'Northern'
//         },
//         {
//             label: 'Western',
//             stateCode: '04',
//             value: 'Western'
//         },
//         {
//             label: 'Southern',
//             stateCode: '05',
//             value: 'Southern'
//         }
//     ],
//     SAU: [
//         {
//             label: 'Riyadh',
//             stateCode: '01',
//             value: 'Riyadh'
//         },
//         {
//             label: 'Mecca',
//             stateCode: '02',
//             value: 'Mecca'
//         },
//         {
//             label: 'Medina',
//             stateCode: '03',
//             value: 'Medina'
//         },
//         {
//             label: 'Eastern',
//             stateCode: '04',
//             value: 'Eastern'
//         },
//         {
//             label: 'Qassim',
//             stateCode: '05',
//             value: 'Qassim'
//         },
//         {
//             label: "Ha'il",
//             stateCode: '06',
//             value: "Ha'il"
//         },
//         {
//             label: 'Tabuk',
//             stateCode: '07',
//             value: 'Tabuk'
//         },
//         {
//             label: 'Northern Boarders',
//             stateCode: '08',
//             value: 'Northern Boarders'
//         },
//         {
//             label: 'Jizan',
//             stateCode: '09',
//             value: 'Jizan'
//         },
//         {
//             label: 'Najran',
//             stateCode: '10',
//             value: 'Najran'
//         },
//         {
//             label: 'Baha',
//             stateCode: '11',
//             value: 'Baha'
//         },
//         {
//             label: 'Jouf',
//             stateCode: '12',
//             value: 'Jouf'
//         },
//         {
//             label: 'Asir',
//             stateCode: '14',
//             value: 'Asir'
//         }
//     ],
//     SEN: [
//         {
//             label: 'Diourbel',
//             stateCode: 'DB',
//             value: 'Diourbel'
//         },
//         {
//             label: 'Dakar',
//             stateCode: 'DK',
//             value: 'Dakar'
//         },
//         {
//             label: 'Fatick',
//             stateCode: 'FK',
//             value: 'Fatick'
//         },
//         {
//             label: 'Kaffrine',
//             stateCode: 'KA',
//             value: 'Kaffrine'
//         },
//         {
//             label: 'Kolda',
//             stateCode: 'KD',
//             value: 'Kolda'
//         },
//         {
//             label: 'Kedougou',
//             stateCode: 'KE',
//             value: 'Kedougou'
//         },
//         {
//             label: 'Kaolack',
//             stateCode: 'KL',
//             value: 'Kaolack'
//         },
//         {
//             label: 'Louga',
//             stateCode: 'LG',
//             value: 'Louga'
//         },
//         {
//             label: 'Matam',
//             stateCode: 'MT',
//             value: 'Matam'
//         },
//         {
//             label: 'Sedhiou',
//             stateCode: 'SE',
//             value: 'Sedhiou'
//         },
//         {
//             label: 'Saint-Louis',
//             stateCode: 'SL',
//             value: 'Saint-Louis'
//         },
//         {
//             label: 'Tambacounda',
//             stateCode: 'TC',
//             value: 'Tambacounda'
//         },
//         {
//             label: 'Thies',
//             stateCode: 'TH',
//             value: 'Thies'
//         },
//         {
//             label: 'Ziguinchor',
//             stateCode: 'ZG',
//             value: 'Ziguinchor'
//         }
//     ],
//     SMR: [
//         {
//             label: 'Acquaviva',
//             stateCode: '01',
//             value: 'Acquaviva'
//         },
//         {
//             label: 'Chiesanuova',
//             stateCode: '02',
//             value: 'Chiesanuova'
//         },
//         {
//             label: 'Domagnano',
//             stateCode: '03',
//             value: 'Domagnano'
//         },
//         {
//             label: 'Faetano',
//             stateCode: '04',
//             value: 'Faetano'
//         },
//         {
//             label: 'Fiorentino',
//             stateCode: '05',
//             value: 'Fiorentino'
//         },
//         {
//             label: 'Borgo Maggiore',
//             stateCode: '06',
//             value: 'Borgo Maggiore'
//         },
//         {
//             label: 'San Marino',
//             stateCode: '07',
//             value: 'San Marino'
//         },
//         {
//             label: 'Montegiardino',
//             stateCode: '08',
//             value: 'Montegiardino'
//         },
//         {
//             label: 'Serravalle',
//             stateCode: '09',
//             value: 'Serravalle'
//         }
//     ],
//     SRB: [
//         {
//             label: 'Belgrade',
//             stateCode: '00',
//             value: 'Belgrade'
//         },
//         {
//             label: 'Bor',
//             stateCode: '14',
//             value: 'Bor'
//         },
//         {
//             label: 'Braničevo',
//             stateCode: '11',
//             value: 'Braničevo'
//         },
//         {
//             label: 'Jablanica',
//             stateCode: '23',
//             value: 'Jablanica'
//         },
//         {
//             label: 'South Bačka',
//             stateCode: '06',
//             value: 'South Bačka'
//         },
//         {
//             label: 'South Banat',
//             stateCode: '04',
//             value: 'South Banat'
//         },
//         {
//             label: 'Kolubara',
//             stateCode: '09',
//             value: 'Kolubara'
//         },
//         {
//             label: 'Kosovo',
//             stateCode: '25',
//             value: 'Kosovo'
//         },
//         {
//             label: 'Kosovo-Mitrovica',
//             stateCode: '28',
//             value: 'Kosovo-Mitrovica'
//         },
//         {
//             label: 'Kosovo-Pomoravlje',
//             stateCode: '29',
//             value: 'Kosovo-Pomoravlje'
//         },
//         {
//             label: 'Mačva',
//             stateCode: '08',
//             value: 'Mačva'
//         },
//         {
//             label: 'Moravica',
//             stateCode: '17',
//             value: 'Moravica'
//         },
//         {
//             label: 'Nišava',
//             stateCode: '20',
//             value: 'Nišava'
//         },
//         {
//             label: 'Pčinja',
//             stateCode: '24',
//             value: 'Pčinja'
//         },
//         {
//             label: 'Peć',
//             stateCode: '26',
//             value: 'Peć'
//         },
//         {
//             label: 'Pirot',
//             stateCode: '22',
//             value: 'Pirot'
//         },
//         {
//             label: 'Podunavlje',
//             stateCode: '10',
//             value: 'Podunavlje'
//         },
//         {
//             label: 'Pomoravlje',
//             stateCode: '13',
//             value: 'Pomoravlje'
//         },
//         {
//             label: 'Prizren',
//             stateCode: '27',
//             value: 'Prizren'
//         },
//         {
//             label: 'Rasina',
//             stateCode: '19',
//             value: 'Rasina'
//         },
//         {
//             label: 'Raška',
//             stateCode: '18',
//             value: 'Raška'
//         },
//         {
//             label: 'North Bačka',
//             stateCode: '01',
//             value: 'North Bačka'
//         },
//         {
//             label: 'North Banat',
//             stateCode: '03',
//             value: 'North Banat'
//         },
//         {
//             label: 'Central Banat',
//             stateCode: '02',
//             value: 'Central Banat'
//         },
//         {
//             label: 'Srem',
//             stateCode: '07',
//             value: 'Srem'
//         },
//         {
//             label: 'Šumadija',
//             stateCode: '12',
//             value: 'Šumadija'
//         },
//         {
//             label: 'Toplica',
//             stateCode: '21',
//             value: 'Toplica'
//         },
//         {
//             label: 'Zaječar',
//             stateCode: '15',
//             value: 'Zaječar'
//         },
//         {
//             label: 'West Bačka',
//             stateCode: '05',
//             value: 'West Bačka'
//         },
//         {
//             label: 'Zlatibor',
//             stateCode: '16',
//             value: 'Zlatibor'
//         }
//     ],
//     SVK: [
//         {
//             label: 'Banska Bystrica',
//             stateCode: 'BC',
//             value: 'Banska Bystrica'
//         },
//         {
//             label: 'Bratislava',
//             stateCode: 'BL',
//             value: 'Bratislava'
//         },
//         {
//             label: 'Kosice',
//             stateCode: 'KI',
//             value: 'Kosice'
//         },
//         {
//             label: 'Nitra',
//             stateCode: 'NI',
//             value: 'Nitra'
//         },
//         {
//             label: 'Presov',
//             stateCode: 'PV',
//             value: 'Presov'
//         },
//         {
//             label: 'Trencin',
//             stateCode: 'TC',
//             value: 'Trencin'
//         },
//         {
//             label: 'Trnava',
//             stateCode: 'TA',
//             value: 'Trnava'
//         },
//         {
//             label: 'Zilina',
//             stateCode: 'ZI',
//             value: 'Zilina'
//         }
//     ],
//     SVN: [
//         {
//             label: 'Ajdovscina',
//             stateCode: '01',
//             value: 'Ajdovscina'
//         },
//         {
//             label: 'Beltinci',
//             stateCode: '02',
//             value: 'Beltinci'
//         },
//         {
//             label: 'Bled',
//             stateCode: '03',
//             value: 'Bled'
//         },
//         {
//             label: 'Bohinj',
//             stateCode: '04',
//             value: 'Bohinj'
//         },
//         {
//             label: 'Borovnica',
//             stateCode: '05',
//             value: 'Borovnica'
//         },
//         {
//             label: 'Bovec',
//             stateCode: '06',
//             value: 'Bovec'
//         },
//         {
//             label: 'Brda',
//             stateCode: '07',
//             value: 'Brda'
//         },
//         {
//             label: 'Brezovica',
//             stateCode: '08',
//             value: 'Brezovica'
//         },
//         {
//             label: 'Brezice',
//             stateCode: '09',
//             value: 'Brezice'
//         },
//         {
//             label: 'Tisina',
//             stateCode: '10',
//             value: 'Tisina'
//         },
//         {
//             label: 'Celje',
//             stateCode: '11',
//             value: 'Celje'
//         },
//         {
//             label: 'Cerklje na Gorenjske',
//             stateCode: '12',
//             value: 'Cerklje na Gorenjske'
//         },
//         {
//             label: 'Cerknica',
//             stateCode: '13',
//             value: 'Cerknica'
//         },
//         {
//             label: 'Cerkno',
//             stateCode: '14',
//             value: 'Cerkno'
//         },
//         {
//             label: 'Crensovci',
//             stateCode: '15',
//             value: 'Crensovci'
//         },
//         {
//             label: 'Crna na Koroskem',
//             stateCode: '16',
//             value: 'Crna na Koroskem'
//         },
//         {
//             label: 'Crnomelj',
//             stateCode: '17',
//             value: 'Crnomelj'
//         },
//         {
//             label: 'Destrnik',
//             stateCode: '18',
//             value: 'Destrnik'
//         },
//         {
//             label: 'Divaca',
//             stateCode: '19',
//             value: 'Divaca'
//         },
//         {
//             label: 'Dobrepolje',
//             stateCode: '20',
//             value: 'Dobrepolje'
//         },
//         {
//             label: 'Dobrova-Polhov Gradec',
//             stateCode: '21',
//             value: 'Dobrova-Polhov Gradec'
//         },
//         {
//             label: 'Dol pri Ljubljani',
//             stateCode: '22',
//             value: 'Dol pri Ljubljani'
//         },
//         {
//             label: 'Domzale',
//             stateCode: '23',
//             value: 'Domzale'
//         },
//         {
//             label: 'Dornava',
//             stateCode: '24',
//             value: 'Dornava'
//         },
//         {
//             label: 'Dravograd',
//             stateCode: '25',
//             value: 'Dravograd'
//         },
//         {
//             label: 'Duplek',
//             stateCode: '26',
//             value: 'Duplek'
//         },
//         {
//             label: 'Gorenja vas-Poljane',
//             stateCode: '27',
//             value: 'Gorenja vas-Poljane'
//         },
//         {
//             label: 'Gorisnica',
//             stateCode: '28',
//             value: 'Gorisnica'
//         },
//         {
//             label: 'Gornja Radgona',
//             stateCode: '29',
//             value: 'Gornja Radgona'
//         },
//         {
//             label: 'Gornji Grad',
//             stateCode: '30',
//             value: 'Gornji Grad'
//         },
//         {
//             label: 'Gornji Petrovci',
//             stateCode: '31',
//             value: 'Gornji Petrovci'
//         },
//         {
//             label: 'Grosuplje',
//             stateCode: '32',
//             value: 'Grosuplje'
//         },
//         {
//             label: 'Salovci',
//             stateCode: '33',
//             value: 'Salovci'
//         },
//         {
//             label: 'Hrastnik',
//             stateCode: '34',
//             value: 'Hrastnik'
//         },
//         {
//             label: 'Hrpelje-Kozina',
//             stateCode: '35',
//             value: 'Hrpelje-Kozina'
//         },
//         {
//             label: 'Idrija',
//             stateCode: '36',
//             value: 'Idrija'
//         },
//         {
//             label: 'Ig',
//             stateCode: '37',
//             value: 'Ig'
//         },
//         {
//             label: 'Ilirska Bistrica',
//             stateCode: '38',
//             value: 'Ilirska Bistrica'
//         },
//         {
//             label: 'Ivancna Gorica',
//             stateCode: '39',
//             value: 'Ivancna Gorica'
//         },
//         {
//             label: 'Isola',
//             stateCode: '40',
//             value: 'Isola'
//         },
//         {
//             label: 'Jesenice',
//             stateCode: '41',
//             value: 'Jesenice'
//         },
//         {
//             label: 'Jursinci',
//             stateCode: '42',
//             value: 'Jursinci'
//         },
//         {
//             label: 'Kamnik',
//             stateCode: '43',
//             value: 'Kamnik'
//         },
//         {
//             label: 'Kanal',
//             stateCode: '44',
//             value: 'Kanal'
//         },
//         {
//             label: 'Kidricevo',
//             stateCode: '45',
//             value: 'Kidricevo'
//         },
//         {
//             label: 'Kobarid',
//             stateCode: '46',
//             value: 'Kobarid'
//         },
//         {
//             label: 'Kobilje',
//             stateCode: '47',
//             value: 'Kobilje'
//         },
//         {
//             label: 'Kocevje',
//             stateCode: '48',
//             value: 'Kocevje'
//         },
//         {
//             label: 'Komen',
//             stateCode: '49',
//             value: 'Komen'
//         },
//         {
//             label: 'Capodistria',
//             stateCode: '50',
//             value: 'Capodistria'
//         },
//         {
//             label: 'Kozje',
//             stateCode: '51',
//             value: 'Kozje'
//         },
//         {
//             label: 'Kranj',
//             stateCode: '52',
//             value: 'Kranj'
//         },
//         {
//             label: 'Kranjska Gora',
//             stateCode: '53',
//             value: 'Kranjska Gora'
//         },
//         {
//             label: 'Krsko',
//             stateCode: '54',
//             value: 'Krsko'
//         },
//         {
//             label: 'Kungota',
//             stateCode: '55',
//             value: 'Kungota'
//         },
//         {
//             label: 'Kuzma',
//             stateCode: '56',
//             value: 'Kuzma'
//         },
//         {
//             label: 'Lasko',
//             stateCode: '57',
//             value: 'Lasko'
//         },
//         {
//             label: 'Lenart',
//             stateCode: '58',
//             value: 'Lenart'
//         },
//         {
//             label: 'Lendva',
//             stateCode: '59',
//             value: 'Lendva'
//         },
//         {
//             label: 'Litija',
//             stateCode: '60',
//             value: 'Litija'
//         },
//         {
//             label: 'Ljubljana',
//             stateCode: '61',
//             value: 'Ljubljana'
//         },
//         {
//             label: 'Ljubno',
//             stateCode: '62',
//             value: 'Ljubno'
//         },
//         {
//             label: 'Ljutomer',
//             stateCode: '63',
//             value: 'Ljutomer'
//         },
//         {
//             label: 'Logatec',
//             stateCode: '64',
//             value: 'Logatec'
//         },
//         {
//             label: 'Loska dolina',
//             stateCode: '65',
//             value: 'Loska dolina'
//         },
//         {
//             label: 'Loski Potok',
//             stateCode: '66',
//             value: 'Loski Potok'
//         },
//         {
//             label: 'Luce',
//             stateCode: '67',
//             value: 'Luce'
//         },
//         {
//             label: 'Lukovica',
//             stateCode: '68',
//             value: 'Lukovica'
//         },
//         {
//             label: 'Majsperk',
//             stateCode: '69',
//             value: 'Majsperk'
//         },
//         {
//             label: 'Maribor',
//             stateCode: '70',
//             value: 'Maribor'
//         },
//         {
//             label: 'Medvode',
//             stateCode: '71',
//             value: 'Medvode'
//         },
//         {
//             label: 'Menges',
//             stateCode: '72',
//             value: 'Menges'
//         },
//         {
//             label: 'Metlika',
//             stateCode: '73',
//             value: 'Metlika'
//         },
//         {
//             label: 'Mezica',
//             stateCode: '74',
//             value: 'Mezica'
//         },
//         {
//             label: 'Miren-Kostanjevica',
//             stateCode: '75',
//             value: 'Miren-Kostanjevica'
//         },
//         {
//             label: 'Mislinja',
//             stateCode: '76',
//             value: 'Mislinja'
//         },
//         {
//             label: 'Moravce',
//             stateCode: '77',
//             value: 'Moravce'
//         },
//         {
//             label: 'Moravske Toplice',
//             stateCode: '78',
//             value: 'Moravske Toplice'
//         },
//         {
//             label: 'Mozirje',
//             stateCode: '79',
//             value: 'Mozirje'
//         },
//         {
//             label: 'Murska Sobota',
//             stateCode: '80',
//             value: 'Murska Sobota'
//         },
//         {
//             label: 'Muta',
//             stateCode: '81',
//             value: 'Muta'
//         },
//         {
//             label: 'Naklo',
//             stateCode: '82',
//             value: 'Naklo'
//         },
//         {
//             label: 'Nazarje',
//             stateCode: '83',
//             value: 'Nazarje'
//         },
//         {
//             label: 'Nova Gorica',
//             stateCode: '84',
//             value: 'Nova Gorica'
//         },
//         {
//             label: 'Novo mesto',
//             stateCode: '85',
//             value: 'Novo mesto'
//         },
//         {
//             label: 'Odranci',
//             stateCode: '86',
//             value: 'Odranci'
//         },
//         {
//             label: 'Ormoz',
//             stateCode: '87',
//             value: 'Ormoz'
//         },
//         {
//             label: 'Osilnica',
//             stateCode: '88',
//             value: 'Osilnica'
//         },
//         {
//             label: 'Pesnica',
//             stateCode: '89',
//             value: 'Pesnica'
//         },
//         {
//             label: 'Pirano',
//             stateCode: '90',
//             value: 'Pirano'
//         },
//         {
//             label: 'Pivka',
//             stateCode: '91',
//             value: 'Pivka'
//         },
//         {
//             label: 'Podcetrtek',
//             stateCode: '92',
//             value: 'Podcetrtek'
//         },
//         {
//             label: 'Podvelka',
//             stateCode: '93',
//             value: 'Podvelka'
//         },
//         {
//             label: 'Postojna',
//             stateCode: '94',
//             value: 'Postojna'
//         },
//         {
//             label: 'Preddvor',
//             stateCode: '95',
//             value: 'Preddvor'
//         },
//         {
//             label: 'Ptuj',
//             stateCode: '96',
//             value: 'Ptuj'
//         },
//         {
//             label: 'Puconci',
//             stateCode: '97',
//             value: 'Puconci'
//         },
//         {
//             label: 'Race-Fram',
//             stateCode: '98',
//             value: 'Race-Fram'
//         },
//         {
//             label: 'Radece',
//             stateCode: '99',
//             value: 'Radece'
//         },
//         {
//             label: 'Radenci',
//             stateCode: '100',
//             value: 'Radenci'
//         },
//         {
//             label: 'Radlje ob Dravi',
//             stateCode: '101',
//             value: 'Radlje ob Dravi'
//         },
//         {
//             label: 'Radovljica',
//             stateCode: '102',
//             value: 'Radovljica'
//         },
//         {
//             label: 'Ravne na Koroskem',
//             stateCode: '103',
//             value: 'Ravne na Koroskem'
//         },
//         {
//             label: 'Ribnica',
//             stateCode: '104',
//             value: 'Ribnica'
//         },
//         {
//             label: 'Rogasovci',
//             stateCode: '105',
//             value: 'Rogasovci'
//         },
//         {
//             label: 'Rogaska Slatina',
//             stateCode: '106',
//             value: 'Rogaska Slatina'
//         },
//         {
//             label: 'Rogatec',
//             stateCode: '107',
//             value: 'Rogatec'
//         },
//         {
//             label: 'Ruse',
//             stateCode: '108',
//             value: 'Ruse'
//         },
//         {
//             label: 'Semic',
//             stateCode: '109',
//             value: 'Semic'
//         },
//         {
//             label: 'Sevnica',
//             stateCode: '110',
//             value: 'Sevnica'
//         },
//         {
//             label: 'Sezana',
//             stateCode: '111',
//             value: 'Sezana'
//         },
//         {
//             label: 'Slovenj Gradec',
//             stateCode: '112',
//             value: 'Slovenj Gradec'
//         },
//         {
//             label: 'Slovenska Bistrica',
//             stateCode: '113',
//             value: 'Slovenska Bistrica'
//         },
//         {
//             label: 'Slovenske Konjice',
//             stateCode: '114',
//             value: 'Slovenske Konjice'
//         },
//         {
//             label: 'Starse',
//             stateCode: '115',
//             value: 'Starse'
//         },
//         {
//             label: 'Sveti Jurij',
//             stateCode: '116',
//             value: 'Sveti Jurij'
//         },
//         {
//             label: 'Sencur',
//             stateCode: '117',
//             value: 'Sencur'
//         },
//         {
//             label: 'Sentilj',
//             stateCode: '118',
//             value: 'Sentilj'
//         },
//         {
//             label: 'Sentjernej',
//             stateCode: '119',
//             value: 'Sentjernej'
//         },
//         {
//             label: 'Sentjur pri Celju',
//             stateCode: '120',
//             value: 'Sentjur pri Celju'
//         },
//         {
//             label: 'Skocjan',
//             stateCode: '121',
//             value: 'Skocjan'
//         },
//         {
//             label: 'Skofja Loka',
//             stateCode: '122',
//             value: 'Skofja Loka'
//         },
//         {
//             label: 'Skofljica',
//             stateCode: '123',
//             value: 'Skofljica'
//         },
//         {
//             label: 'Smarje pri Jelsah',
//             stateCode: '124',
//             value: 'Smarje pri Jelsah'
//         },
//         {
//             label: 'Smartno ob Paki',
//             stateCode: '125',
//             value: 'Smartno ob Paki'
//         },
//         {
//             label: 'Sostanj',
//             stateCode: '126',
//             value: 'Sostanj'
//         },
//         {
//             label: 'Store',
//             stateCode: '127',
//             value: 'Store'
//         },
//         {
//             label: 'Tolmin',
//             stateCode: '128',
//             value: 'Tolmin'
//         },
//         {
//             label: 'Trbovlje',
//             stateCode: '129',
//             value: 'Trbovlje'
//         },
//         {
//             label: 'Trebnje',
//             stateCode: '130',
//             value: 'Trebnje'
//         },
//         {
//             label: 'Trzic',
//             stateCode: '131',
//             value: 'Trzic'
//         },
//         {
//             label: 'Turnisce',
//             stateCode: '132',
//             value: 'Turnisce'
//         },
//         {
//             label: 'Velenje',
//             stateCode: '133',
//             value: 'Velenje'
//         },
//         {
//             label: 'Velike Lasce',
//             stateCode: '134',
//             value: 'Velike Lasce'
//         },
//         {
//             label: 'Videm',
//             stateCode: '135',
//             value: 'Videm'
//         },
//         {
//             label: 'Vipava',
//             stateCode: '136',
//             value: 'Vipava'
//         },
//         {
//             label: 'Vitanje',
//             stateCode: '137',
//             value: 'Vitanje'
//         },
//         {
//             label: 'Vodice',
//             stateCode: '138',
//             value: 'Vodice'
//         },
//         {
//             label: 'Vojnik',
//             stateCode: '139',
//             value: 'Vojnik'
//         },
//         {
//             label: 'Vrhnika',
//             stateCode: '140',
//             value: 'Vrhnika'
//         },
//         {
//             label: 'Vuzenica',
//             stateCode: '141',
//             value: 'Vuzenica'
//         },
//         {
//             label: 'Zagorje ob Savi',
//             stateCode: '142',
//             value: 'Zagorje ob Savi'
//         },
//         {
//             label: 'Zavrc',
//             stateCode: '143',
//             value: 'Zavrc'
//         },
//         {
//             label: 'Zrece',
//             stateCode: '144',
//             value: 'Zrece'
//         },
//         {
//             label: 'Zelezniki',
//             stateCode: '146',
//             value: 'Zelezniki'
//         },
//         {
//             label: 'Ziri',
//             stateCode: '147',
//             value: 'Ziri'
//         },
//         {
//             label: 'Benedikt',
//             stateCode: '148',
//             value: 'Benedikt'
//         },
//         {
//             label: 'Bistrica ob Sotli',
//             stateCode: '149',
//             value: 'Bistrica ob Sotli'
//         },
//         {
//             label: 'Bloke',
//             stateCode: '150',
//             value: 'Bloke'
//         },
//         {
//             label: 'Braslovce',
//             stateCode: '151',
//             value: 'Braslovce'
//         },
//         {
//             label: 'Cankova',
//             stateCode: '152',
//             value: 'Cankova'
//         },
//         {
//             label: 'Cerkvenjak',
//             stateCode: '153',
//             value: 'Cerkvenjak'
//         },
//         {
//             label: 'Dobje',
//             stateCode: '154',
//             value: 'Dobje'
//         },
//         {
//             label: 'Dobrna',
//             stateCode: '155',
//             value: 'Dobrna'
//         },
//         {
//             label: 'Dobronak',
//             stateCode: '156',
//             value: 'Dobronak'
//         },
//         {
//             label: 'Dolenjske Toplice',
//             stateCode: '157',
//             value: 'Dolenjske Toplice'
//         },
//         {
//             label: 'Grad',
//             stateCode: '158',
//             value: 'Grad'
//         },
//         {
//             label: 'Hajdina',
//             stateCode: '159',
//             value: 'Hajdina'
//         },
//         {
//             label: 'Hoce-Slivnica',
//             stateCode: '160',
//             value: 'Hoce-Slivnica'
//         },
//         {
//             label: 'Hodos',
//             stateCode: '161',
//             value: 'Hodos'
//         },
//         {
//             label: 'Horjul',
//             stateCode: '162',
//             value: 'Horjul'
//         },
//         {
//             label: 'Jezersko',
//             stateCode: '163',
//             value: 'Jezersko'
//         },
//         {
//             label: 'Komenda',
//             stateCode: '164',
//             value: 'Komenda'
//         },
//         {
//             label: 'Kostel',
//             stateCode: '165',
//             value: 'Kostel'
//         },
//         {
//             label: 'Krizevci',
//             stateCode: '166',
//             value: 'Krizevci'
//         },
//         {
//             label: 'Lovrenc na Pohorju',
//             stateCode: '167',
//             value: 'Lovrenc na Pohorju'
//         },
//         {
//             label: 'Markovci',
//             stateCode: '168',
//             value: 'Markovci'
//         },
//         {
//             label: 'Miklavz na Dravskem polju',
//             stateCode: '169',
//             value: 'Miklavz na Dravskem polju'
//         },
//         {
//             label: 'Mirna Pec',
//             stateCode: '170',
//             value: 'Mirna Pec'
//         },
//         {
//             label: 'Oplotnica',
//             stateCode: '171',
//             value: 'Oplotnica'
//         },
//         {
//             label: 'Podlehnik',
//             stateCode: '172',
//             value: 'Podlehnik'
//         },
//         {
//             label: 'Polzela',
//             stateCode: '173',
//             value: 'Polzela'
//         },
//         {
//             label: 'Prebold',
//             stateCode: '174',
//             value: 'Prebold'
//         },
//         {
//             label: 'Prevalje',
//             stateCode: '175',
//             value: 'Prevalje'
//         },
//         {
//             label: 'Razkrizje',
//             stateCode: '176',
//             value: 'Razkrizje'
//         },
//         {
//             label: 'Ribnica na Pohorju',
//             stateCode: '177',
//             value: 'Ribnica na Pohorju'
//         },
//         {
//             label: 'Selnica ob Dravi',
//             stateCode: '178',
//             value: 'Selnica ob Dravi'
//         },
//         {
//             label: 'Sodrazica',
//             stateCode: '179',
//             value: 'Sodrazica'
//         },
//         {
//             label: 'Solcava',
//             stateCode: '180',
//             value: 'Solcava'
//         },
//         {
//             label: 'Sveta Ana',
//             stateCode: '181',
//             value: 'Sveta Ana'
//         },
//         {
//             label: 'Sveti Andraz v Slovenskih goricah',
//             stateCode: '182',
//             value: 'Sveti Andraz v Slovenskih goricah'
//         },
//         {
//             label: 'Sempeter-Vrtojba',
//             stateCode: '183',
//             value: 'Sempeter-Vrtojba'
//         },
//         {
//             label: 'Tabor',
//             stateCode: '184',
//             value: 'Tabor'
//         },
//         {
//             label: 'Trnovska Vas',
//             stateCode: '185',
//             value: 'Trnovska Vas'
//         },
//         {
//             label: 'Trzin',
//             stateCode: '186',
//             value: 'Trzin'
//         },
//         {
//             label: 'Velika Polana',
//             stateCode: '187',
//             value: 'Velika Polana'
//         },
//         {
//             label: 'Verzej',
//             stateCode: '188',
//             value: 'Verzej'
//         },
//         {
//             label: 'Vransko',
//             stateCode: '189',
//             value: 'Vransko'
//         },
//         {
//             label: 'Zalec',
//             stateCode: '190',
//             value: 'Zalec'
//         },
//         {
//             label: 'Zetale',
//             stateCode: '191',
//             value: 'Zetale'
//         },
//         {
//             label: 'Zirovnica',
//             stateCode: '192',
//             value: 'Zirovnica'
//         },
//         {
//             label: 'Zuzemberk',
//             stateCode: '193',
//             value: 'Zuzemberk'
//         },
//         {
//             label: 'Smartno pri Litiji',
//             stateCode: '194',
//             value: 'Smartno pri Litiji'
//         },
//         {
//             label: 'Apace',
//             stateCode: '195',
//             value: 'Apace'
//         },
//         {
//             label: 'Cirkulane',
//             stateCode: '196',
//             value: 'Cirkulane'
//         },
//         {
//             label: 'Kostanjevica na Krki',
//             stateCode: '197',
//             value: 'Kostanjevica na Krki'
//         },
//         {
//             label: 'Makole',
//             stateCode: '198',
//             value: 'Makole'
//         },
//         {
//             label: 'Mokronog-Trebelno',
//             stateCode: '199',
//             value: 'Mokronog-Trebelno'
//         },
//         {
//             label: 'Poljcane',
//             stateCode: '200',
//             value: 'Poljcane'
//         },
//         {
//             label: 'Rence-Vogrsko',
//             stateCode: '201',
//             value: 'Rence-Vogrsko'
//         },
//         {
//             label: 'Sredisce ob Dravi',
//             stateCode: '202',
//             value: 'Sredisce ob Dravi'
//         },
//         {
//             label: 'Straza',
//             stateCode: '203',
//             value: 'Straza'
//         },
//         {
//             label: 'Sveta Trojica v Slovenskih goricah',
//             stateCode: '204',
//             value: 'Sveta Trojica v Slovenskih goricah'
//         },
//         {
//             label: 'Sveti Tomaz',
//             stateCode: '205',
//             value: 'Sveti Tomaz'
//         },
//         {
//             label: 'Smarjeske Toplice',
//             stateCode: '206',
//             value: 'Smarjeske Toplice'
//         },
//         {
//             label: 'Gorje',
//             stateCode: '207',
//             value: 'Gorje'
//         },
//         {
//             label: 'Log-Dragomer',
//             stateCode: '208',
//             value: 'Log-Dragomer'
//         },
//         {
//             label: 'Recica ob Savinji',
//             stateCode: '209',
//             value: 'Recica ob Savinji'
//         },
//         {
//             label: 'Sveti Jurji v Slovenskih goricah',
//             stateCode: '210',
//             value: 'Sveti Jurji v Slovenskih goricah'
//         },
//         {
//             label: 'Sentrupert',
//             stateCode: '211',
//             value: 'Sentrupert'
//         },
//         {
//             label: 'Mina',
//             stateCode: '212',
//             value: 'Mina'
//         },
//         {
//             label: 'Ancarano',
//             stateCode: '213',
//             value: 'Ancarano'
//         }
//     ],
//     SWE: [
//         {
//             label: 'Blekinge',
//             stateCode: 'K',
//             value: 'Blekinge'
//         },
//         {
//             label: 'Dalarna',
//             stateCode: 'W',
//             value: 'Dalarna'
//         },
//         {
//             label: 'Gotland',
//             stateCode: 'I',
//             value: 'Gotland'
//         },
//         {
//             label: 'Gaevleborg',
//             stateCode: 'X',
//             value: 'Gaevleborg'
//         },
//         {
//             label: 'Halland',
//             stateCode: 'N',
//             value: 'Halland'
//         },
//         {
//             label: 'Jamtland',
//             stateCode: 'Z',
//             value: 'Jamtland'
//         },
//         {
//             label: 'Jonkoping',
//             stateCode: 'F',
//             value: 'Jonkoping'
//         },
//         {
//             label: 'Kalmar',
//             stateCode: 'H',
//             value: 'Kalmar'
//         },
//         {
//             label: 'Kronoberg',
//             stateCode: 'G',
//             value: 'Kronoberg'
//         },
//         {
//             label: 'Norrbotten',
//             stateCode: 'BD',
//             value: 'Norrbotten'
//         },
//         {
//             label: 'Scania',
//             stateCode: 'M',
//             value: 'Scania'
//         },
//         {
//             label: 'Stockholm',
//             stateCode: 'AB',
//             value: 'Stockholm'
//         },
//         {
//             label: 'Soedermanland',
//             stateCode: 'D',
//             value: 'Soedermanland'
//         },
//         {
//             label: 'Uppsala',
//             stateCode: 'C',
//             value: 'Uppsala'
//         },
//         {
//             label: 'Varmland',
//             stateCode: 'S',
//             value: 'Varmland'
//         },
//         {
//             label: 'Vasterbotten',
//             stateCode: 'AC',
//             value: 'Vasterbotten'
//         },
//         {
//             label: 'Western Northland',
//             stateCode: 'Y',
//             value: 'Western Northland'
//         },
//         {
//             label: 'Vaestmanland',
//             stateCode: 'U',
//             value: 'Vaestmanland'
//         },
//         {
//             label: 'Vastra Gotaland',
//             stateCode: 'O',
//             value: 'Vastra Gotaland'
//         },
//         {
//             label: 'Oerbro',
//             stateCode: 'T',
//             value: 'Oerbro'
//         },
//         {
//             label: 'Ostergotland',
//             stateCode: 'E',
//             value: 'Ostergotland'
//         }
//     ],
//     TUN: [
//         {
//             label: 'Tunis',
//             stateCode: '11',
//             value: 'Tunis'
//         },
//         {
//             label: "L'Ariana",
//             stateCode: '12',
//             value: "L'Ariana"
//         },
//         {
//             label: 'Ben Arous',
//             stateCode: '13',
//             value: 'Ben Arous'
//         },
//         {
//             label: 'La Manouba',
//             stateCode: '14',
//             value: 'La Manouba'
//         },
//         {
//             label: 'Nabeul',
//             stateCode: '21',
//             value: 'Nabeul'
//         },
//         {
//             label: 'Zaghouan',
//             stateCode: '22',
//             value: 'Zaghouan'
//         },
//         {
//             label: 'Bizerte',
//             stateCode: '23',
//             value: 'Bizerte'
//         },
//         {
//             label: 'Beja',
//             stateCode: '31',
//             value: 'Beja'
//         },
//         {
//             label: 'Jendouba',
//             stateCode: '32',
//             value: 'Jendouba'
//         },
//         {
//             label: 'Le Kef',
//             stateCode: '33',
//             value: 'Le Kef'
//         },
//         {
//             label: 'Siliana',
//             stateCode: '34',
//             value: 'Siliana'
//         },
//         {
//             label: 'Kairouan',
//             stateCode: '41',
//             value: 'Kairouan'
//         },
//         {
//             label: 'Kasserine',
//             stateCode: '42',
//             value: 'Kasserine'
//         },
//         {
//             label: 'Sidi Bouzid',
//             stateCode: '43',
//             value: 'Sidi Bouzid'
//         },
//         {
//             label: 'Sousse',
//             stateCode: '51',
//             value: 'Sousse'
//         },
//         {
//             label: 'Monastir',
//             stateCode: '52',
//             value: 'Monastir'
//         },
//         {
//             label: 'Mahdia',
//             stateCode: '53',
//             value: 'Mahdia'
//         },
//         {
//             label: 'Sfax',
//             stateCode: '61',
//             value: 'Sfax'
//         },
//         {
//             label: 'Gafsa',
//             stateCode: '71',
//             value: 'Gafsa'
//         },
//         {
//             label: 'Tozeur',
//             stateCode: '72',
//             value: 'Tozeur'
//         },
//         {
//             label: 'Kebili',
//             stateCode: '73',
//             value: 'Kebili'
//         },
//         {
//             label: 'Gabes',
//             stateCode: '81',
//             value: 'Gabes'
//         },
//         {
//             label: 'Medenine',
//             stateCode: '82',
//             value: 'Medenine'
//         },
//         {
//             label: 'Tataouine',
//             stateCode: '83',
//             value: 'Tataouine'
//         }
//     ],
//     TUR: [
//         {
//             label: 'Adana',
//             stateCode: '01',
//             value: 'Adana'
//         },
//         {
//             label: 'Adiyaman',
//             stateCode: '02',
//             value: 'Adiyaman'
//         },
//         {
//             label: 'Afyonkarahisar',
//             stateCode: '03',
//             value: 'Afyonkarahisar'
//         },
//         {
//             label: 'Agri',
//             stateCode: '04',
//             value: 'Agri'
//         },
//         {
//             label: 'Amasya',
//             stateCode: '05',
//             value: 'Amasya'
//         },
//         {
//             label: 'Ankara',
//             stateCode: '06',
//             value: 'Ankara'
//         },
//         {
//             label: 'Antalya',
//             stateCode: '07',
//             value: 'Antalya'
//         },
//         {
//             label: 'Artvin',
//             stateCode: '08',
//             value: 'Artvin'
//         },
//         {
//             label: 'Aydin',
//             stateCode: '09',
//             value: 'Aydin'
//         },
//         {
//             label: 'Balikesir',
//             stateCode: '10',
//             value: 'Balikesir'
//         },
//         {
//             label: 'Bilecik',
//             stateCode: '11',
//             value: 'Bilecik'
//         },
//         {
//             label: 'Bingol',
//             stateCode: '12',
//             value: 'Bingol'
//         },
//         {
//             label: 'Bitlis',
//             stateCode: '13',
//             value: 'Bitlis'
//         },
//         {
//             label: 'Bolu',
//             stateCode: '14',
//             value: 'Bolu'
//         },
//         {
//             label: 'Burdur',
//             stateCode: '15',
//             value: 'Burdur'
//         },
//         {
//             label: 'Bursa',
//             stateCode: '16',
//             value: 'Bursa'
//         },
//         {
//             label: 'Canakkale',
//             stateCode: '17',
//             value: 'Canakkale'
//         },
//         {
//             label: 'Cankiri',
//             stateCode: '18',
//             value: 'Cankiri'
//         },
//         {
//             label: 'Corum',
//             stateCode: '19',
//             value: 'Corum'
//         },
//         {
//             label: 'Denizli',
//             stateCode: '20',
//             value: 'Denizli'
//         },
//         {
//             label: 'Diyarbakir',
//             stateCode: '21',
//             value: 'Diyarbakir'
//         },
//         {
//             label: 'Edirne',
//             stateCode: '22',
//             value: 'Edirne'
//         },
//         {
//             label: 'Elazig',
//             stateCode: '23',
//             value: 'Elazig'
//         },
//         {
//             label: 'Erzincan',
//             stateCode: '24',
//             value: 'Erzincan'
//         },
//         {
//             label: 'Erzurum',
//             stateCode: '25',
//             value: 'Erzurum'
//         },
//         {
//             label: 'Eskisehir',
//             stateCode: '26',
//             value: 'Eskisehir'
//         },
//         {
//             label: 'Gaziantep',
//             stateCode: '27',
//             value: 'Gaziantep'
//         },
//         {
//             label: 'Giresun',
//             stateCode: '28',
//             value: 'Giresun'
//         },
//         {
//             label: 'Gumushane',
//             stateCode: '29',
//             value: 'Gumushane'
//         },
//         {
//             label: 'Hakkari',
//             stateCode: '30',
//             value: 'Hakkari'
//         },
//         {
//             label: 'Hatay',
//             stateCode: '31',
//             value: 'Hatay'
//         },
//         {
//             label: 'Isparta',
//             stateCode: '32',
//             value: 'Isparta'
//         },
//         {
//             label: 'Mersin',
//             stateCode: '33',
//             value: 'Mersin'
//         },
//         {
//             label: 'Istanbul',
//             stateCode: '34',
//             value: 'Istanbul'
//         },
//         {
//             label: 'Izmir',
//             stateCode: '35',
//             value: 'Izmir'
//         },
//         {
//             label: 'Kars',
//             stateCode: '36',
//             value: 'Kars'
//         },
//         {
//             label: 'Kastamonu',
//             stateCode: '37',
//             value: 'Kastamonu'
//         },
//         {
//             label: 'Kayseri',
//             stateCode: '38',
//             value: 'Kayseri'
//         },
//         {
//             label: 'Kirklareli',
//             stateCode: '39',
//             value: 'Kirklareli'
//         },
//         {
//             label: 'Kirsehir',
//             stateCode: '40',
//             value: 'Kirsehir'
//         },
//         {
//             label: 'Kocaeli',
//             stateCode: '41',
//             value: 'Kocaeli'
//         },
//         {
//             label: 'Konya',
//             stateCode: '42',
//             value: 'Konya'
//         },
//         {
//             label: 'Kutahya',
//             stateCode: '43',
//             value: 'Kutahya'
//         },
//         {
//             label: 'Malatya',
//             stateCode: '44',
//             value: 'Malatya'
//         },
//         {
//             label: 'Manisa',
//             stateCode: '45',
//             value: 'Manisa'
//         },
//         {
//             label: 'Kahramanmaras',
//             stateCode: '46',
//             value: 'Kahramanmaras'
//         },
//         {
//             label: 'Mardin',
//             stateCode: '47',
//             value: 'Mardin'
//         },
//         {
//             label: 'Mugla',
//             stateCode: '48',
//             value: 'Mugla'
//         },
//         {
//             label: 'Mus',
//             stateCode: '49',
//             value: 'Mus'
//         },
//         {
//             label: 'Nevsehir',
//             stateCode: '50',
//             value: 'Nevsehir'
//         },
//         {
//             label: 'Nigde',
//             stateCode: '51',
//             value: 'Nigde'
//         },
//         {
//             label: 'Ordu',
//             stateCode: '52',
//             value: 'Ordu'
//         },
//         {
//             label: 'Rize',
//             stateCode: '53',
//             value: 'Rize'
//         },
//         {
//             label: 'Sakarya',
//             stateCode: '54',
//             value: 'Sakarya'
//         },
//         {
//             label: 'Samsun',
//             stateCode: '55',
//             value: 'Samsun'
//         },
//         {
//             label: 'Siirt',
//             stateCode: '56',
//             value: 'Siirt'
//         },
//         {
//             label: 'Sinop',
//             stateCode: '57',
//             value: 'Sinop'
//         },
//         {
//             label: 'Sivas',
//             stateCode: '58',
//             value: 'Sivas'
//         },
//         {
//             label: 'Tekirdag',
//             stateCode: '59',
//             value: 'Tekirdag'
//         },
//         {
//             label: 'Tokat',
//             stateCode: '60',
//             value: 'Tokat'
//         },
//         {
//             label: 'Trabzon',
//             stateCode: '61',
//             value: 'Trabzon'
//         },
//         {
//             label: 'Tunceli',
//             stateCode: '62',
//             value: 'Tunceli'
//         },
//         {
//             label: 'Shanliurfa',
//             stateCode: '63',
//             value: 'Shanliurfa'
//         },
//         {
//             label: 'Usak',
//             stateCode: '64',
//             value: 'Usak'
//         },
//         {
//             label: 'Van',
//             stateCode: '65',
//             value: 'Van'
//         },
//         {
//             label: 'Yozgat',
//             stateCode: '66',
//             value: 'Yozgat'
//         },
//         {
//             label: 'Zonguldak',
//             stateCode: '67',
//             value: 'Zonguldak'
//         },
//         {
//             label: 'Aksaray',
//             stateCode: '68',
//             value: 'Aksaray'
//         },
//         {
//             label: 'Bayburt',
//             stateCode: '69',
//             value: 'Bayburt'
//         },
//         {
//             label: 'Karaman',
//             stateCode: '70',
//             value: 'Karaman'
//         },
//         {
//             label: 'Kirikkale',
//             stateCode: '71',
//             value: 'Kirikkale'
//         },
//         {
//             label: 'Batman',
//             stateCode: '72',
//             value: 'Batman'
//         },
//         {
//             label: 'Sirnak',
//             stateCode: '73',
//             value: 'Sirnak'
//         },
//         {
//             label: 'Bartin',
//             stateCode: '74',
//             value: 'Bartin'
//         },
//         {
//             label: 'Ardahan',
//             stateCode: '75',
//             value: 'Ardahan'
//         },
//         {
//             label: 'Igdir',
//             stateCode: '76',
//             value: 'Igdir'
//         },
//         {
//             label: 'Yalova',
//             stateCode: '77',
//             value: 'Yalova'
//         },
//         {
//             label: 'Karabuk',
//             stateCode: '78',
//             value: 'Karabuk'
//         },
//         {
//             label: 'Kilis',
//             stateCode: '79',
//             value: 'Kilis'
//         },
//         {
//             label: 'Osmaniye',
//             stateCode: '80',
//             value: 'Osmaniye'
//         },
//         {
//             label: 'Duzce',
//             stateCode: '81',
//             value: 'Duzce'
//         }
//     ],
//     UKR: [
//         {
//             label: 'Vinnytsia',
//             stateCode: '05',
//             value: 'Vinnytsia'
//         },
//         {
//             label: 'Volyn',
//             stateCode: '07',
//             value: 'Volyn'
//         },
//         {
//             label: 'Luhansk',
//             stateCode: '09',
//             value: 'Luhansk'
//         },
//         {
//             label: 'Dnipropetrovsk',
//             stateCode: '12',
//             value: 'Dnipropetrovsk'
//         },
//         {
//             label: 'Donetsk',
//             stateCode: '14',
//             value: 'Donetsk'
//         },
//         {
//             label: 'Zhytomyr',
//             stateCode: '18',
//             value: 'Zhytomyr'
//         },
//         {
//             label: 'Transcarpathia',
//             stateCode: '21',
//             value: 'Transcarpathia'
//         },
//         {
//             label: 'Zaporizhzhia',
//             stateCode: '23',
//             value: 'Zaporizhzhia'
//         },
//         {
//             label: 'Ivano-Frankivsk',
//             stateCode: '26',
//             value: 'Ivano-Frankivsk'
//         },
//         {
//             label: 'Kyiv City',
//             stateCode: '30',
//             value: 'Kyiv City'
//         },
//         {
//             label: 'Kyiv',
//             stateCode: '32',
//             value: 'Kyiv'
//         },
//         {
//             label: 'Kirovohrad',
//             stateCode: '35',
//             value: 'Kirovohrad'
//         },
//         {
//             label: 'Sevastopol',
//             stateCode: '40',
//             value: 'Sevastopol'
//         },
//         {
//             label: 'Crimea',
//             stateCode: '43',
//             value: 'Crimea'
//         },
//         {
//             label: 'Lviv',
//             stateCode: '46',
//             value: 'Lviv'
//         },
//         {
//             label: 'Mykolaiv',
//             stateCode: '48',
//             value: 'Mykolaiv'
//         },
//         {
//             label: 'Odesa',
//             stateCode: '51',
//             value: 'Odesa'
//         },
//         {
//             label: 'Poltava',
//             stateCode: '53',
//             value: 'Poltava'
//         },
//         {
//             label: 'Rivne',
//             stateCode: '56',
//             value: 'Rivne'
//         },
//         {
//             label: 'Sumy',
//             stateCode: '59',
//             value: 'Sumy'
//         },
//         {
//             label: 'Ternopil',
//             stateCode: '61',
//             value: 'Ternopil'
//         },
//         {
//             label: 'Kharkiv',
//             stateCode: '63',
//             value: 'Kharkiv'
//         },
//         {
//             label: 'Kherson',
//             stateCode: '65',
//             value: 'Kherson'
//         },
//         {
//             label: 'Khmelnytskyi',
//             stateCode: '68',
//             value: 'Khmelnytskyi'
//         },
//         {
//             label: 'Cherkasy',
//             stateCode: '71',
//             value: 'Cherkasy'
//         },
//         {
//             label: 'Chernihiv',
//             stateCode: '74',
//             value: 'Chernihiv'
//         },
//         {
//             label: 'Chernivtsi',
//             stateCode: '77',
//             value: 'Chernivtsi'
//         }
//     ],
//     ZAF: [
//         {
//             label: 'Eastern Cape',
//             stateCode: 'EC',
//             value: 'Eastern Cape'
//         },
//         {
//             label: 'Free State',
//             stateCode: 'FS',
//             value: 'Free State'
//         },
//         {
//             label: 'Gauteng',
//             stateCode: 'GP',
//             value: 'Gauteng'
//         },
//         {
//             label: 'Kwazulu/Natal',
//             stateCode: 'KZN',
//             value: 'Kwazulu/Natal'
//         },
//         {
//             label: 'Limpopo',
//             stateCode: 'LP',
//             value: 'Limpopo'
//         },
//         {
//             label: 'Mpumalanga',
//             stateCode: 'MP',
//             value: 'Mpumalanga'
//         },
//         {
//             label: 'Northern Cape',
//             stateCode: 'NC',
//             value: 'Northern Cape'
//         },
//         {
//             label: 'Western Cape',
//             stateCode: 'WC',
//             value: 'Western Cape'
//         }
//     ]
// };
